import moment from 'moment';

const URL_POINT = process.env['VUE_APP_API_ENDPOINT'] || 'https://power-api.powerliber.com';
const OSS_POINT = process.env['VUE_APP_OSS_ENDPOINT'] || 'https://bolai-power.oss-cn-hangzhou.aliyuncs.com';


const ADVERTISING_BAN = {
    KAY_MAP: {
        'flag_all': '全部',
        'flag_popup': '弹窗',
        'flag_banner': 'Banner',
        'flag_ali_guide': '支付宝全屏引流',
        'flag_confirm_before_pay': '支付前询问',
        'flag_pay_confirm': '屏蔽支付按钮上方Banner',

        'flag_home': "首页",
        'flag_plug_device': "两轮设备页",
        'flag_plug_device_new': "两轮设备页-新版",
        'flag_plug_pay_confirm': "两轮支付确认页",
        'flag_plug_result': "两轮结果页",
        'flag_plug_order':  "两轮订单页",
    },
    COMMON:   [{ key: 'flag_all', title: "全部"}],
    LOADING:  [{ key: 'flag_ali_guide', title: "支付宝全屏引流"}],
    /* GT_INSUR: [{ key: 'flag_all', title: "屏蔽广告", children: [
        { key: 'flag_popup', title: "屏蔽每日弹窗" },
        { key: 'flag_banner', title: "屏蔽Banner" },
        { key: 'flag_confirm_before_pay', title: "屏蔽支付前询问" },
        { key: 'flag_pay_confirm', title: "屏蔽支付按钮上方Banner" },
    ]}]
    ]}] */

    GT_INSUR: [
        { key: 'flag_part', title: "指定范围", children: [
            { key: 'flag_popup', title: "每日弹窗" },
            { key: 'flag_banner', title: "Banner" },
            { key: 'flag_confirm_before_pay', title: "支付前询问" },
            { key: 'flag_pay_confirm', title: "屏蔽支付按钮上方Banner" },
        ]},
        { key: 'flag_all', title: "全部" },
    ],

    FLOAT_REWARD: [
        { key: 'flag_part', title: "指定范围", children: [
            { key: 'flag_plug_device', title: "两轮充设备选择页" },
            { key: 'flag_plug_result', title: "两轮充充电结果页" },
            { key: 'flag_plug_order',  title: "两轮充订单详情页" },
            { key: 'flag_plug_device_new', title: "两轮充设备选择页-新版" },
            { key: 'flag_plug_pay_confirm', title: "两轮充支付确认页" },
            { key: 'flag_home', title: "首页" },
        ]},
        { key: 'flag_all', title: "全部" },
    ]
}
// prettier-ignore
const Const = {
    COLOR: {
        WHITE: '#FFFFFF',
        PEIMARY: '#006CFF',
        PEIMARY_LIGHT: '#1890FF',

        RED: '#FF3E05',
        GREY: '#A9AFBD',
        BLUE: '#3190FF',
        GREEN: '#31C469',
        ORANGE: '#EA8D4C',

        VIOLET: '#5B8FF9', // 蓝紫色多用于图表

        TC_DISABLED: 'rgba(0, 0, 0, 0.25)',
        TC_SUB: 'rgba(0, 0, 0, 0.45)',
        TC_NORMAL: 'rgba(0, 0, 0, 0.65)',
        TC_HEAD: 'rgba(0, 0, 0, 0.85)',

        CHART_BG_GRAY: '#F0F2F5',
        CHART_Y_LINE: '#D9D9D9',
        CHART_X_LINE: '#777777',
        CHART_TOOL_LINE: '#34383E',
        CHART_TC_SUB: '#8C8C8C',
        CHART_TC_MAIN: '#363D42',
    },
    NET: {
        URL_POINT: URL_POINT,
        URL_POINT_DEV: 'http://api.dev.power.powerliber.com',
        OSS_POINT: OSS_POINT,
        IMG_URL_PREFIX: `${OSS_POINT}/img/`,
        FILE_URL_PREFIX: `${OSS_POINT}/file/`,
        IMG_UPLOAD_END_POINT: `${URL_POINT}/file/img-upload`,
        FILE_UPLOAD_END_POINT: `${URL_POINT}/file/file-upload`,
    },
    // 本地存储
    DATA: {
        KEY_PREFIX: 'bolai.admin.data.',
        KEY_TOKEN: 'token',
        KEY_USER: 'user',
        KEY_LOGIN_TYPE: 'login.type',
        KEY_USER_TYPE: 'user.type',
        KEY_PROJECT: 'project',
        KEY_MODE: 'mode',
        KEY_AUTHORITY_LIST: 'authority.list',
        KEY_ORDER_FIELD: 'field.order',
        KEY_STATION_FIELD: 'field.station',
        KEY_ORDER_LIST_HINT: 'order.list.hint',
        KEY_USER_ORDER_LIST_HINT: 'order.list.user.hint',
        KEY_OPERATOR_CUSTOM: 'operator.custom',
        KEY_WX_PLATFORM_INFO: 'wx_platform_info',
        KEY_TOKEN_EXPIR_TIME: 'token.expiration_time',

        KEY_SERVICE_CHARGE_TIP_FLAG: 'service-charge.tip-flag',
        KEY_SERVICE_CHARGE_VERSION: 'service-charge.version',

        KEY_INSURANCE_TIP_FLAG: 'insurance.tip-flag',

    },
    // 默认时间
    TIME_PICKER_DEFAULT_VALUE: {
        B_TO_B: [moment().seconds(0).minute(0).hour(0), moment().seconds(0).minute(0).hour(0)],
        B_TO_E: [moment().seconds(0).minute(0).hour(0), moment().seconds(59).minute(59).hour(23)],
    },
    SORT: {
        ORG: { // 片区
            DEFAULT: 0,
            USAGE_DESCEND: 1, // 使用率降序
            USAGE_ASCEND: 2, // 使用率升序
            ARPU_DESCEND: 3, // 客单价降序
            ARPU_ASCEND: 4, // 客单价升序
        },
        STATION: { // 充电站
            DEFAULT: 0,
            USAGE_DESCEND: 1, // 使用率降序
            USAGE_ASCEND: 2, // 使用率升序
            ARPU_DESCEND: 3, // 客单价降序
            ARPU_ASCEND: 4, // 客单价升序
        },
        DEVICE: { // 设备
            DEFAULT: 0,
            LAST_ACTIVE_TIME_DESCEND: 1, // 活跃时间降序
            LAST_ACTIVE_TIME_ASCEND: 2, // 活跃时间升序
            USAGE_DESCEND: 3, // 使用率降序
            USAGE_ASCEND: 4, // 使用率升序
            ARPU_DESCEND: 5, // 客单价降序
            ARPU_ASCEND: 6, // 客单价降序
            CREATE_TIME_DESCEND: 7, // 创建时间降序
            CREATE_TIME_ASCEND: 8, // 创建时间升序
        },
        SERVICE_DEVICE: { // 服务费设备
            DEFAULT: 0,
            SERVICE_BEGIN_TIME_DESCEND: 1, // 开始时间降序
            SERVICE_BEGIN_TIME_ASCEND: 2, // 开始时间升序
        },
        SERVICE_STAT: {
            DEFAULT: 0,
            TOTAL_MONEY_DESCEND: 1,  // 累计应缴服务费 降序
            TOTAL_MONEY_ASCEND: 2,   // 累计应缴服务费 升序
            DEAL_MONEY_DESCEND: 3,   // 累计已缴服务费 降序
            DEAL_MONEY_ASCEND: 4,    // 累计已缴服务费 升序
            UN_DEAL_MONEY_DESCEND: 5, // 累计未结服务费 降序
            UN_DEAL_MONEY_ASCEND: 6,  // 累计未结服务费 升序

            MONTH_TOTAL_MONEY_DESCEND: 7, // 本月应缴服务费 降序
            MONTH_TOTAL_MONEY_ASCEND: 8,  // 本月应缴服务费 升序
            MONTH_DEAL_MONEY_DESCEND: 9,  // 本月已缴服务费 降序
            MONTH_DEAL_MONEY_ASCEND: 10,  // 本月已缴服务费 升序
        },
        SERVICE_GROUP: { // 服务费收费分组
            DEFAULT: 0,
            DEVICE_COUNT_DESCEND: 1, // 设备数量 降序
            DEVICE_COUNT_ASCEND: 2,  // 设备数量 升序
        },
        FEEDBACK: { // 服务费收费分组
            DEFAULT: 0,
            CREATE_TIME_ASCEND: 1, // 设备数量 升序
            CREATE_TIME_DESCEND: 2,  // 设备数量 降序
        },
    },

    // 性别
    GENDER: {
        MALE: 1,   // 男
        FEMALE: 2, // 女
    },

    // 用户规则
    USER_RULE: {
        MODE: {
            All: -1, // 全部
            NONE: 0,  // 无规则
            FREE: 1,  // 免费
            DISCOUNT: 2,  // 折扣  服务费+电费
        },
        MODE_MAP: {
            '-1': { value: -1, text: '全部', add_order: 0 },
            // '0': { value: 0, text: '无折扣' },  // 无规则
            '1': { value: 1, text: '免费用户', add_order: 2 },  // 免费
            '2': { value: 2, text: '折扣用户', add_order: 1, add_charge_key: ['plug', 'car', 'car_ykc'] },  // 折扣
        },
        MODE_MARK: {
            HAVE_RULE: [1, 2],
        },
        // 操作日志
        LOG_TYPE: {
            CREATE_USER: 1,   // 添加用户
            UPDATE_RULE: 2,   // 修改规则
            DELETE_USER: 3,   // 删除用户
            WHITE_PANEL_OPEN: 4,  // 白名单开启
            WHITE_PANEL_DELETE: 5,  // 白名单关闭
            WHITE_PANEL_SYNC: 6, //  数据原  同步
        },
        LOG_TYPE_MAP: {
            '1': { value: 1, text: '添加' },  // 添加用户
            '2': { value: 2, text: '修改' },  // 修改规则
            '3': { value: 3, text: '删除' },  // 删除用户
            '4': { value: 4, text: '开启白名单' },
            '5': { value: 5, text: '关闭白名单' },
            '6': { value: 6, text: '开启白名单' },  // 数据原  同步
        },
        LOG_TYPE_MARK: {
            WHITE_PANEL: [4, 5, 6],    // 白名单
            WHITE_PANEL_OPEN: [4, 6],  // 开启白名单
            WHITE_PANEL_CLOSE: [5],    // 关闭白名单
        },

        // 添加方式
        ADD_MODE: {
            ADD: 1, // 添加
            UPLOAD: 2, // 上传
        },
        ADD_MODE_MAP: {
            '1': { text: '单个添加', value: 1, tip_key: '', tip: '' },
            '2': { text: '批量导入', value: 2, tip_key: 'download', tip: '' },
        },
    },

    // 运营产品类型
    CHARGE_KEY: {
        PLUG: ['plug'],   // 两轮充
        CAR: ['car', 'car_ykc'],    // 汽车充
        TANK: ['tank'],   // 充电柜
        CABINET: ['cabinet'], // 换电柜
    },

    // 白名单 or  免费用户
    WHITE_PANEL: {
        USER_TYPE: {
            FREE: 1,   // 免费用户
            WHITE: 2,  // 白名单
        }
    },

    // 黑名单
    BLACK_PANEL: {
        TYPE: {
            USER: 1,  // 用户
            CARD: 2,  // 卡
            OPERATOR: 3, // 运营商
        },
        USER_TYPE: {
            ORG_FREE: 1,    // 小区免费用户
            ORG: 2,         // 小区白名单
            DEVICE: 3,      // 设备白名单
            POSTPAY: 4,     // 先充后付黑名单
            BLACK_POWER: 5,     // 充电黑名单
        }
    },

    // 黑名单、白名单  
    PANEL_ACTION_LIST: {
        TARGET_TYPE: {
            WHITE_PANEL: 300,       // 白名单
            BLACK_PANEL: 400,       // 黑名单
        },
        TARGET_TYPE_MAP: {
            '300': { value: 300, text: '白名单' },
            '400': { value: 400, text: '黑名单' },
        },
        TYPE: {
            CREATE_WHITE_PANEL: 30001,  // 创建
            DELETE_WHITE_PANEL: 30002,  // 删除
            UPDATE_WHITE_PANEL: 30003,  // 修改
        },
        TYPE_MAP: {
            '30001': { value: 30001, text: '新增' },
            '30002': { value: 30002, text: '删除' },
            '30003': { value: 30003, text: '修改' },
        },
        TYPE_MARK: {
            CREATE_DELETE: [30001, 30002],    // 白名单
        },
    },

    // 金额变动类型
    MONEY_CHARGE_TYPE: {
        INCOME: 1, // 收入
        OUTPAY: 2, // 支出
    },
    MONEY_CHARGE_MAP: {
        '1': { value: 1, text: '收入', symbol: '+', oper: '充值', icon: 'i-income', new_icon: 'i-income-new' },
        '2': { value: 2, text: '支出', symbol: '-', oper: '扣减', icon: 'i-expenditure', new_icon: 'i-expenditure-new' },
    },

    // 数据展示格式
    DISPLAY_TEMP: {
        // 分账账户
        SETTLE_ACCOUNT: [
            { value: '', key: 'name', key_ch: '姓名' },
            { value: '', key: 'phone', key_ch: '联系方式' },
            { value: '', key: 'alipay_real_name', key_ch: '支付宝实名' },
            { value: '', key: 'alipay_account_id', key_ch: '支付宝账号' },
            // { value: '', key: 'wx_real_name', key_ch: '微信实名'},
            // { value: '', key: 'wx_open_id',   key_ch: '微信OpenId'},
            { value: '', key: 'bank_card_name', key_ch: '银行卡持有人姓名' },
            { value: '', key: 'bank_card_no', key_ch: '银行卡号' },
            { value: '', key: 'bank_card_account_type', key_ch: '账户类型' },
            // { value: '', key: 'bank_card_inst_name',    key_ch: '银行名称'},
            // { value: '', key: 'bank_card_inst_province', key_ch: '收款银行所在省'},
            // { value: '', key: 'bank_card_inst_city',     key_ch: '收款银行所在市'},
            // { value: '', key: 'bank_card_inst_branch_name', key_ch: '收款银行支行名称'},
            // { value: '', key: 'bank_card_bank_code',        key_ch: '收款银行支行联行号'},
        ],
        // 运营商推送设置
        OPERATOR_REPORT: [
            { value: '', secret: false, key: 'report_strategy', key_ch: '推送策略' },
            { value: '', secret: true, key: 'report_config', key_ch: '推送配置' },
        ],
        // 运营商定制信息
        OPERATOR_CUSTOM: [
            { value: '', key: 'company_name', key_ch: '公司名称' },
            { value: '', key: 'admin_logo', key_ch: '平台LOGO' },
            { value: '', key: 'admin_name', key_ch: '平台名称' },
            { value: '', key: 'app_name', key_ch: 'App平台名称' },
            { value: '', key: 'app_contact', key_ch: '客服联系电话' },
        ],
        // 运营商信息展示定制
        OPERATOR_CUSTOM_NEW: [
            // { value: '', key: 'company_name', key_ch: '公司名称' },
            { value: '', key: 'admin_logo', key_ch: '平台LOGO', type: 'img' },
            { value: '', key: 'admin_name', key_ch: '数据大屏标题' },  // 平台名称
            // { value: '', key: 'app_name', key_ch: 'App平台名称' },
            // { value: '', key: 'app_contact', key_ch: '客服联系电话' },
        ],
        // 运营商定制信息
        OPERATOR_AD: [
            { value: '', key: 'after_wx_h5_pay_redirect_url', key_ch: '微信H5支付后跳转链接' },
            { value: '', key: 'after_ali_h5_pay_redirect_url', key_ch: '支付宝H5支付后跳转链接' },
            { value: '', key: 'after_wx_mini_program_pay_redirect_url', key_ch: '微信小程序支付后跳转链接' },
            { value: '', key: 'after_ali_mini_program_pay_redirect_url', key_ch: '支付宝小程序支付后跳转链接' },
        ],
        // 支付后跳转链接定制
        OPERATOR_AD_NEW: [
            { value: '', key: 'after_wx_h5_pay_redirect_url', key_ch: '微信H5' },
            { value: '', key: 'after_ali_h5_pay_redirect_url', key_ch: '支付宝H5' },
            { value: '', key: 'after_wx_mini_program_pay_redirect_url', key_ch: '微信小程序' },
            { value: '', key: 'after_ali_mini_program_pay_redirect_url', key_ch: '支付宝小程序' },
        ],
        // 运营商独立商户
        INDEPENDENT_PAY: [
            { value: '', secret: false, key_ch: '商户名称', key: 'name', },

            { value: '', secret: false, key_ch: '微信商户号', key: 'wx_mch_id', },
            { value: '', secret: true, key_ch: '微信商户配置', key: ['wx_mch_type', 'flag_wx_independent', 'wx_independent_app_id', 'wx_pay_key', 'wx_cert_path'], },

            { value: '', secret: false, key_ch: '支付宝收款APPID', key: 'alipay_app_id', },
            { value: '', secret: true, key_ch: '支付宝收款配置', key: ['alipay_app_id', 'alipay_private_key', 'alipay_public_key', 'alipay_cert_path', 'alipay_public_cert_path', 'alipay_root_cert_path'], },

            { value: '', secret: false, key_ch: '支付宝打款APPID', parent: 'alipay_transfer_config', key: 'app_id', },
            { value: '', secret: true, key_ch: '支付宝打款配置', parent: 'alipay_transfer_config', key: ['app_id', 'private_key', 'public_key', 'cert_path', 'public_cert_path', 'root_cert_path'], },
        ],
        // 运营商独立商户-微信支付宝独立商户
        INDEPENDENT_PAY_NEW: [
            // { value: '', secret: false, key_ch: '商户名称', key: 'name', },
            { value: '', secret: false, key_ch: '渠道类型', key: 'chanel', },
            { value: '', secret: false, key_ch: '微信商户模式', key: 'flag_wx_independent', },
            { value: '', secret: false, key_ch: '微信商户类型', key: 'wx_mch_type', },

            { value: '', secret: false, key_ch: '微信商户号', key: 'wx_mch_id', },
            { value: '', secret: true, key_ch: '微信商户配置', key: ['wx_mch_type', 'flag_wx_independent', 'wx_independent_app_id', 'wx_pay_key', 'wx_cert_path'], },

            { value: '', secret: false, key_ch: '支付宝收款APPID', key: 'alipay_app_id', },
            { value: '', secret: true, key_ch: '支付宝收款配置', key: ['alipay_app_id', 'alipay_private_key', 'alipay_public_key', 'alipay_cert_path', 'alipay_public_cert_path', 'alipay_root_cert_path'], },

            { value: '', secret: false, key_ch: '支付宝打款APPID', parent: 'alipay_transfer_config', key: 'app_id', },
            { value: '', secret: true, key_ch: '支付宝打款配置', parent: 'alipay_transfer_config', key: ['app_id', 'private_key', 'public_key', 'cert_path', 'public_cert_path', 'root_cert_path'], },
        ],
        // 运营商独立商户-南平农商行
        INDEPENDENT_PAY_NANPING_RURAL_COMMERCIAL_BANK: [
            { value: '', secret: false, key_ch: '渠道类型', key: 'chanel', },
            { value: '', secret: false, key_ch: '独立公众号APPID', key: 'wx_app_id', },
            { value: '', secret: true, key_ch: '微信商户配置', key: ['merchant_id', 'mer_inst_id', 'cert_path', 'cert_password', 'validate_cert'], },
        ],
        // C端定制-基本信息
        CLIENT_BASE: [
            { value: '', key: 'uid', key_ch: 'UID' },
            { value: '', key: 'wx_service_title', key_ch: '首页标题' },
        ],
        // C端定制-微信服务号
        CLIENT_WX_OFFICIAL: [
            { value: '', key: 'wx_service_app_id', key_ch: '服务号AppId' },
            { value: '', key: 'wx_service_app_secret', key_ch: '服务号AppSecret' },
            { value: '', key: 'wx_service_qr_code_path', key_ch: '服务号二维码' },
            { value: '', key: 'wx_service_start_template_id', key_ch: '充电开始通知' },
            { value: '', key: 'wx_service_finish_template_id', key_ch: '充电结束通知' },
            { value: '', key: 'wx_service_order_stop_template_id', key_ch: '车端暂停充电通知' },
            { value: '', key: 'wx_service_order_refund_template_id', key_ch: '订单退款通知' },
            { value: '', key: 'wx_service_close_cabinet_door_template_id', key_ch: '充电柜取出通知' },
            { value: '', key: 'wx_service_insurance_pay_template_id', key_ch: '保单支付通知' },
            { value: '', key: 'wx_service_insurance_refund_template_id', key_ch: '保单退款通知' },
            { value: '', key: 'wx_service_ticket_process_template_id', key_ch: '工单处理通知' },
            { value: '', key: 'flag_wx_service_follow', key_ch: '是否开启强制关注' },
        ],
        CLIENT_WX_OFFICIAL_FILE: [
            { value: '', key: 'wx_service_file_name', key_ch: '验证文件名称' },
            { value: '', key: 'wx_service_file_content', key_ch: '验证文件内容' },
        ],
        // 运营商独立商户-服务号对接定制
        CLIENT_WX_OFFICIAL_NEW: [
            { value: '', key: 'wx_service_title', key_ch: 'H5客户端首页标题文字' },

            { value: '', key: 'wx_service_app_id', key_ch: '服务号AppId' },

            { value: '', key: 'flag_wx_service_follow', key_ch: '是否开启强制关注' },

            { value: '', secret: true, key_ch: '服务号基本参数', key: ['uid', 'wx_service_app_secret', 'wx_service_qr_code_path'], },
            // { value: '', key: 'uid', key_ch: 'UID' },
            // { value: '', key: 'wx_service_app_secret', key_ch: '服务号AppSecret' },
            // { value: '', key: 'wx_service_qr_code_path', key_ch: '服务号二维码' },

            { value: '', secret: true, key_ch: '消息推送配置', key: ['wx_service_start_template_id', 'wx_service_finish_template_id', 'wx_service_order_stop_template_id', 'wx_service_order_refund_template_id', 'wx_service_close_cabinet_door_template_id', 'wx_service_insurance_pay_template_id', 'wx_service_insurance_refund_template_id'], },
            // { value: '', key: 'wx_service_start_template_id', key_ch: '充电开始通知' },
            // { value: '', key: 'wx_service_finish_template_id', key_ch: '充电结束通知' },
            // { value: '', key: 'wx_service_order_stop_template_id', key_ch: '车端暂停充电通知' },
            // { value: '', key: 'wx_service_order_refund_template_id', key_ch: '订单退款通知' },
            // { value: '', key: 'wx_service_close_cabinet_door_template_id', key_ch: '充电柜取出通知' },
            // { value: '', key: 'wx_service_insurance_pay_template_id', key_ch: '保单支付通知' },
            // { value: '', key: 'wx_service_insurance_refund_template_id', key_ch: '保单退款通知' },
           


            // { value: '', secret: true, key_ch: '微信商户配置', key: ['wx_mch_type', 'flag_wx_independent', 'wx_independent_app_id', 'wx_pay_key', 'wx_cert_path'], },
        ],
        CLIENT_WX_OFFICIAL_FILE_NEW: [
            { value: '', secret: true, key_ch: '服务号验证文件', key: ['wx_service_file_name', 'wx_service_file_content'], },
            // { value: '', key: 'wx_service_file_name', key_ch: '验证文件名称' },
            // { value: '', key: 'wx_service_file_content', key_ch: '验证文件内容' },
        ],
        // 运营商独立商户-小程序独立部署定制
        CLIENT_WX_APPLET_NEW: [
            // { value: '', key: 'uid', key_ch: 'UID' },
            { value: '', key: 'wx_mp_home_title', key_ch: '小程序首页标题文字' },
            { value: '', key: 'wx_app_id', key_ch: '小程序AppId' },
            { value: '', key: 'wx_app_secret', key_ch: '小程序AppSecret' },
        ],
        // C端定制-微信小程序
        CLIENT_WX_APPLET: [
            { value: '', key: 'wx_app_id', key_ch: '小程序AppId' },
            { value: '', key: 'wx_app_secret', key_ch: '小程序AppSecret' },
        ],
        SMS_MODEL: [
            { value: '', key: 'sms_region_id', key_ch: '短信区域' },
            { value: '', key: 'sms_app_key', key_ch: '短信AppKey' },
            { value: '', key: 'sms_app_secret', key_ch: '短信AppSecret' },
            { value: '', key: 'sms_sign_name', key_ch: '短信签名' },
            { value: '', key: 'sms_template_id', key_ch: '短信模版ID' },
        ],
        // 验证码短信配置  - 合在一起
        SMS_MODEL_NEW: [
            { value: '', secret: true, key_ch: '验证码短信配置', key: ['sms_region_id', 'sms_app_key', 'sms_app_secret', 'sms_sign_name', 'sms_template_id'], },
            // { value: '', key: 'sms_region_id', key_ch: '短信区域' },
            // { value: '', key: 'sms_app_key', key_ch: '短信AppKey' },
            // { value: '', key: 'sms_app_secret', key_ch: '短信AppSecret' },
            // { value: '', key: 'sms_sign_name', key_ch: '短信签名' },
            // { value: '', key: 'sms_template_id', key_ch: '短信模版ID' },
        ],
        // 权限分配
        AUTH_LIST_TEMP: [
            // keyList  防止其他需要放在一起的key
            // 比如 org-black-panel.view   需要放在片区里面
            { list: [], select: [], key: 'home', name: '总览' },
            { list: [], select: [], key: 'stat', name: '统计' },
            { list: [], select: [], key: 'operator,operator-manage', name: '运营商管理' },
            { list: [], select: [], key: 'org,org-manage,org-black-panel,org-white-panel', name: '片区管理' },
            { list: [], select: [], key: 'station', name: '充电站管理' },
            { list: [], select: [], key: 'device', name: '设备管理' },
            { list: [], select: [], key: 'device_task', name: '设备任务' },
            { list: [], select: [], key: 'order', name: '充电订单管理' },
            { list: [], select: [], key: 'recharge-order', name: '充值订单管理' },
            { list: [], select: [], key: 'clearing-order', name: '结算管理' },
            { list: [], select: [], key: 'statement', name: '对账单管理' },
            { list: [], select: [], key: 'transfer', name: '转账管理' },
            { list: [], select: [], key: 'operator-member', name: '子账号管理' },
            { list: [], select: [], key: 'clearing', name: '分账账号管理' },
            { list: [], select: [], key: 'card', name: '充电卡管理' },
            { list: [], select: [], key: 'virtual_card', name: '虚拟卡管理' },
            { list: [], select: [], key: 'admin', name: '管理员管理' },
            { list: [], select: [], key: 'worker', name: '工人管理' },
            { list: [], select: [], key: 'service', name: '服务费管理' },
            { list: [], select: [], key: 'system-notice', name: '系统消息管理' },
            { list: [], select: [], key: 'pre', name: '预约充电管理' },
            { list: [], select: [], key: 'car-occupy', name: '占位管理' },
            { list: [], select: [], key: 'org-power-direct-config', name: '有序充电管理' },
            { list: [], select: [], key: 'ticket', name: '反馈工单管理' },
            { list: [], select: [], key: 'device-manage', name: '设备运营管理' },
        ],
        // 支付方式饼图
        PAY_WAY_DATA_TEMP: [
            { count: 0, percent: 10, payMethod: 1, item: '微信' },
            { count: 0, percent: 10, payMethod: 2, item: '支付宝' },
            { count: 0, percent: 10, payMethod: 5, item: '白名单' },
            { count: 0, percent: 10, payMethod: 3, item: '两轮实体储值卡', name: '实体充值卡' },
            { count: 0, percent: 10, payMethod: 4, item: '两轮实体包月卡', name: '实体包月卡' },
            { count: 0, percent: 10, payMethod: 6, item: '两轮虚拟储值卡', name: '虚拟充值卡' },
            { count: 0, percent: 10, payMethod: 7, item: '两轮虚拟包月卡', name: '虚拟包月卡' },
            { count: 0, percent: 10, payMethod: 9, item: '汽车实体储值卡', name: '汽车充实体卡' },   // item: '其他'
            { count: 0, percent: 10, payMethod: 10, item: '汽车虚拟储值卡', name: '汽车充虚拟卡' },   // item: '其他'
            // { count: 0, percent: 10, item: '其他', name: '未知' },
        ],
        // 设备详情页 充电订单数统计
        PAY_WAY_DATA_BY_DEVICE_TEMP: [
            // { count: 0, percent: 10, payMethod: 1, item: '微信' },
            // { count: 0, percent: 10, payMethod: 2, item: '支付宝' },
            // { count: 0, percent: 10, payMethod: 5, item: '白名单' },
            // { count: 0, percent: 10, payMethod: 3, item: '两轮实体储值卡', name: '实体充值卡' },
            // { count: 0, percent: 10, payMethod: 4, item: '两轮实体包月卡', name: '实体包月卡' },
            // { count: 0, percent: 10, payMethod: 6, item: '两轮虚拟储值卡', name: '虚拟充值卡' },
            // { count: 0, percent: 10, payMethod: 7, item: '两轮虚拟包月卡', name: '虚拟包月卡' },
            // { count: 0, percent: 10, payMethod: 9, item: '汽车实体储值卡', name: '汽车充实体卡' }, 
            // { count: 0, percent: 10, payMethod: 10, item: '汽车虚拟储值卡', name: '汽车充虚拟卡' }, 
            { count: 0, percent: 10, payMethod: 16, item: '投币', name: '投币' }, 
        ],
    },
    // 运营商独立商户-微信支付宝独立商户
    INDEPENDENT_MERCHANT: {
        // 商户模式
        // 商户模式-一级商户模式，对应的是原来线上的“微信服务商-独立”
        // 商户模式-二级商户模式，对应的是原来线上的“微信服务商-公版”
        MODEL: {
            PUBLIC: 0,  // 公版 
            INDEPENDENT: 1,  // 独立
        },
        MODEL_MAP: {
            '0': { value: 0, text: '二级商户模式' },
            '1': { value: 1, text: '一级商户模式' },
        },
        MODEL_LIST: [
            { value: 1, text: '一级商户模式' },
            { value: 0, text: '二级商户模式' },
        ],
        // 商户类型
        // 商户类型-常规商户，对应的是原来线上的“微信商户类型-常规商户”
        // 商户类型-电商商户，对应的是原来线上的“微信商户类型-电商商户”
        TYPE: {
            ROUTINE: 1,  // 常规商户
            E_COMMERCE:2,  // 电商商户
        },
        TYPE_MAP: {
            '1': { value: 1, text: '常规商户' },
            '2': { value: 2, text: '电商商户' },
        },
        TYPE_LIST: [
            { value: 1, text: '常规商户' },
            { value: 2, text: '电商商户' },
        ],
        WX_OFFICIAL_FOLLOW: {
            NO: 0, // 否
            YES: 1, // 是
        },
        WX_OFFICIAL_FOLLOW_LIST: [
            { value: 0, text: '否' },
            { value: 1, text: '是' },
        ],
    },
    // 运营商定制-支付收单
    PAY_RECEIPT: {
        // 渠道
        CHANNEL: {
            WECHAT_ALIPAY: 0,  // 独立微信支付宝商户
            NANPING_RURAL_COMMERCIAL_BANK: 4,  // 南平农商行
        },
        CHANNEL_LIST: [
            { text: '独立微信支付宝商户', value: 0 },
            { text: '南平农商行', value: 4 },
        ],
        CHANNEL_MAP: {
            "0": { text: '独立微信支付宝商户', value: 0 },
            "4": { text: '南平农商行', value: 4 },
        },
        CHANNEL_MARK: {
            INDEPEN_CHANNEL: [0, 4], // 运营商定制-支付收单里所有可选的支付渠道
        },
    },
    // 验证码短信配置
    SMS_CONFIG: {
        SCENE: {
            ALIYUN: 1, // 阿里云
        },
        SCENE_LIST: [
            { value: 1, text: '阿里云' }
        ],
        SCENE_MAP: {
            '1': { value: 1, text: '阿里云' },
        }
    },


    //  登录/用户 类型
    LOGIN_TYPE: {
        ADMIN: 1,            // 管理员
        OPERATOR: 2,         // 运营商
        CLEARING_ACCOUNT: 3, // 分账账号
        OPERATOR_MEMBER: 4,  // 运营商子账户
        ADMIN_MEMBER: 10,    // 子管理员
    },
    LOGIN_USER_TYPE: {
        1: 'ADMIN',
        10: 'ADMIN_MEMBER',
        2: 'OPERATOR',
        3: 'CLEARING_ACCOUNT',
        4: 'OPERATOR_MEMBER',
    },
    USER_TYPE_MAP: {
        '1': { value: 1, text: 'ADMIN' },
        '10': { value: 10, text: 'ADMIN_MEMBER' },
        '2': { value: 2, text: 'OPERATOR' },
        '3': { value: 3, text: 'CLEARING_ACCOUNT' },
        '4': { value: 4, text: 'OPERATOR_MEMBER' },
    },
    // 运营商 模式
    OPERATOR: {
        // 模式
        MODE: {
            DIRECTSALES: 1, // 直营
            DISTRIBUTOR: 2, // 分销
        },
        MODE_MAP: {
            '1': { value: 1, text: '直营', tip: '购买设备并参与直接运营' },
            '2': { value: 2, text: '分销', tip: '拓展客户并销售设备，不参与运营' },
        },

        /* MODE_LIST: [
            { value: 1, text: '直营', tip: '购买设备并参与直接运营' },
            { value: 2, text: '分销', tip: '拓展客户并销售设备，不参与运营' },
        ],
        MODE_MAP: {
            1: '直营',
            2: '分销',
        }, */


        // 激活码状态
        CDKEY_STATUS_LIST: [
            { value: 0, text: '未激活' },
            { value: 1, text: '已激活' },
        ],
        // 第三方支付渠道
        PAYMENT_CHANNEL_MAP: {
            '1': { value: 1, text: '宝付支付' },
            '2': { value: 2, text: '汇付支付' },
        },
    },
    // 账号状态
    ACCOUNT_STATUS: {
        USEING: 100,     // 启用中
        FORBIDDEN: -100, // 禁用中
    },

    // 渠道
    CHANNEL: {
        WX: 1,
        ALIPAY: 2,
        BANK_CARD: 3,
        BANK_CARD_BF: 4,
    },
    CHANNEL_MAP: {
        '1': { value: 1, text: '微信', icon: 'i-WeChat' },
        '2': { value: 2, text: '支付宝', icon: 'i-Alipay' },
        '3': { value: 3, text: '银行卡-支付宝', icon: 'i-bank_card' },
        '4': { value: 4, text: '银行卡-宝付', icon: 'i-bank_card' },
    },
    _CHANNEL_MAP: {
        '2': { value: 2, text: '支付宝', icon: 'i-Alipay' },
        '3': { value: 3, text: '银行卡-支付宝', icon: 'i-bank_card' },
        '4': { value: 4, text: '银行卡-宝付', icon: 'i-bank_card' },
    },

    // 充电站
    STATION: {
        TYPE: {
            PLUG: 1,
            CAR: 2,
            TANK: 3,
            CABINET: 4,
        },
        TYPE_MAP: {
            '1': { key: 'plug', value: 1, text: '两轮充', label: '两轮充', device_type: [0, 1, 2, 3, 4, 5, 10], category_type: [2, 3, 4, 5, 6, 7, 12]},
            '2': { key: 'car', value: 2, text: '汽车充', label: '汽车充', device_type: [6, 9], category_type: [8, 11]},
            '3': { key: 'tank', value: 3, text: '充电柜', label: '充电柜', device_type: [7], category_type: [9]},
            '4': { key: 'cabinet', value: 4, text: '换电柜', label: '换电柜', device_type: [8], category_type: [10]},
        },
        // 充电站审核状态
        CHECK_STATUS_MAP: {
            '0': { value: 0, text: '初始化' },
            '100': { value: 100, text: '待审核' },
            '100': { value: 200, text: '已通过' },
            '-200': { value: -200, text: '未通过' },
        },

        PARKING_DISCOUNT: {
            PLATFORM: {
                PYUN: 1, // P云+
                BOLINKYUN: 2, // 泊链云
                YUNMENG: 3, // 云盟互联
            },
            PLATFORM_LIST: [
				{ value: 1, key: 'pyun', 	  text: 'P云+' },
				{ value: 2, key: 'bolinkyun', text: '泊链云' },
				{ value: 3, key: 'yunmeng', text: '云盟互联' },
			],
            MITIGATE_TYPE: {
                TIME: 1,  // 时间
                MONEY: 2, // 金额
            },
            MITIGATE_TYPE_LIST: [
				{ value: 1, text: '时长' },
				{ value: 2, text: '金额' },
			],
        }
    },
    // 设备 (插座)
    DEVICE: {
        PORT_NAME: {
            NORMAL: { 1: 'A', 2: 'B', },
            CAR: { 1: '左', 2: '右', },
        },
        // 根据port_index 获取 port_name
        PORT_INDEX_PORT_NAME: {
            PLUG: { 0: 'A', 1: 'B', },
            CAR: { 0: '左', 1: '右', },  // 公版协议汽车充
            SPECIAL_CAR: { 1: '左', 2: '右', },  // 云快充协议汽车充
        },
        PORT_MARK: {
            CAR: [// 汽车充
                '51','52','53','54','55','56','58',
                '1011','1012','1013','1014','1016','1017','1018','1019',
                '1020','1022','1025','1026','1027','1028','1029',
                '1032','1033','1035','1039',
                '1040','1041','1042','1043','1044','1045','1046',
                '1060',
                '1071','1072','1073','1075','1083','1086','1089','1091',
                '9001','9002','9101','1097',


                // 之前代码里未写，但是文档（产品名称，型号，PCBA条码规格定义2024511）里面有
                // 直流
                '1053', '1054', '1055', '1056', '1058', '1067', '1069', '1070',

                // 007项目
                '1062', '1063', '1064', '1065', '1066',
            ],
            SINGLE_CAR: [ // 单枪汽车充
                '51','53','54','55','58','1013','1014','1018','1019',
                '1025','1028','1029','1032','1033','1034', '1091',
                '9001','1097'
            ],
            DOUBLE_CAR_SPECIAL: [ // 双枪汽车充 但 port_index 从1开始
                '9002','9101'
            ],
            DIRECT: [ // 汽车充直流桩
                '1022','1026','1027','1028','1029','1032','1033','1034','1039',
                '1040','1041','1042','1043','1044','1045','1046',
                '1060',
                '1071','1072','1073','1075','1083','1086','1089','1091',
                '9101',



                // 之前代码里未写，但是文档（产品名称，型号，PCBA条码规格定义2024511）里面有
                '1053', '1054', '1055', '1056', '1058', '1067', '1069', '1070',
            ],
            NO_CHECK_CAR: ['58'],// 汽车充不需要插枪检测

            TANK: ['43', '44'], // 充电柜

            CABINET: ['1000', '1001', '1010'],  // 换电柜
            BATTERY: [''], // 换电柜电池

            GATE: ['1024'], // 道闸

            PLUG: [
                // 两轮充
                '11','12','13','14','16','17','20',
                '21','22','23','24','25','26','27','28','29','30',
                '31','32','33','34','35','36','37','38','39','40',
                '41','42','45','46','47','48','49','50','57',
                '61','62','70','71','72','73','74',
                '80','81','85','86','87','88','90',
                '91','92','93','94','95','96','98','99',
                '1002','1003','1004','1005','1006','1007','1008','1009','1015',
                '1030','1031','1036','1037','1038','1047','1048','1049',
                '1050','1051','1052',
                '1074','1076','1077',
                '1082','1087','1088','1090',
                '1094','1096',


                // 之前代码里未写，但是文档（产品名称，型号，PCBA条码规格定义2024511）里面有
                '57', '65',
                '82', '83', '84', '89', 
                '1023', 
                '1057', '1059', '1061', '1068',
                '1200',
                '13','14','16','17',
            ],
        },
        PORT_INDEX: {
            CAR: { // 汽车充
                LEFT: 0,  // 左
                RIGHT: 1,  // 右
            },
        },

        PORT_PRE_STATUS: {
            ALL: 0,  // 全部
            NO: 1,  // 未预约
            YES: 2,  // 已预约
        },
        PORT_PRE_STATUS_MAP: {
            '0': { value: '0', text: '全部' },
            '1': { value: '1', text: '未预约' },
            '2': { value: '2', text: '已预约' },
        },

        PAGE_TYPE: {
            ALL: '',
            OFFLINE: '0',
            ONLINE: '1',
        },

        STATUS: {
            ONLINE: 1,  // 在线
            OFFLINE: 0, // 离线
        },
        STATUS_LIST: [
            { value: '1', text: '在线' },
            { value: '0', text: '离线' },
        ],

        TYPE: {
            GATEWAY: 0,
            INDEPENDENT: 1,   // 独立版 旧
            AEP: 2,
            SIX_WAY: 3,
            TWELVE_WAY: 4,
            TEN_WAY: 5,
            TWENTY_WAY: 10,
            NEW_INDEPENDENT: 11,  //  新独立版   可以理解为21004，包含了独立版、六路机、十二路机、十路机、二十路机、五路机、十六路机

            CAR_AC: 6,
            CAR_DC: 9,
            CLOUD_FAST_AC: 12,
            CLOUD_FAST_DC: 13,

            TANK: 7,

            CABINET: 8,
        },
        TYPE_MAP: { 
            // intact_text 完整名称，用于站点设备类型的展示
            // group_text 组合名称，独立版、六路机、十二路机、十路机、二十路机、五路机、十六路机  名字统一为独立版
            // is_station_edit 站点编辑显示
            // is_device_type  是设备类型
            '0': { 
                value: 0, 
                station_type: 1, 
                text: '组网版', 
                intact_text: '组网版', 
                group_text: '组网版', 
                key: 'plug', 
                is_station_edit: true,
                is_device_type: true,
                order: 1,
            },
            '1': { 
                // 独立版 旧
                value: 1, 
                station_type: 1, 
                text: '独立版', 
                intact_text: '独立版', 
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: false,
                is_device_type: true,
                order: 1,
            },  
            '2': { 
                value: 2, 
                station_type: 1, 
                text: 'NB版',   // AEP版
                intact_text: 'NB版',   // AEP版
                group_text: 'NB版', 
                key: 'plug', 
                is_station_edit: true,
                is_device_type: true,
                order: 1,
            },
            '3': { 
                value: 3, 
                station_type: 1, 
                text: '六路机', 
                intact_text: '六路机',
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: false,
                is_device_type: true,
                order: 1,
            },
            '4': { 
                value: 4, 
                station_type: 1, 
                text: '十二路机', 
                intact_text: '十二路机',
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: false,
                is_device_type: true,
                order: 1,
            },
            '5': { 
                value: 5, 
                station_type: 1, 
                text: '十路机', 
                intact_text: '十路机',
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: false,
                is_device_type: true,
                order: 1,
            },
            '10':{ 
                value: 10,
                station_type: 1, 
                text: '二十路机', 
                intact_text: '二十路机',
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: false,
                is_device_type: true,
                order: 1,
            },
            '11':{ 
                value: 11,
                station_type: 1, 
                text: '独立版', 
                intact_text: '独立版', 
                group_text: '独立版', 
                key: 'plug', 
                is_station_edit: true,
                is_device_type: false,
                order: 1,
            },  // 新独立版   可以理解为21004，包含了独立版、六路机、十二路机、十路机、二十路机、五路机、十六路机

            '6': { 
                value: 6, 
                station_type: 2, 
                text: '汽车交流', 
                intact_text: '汽车交流', 
                group_text: '汽车交流', 
                key: 'car',
                protocol: 0, 
                is_station_edit: true,
                is_device_type: true,
                order: 2,
            },
            '9': { 
                value: 9, 
                station_type: 2, 
                text: '汽车直流', 
                intact_text: '汽车直流', 
                group_text: '汽车直流', 
                key: 'car', 
                protocol: 0, 
                is_station_edit: true,
                is_device_type: true,
                order: 2,
            },
            '12':{ 
                value: 12,
                station_type: 2, 
                text: '汽车交流', 
                intact_text: '云快充汽车交流', 
                group_text: '云快充汽车交流', 
                key: 'car', 
                protocol: 1, 
                auth: 'device-manage.car.ykc',
                is_station_edit: true,
                is_device_type: true,
                order: 2,
            }, // 云快充汽车交流
            '13':{ 
                value: 13,
                station_type: 2, 
                text: '汽车直流', 
                intact_text: '云快充汽车直流', 
                group_text: '云快充汽车直流', 
                key: 'car', 
                protocol: 1, 
                auth: 'device-manage.car.ykc',
                is_station_edit: true,
                is_device_type: true,
                order: 2,
            }, // 云快充汽车直流

            '7': { 
                value: 7, 
                station_type: 3, 
                text: '充电柜', 
                intact_text: '充电柜', 
                group_text: '充电柜', 
                key: 'tank', 
                is_station_edit: true,
                is_device_type: true,
                order: 3,
            },
            '8': { 
                value: 8, 
                station_type: 4, 
                text: '换电柜', 
                intact_text: '换电柜', 
                group_text: '换电柜', 
                key: 'cabinet', 
                is_station_edit: true,
                is_device_type: true,
                order: 4,
            },
        },
        TYPE_MARK: {
            CAR: [6, 9, 12, 13],  // 汽车充
            CAR_AC: [6, 12], // 汽车充交流桩
            CAR_DC: [9, 13], // 汽车充直流桩
        },

        CATEGORY_TYPE: {
            GATEWAY: 1, // 网关
            GATEWAY_PLUG: 2, // 组网版插座

            INDEPENDENT: 3, // 独立版
            AEP: 4, // NB插座 ~ AEP
            SIX_WAY: 5, // 六路机
            TWELVE_WAY: 6, // 十二路机
            TEN_WAY: 7, // 十路机
            TWENTY_WAY: 12, // 二十路机
            FIVE_WAY: 15, // 五路机
            SIXTEEN_WAY: 16, // 十六路机

            CAR_AC: 8, // 汽车交流充
            CAR_DC: 11, // 汽车直流充

            CLOUD_FAST_AC: 13, // 云快充汽车交流
            CLOUD_FAST_DC: 14, // 云快充汽车直流

            TANK: 9, // 充电柜
            CABINET: 10, // 换电柜
        },
        CATEGORY_TYPE_LIST: [
            { value: '1', text: '网关' },
            { value: '2', text: '组网版插座' },
            { value: '3', text: '两路独立版插座' },
            { value: '4', text: 'NB插座' },
            { value: '15',text: '五路机' },
            { value: '5', text: '六路机' },
            { value: '7', text: '十路机' },
            { value: '6', text: '十二路机' },
            { value: '16',text: '十六路机' },
            { value: '12',text: '二十路机' },
            { value: '8', text: '汽车交流充' },
            { value: '11',text: '汽车直流充' },
            { value: '13',text: '云快充汽车交流', auth: 'device-manage.car.ykc' },
            { value: '14',text: '云快充汽车直流', auth: 'device-manage.car.ykc' },
            { value: '9', text: '充电柜' },
            { value: '10',text: '换电柜' },
        ],
        CATEGORY_TYPE_MAP: {
            1: '网关',
            2: '组网版插座',
            3: '独立版插座',
            4: 'NB插座',
            5: '六路机',
            6: '十二路机',
            7: '十路机',
            8: '汽车交流充',
            9: '充电柜',
            10: '换电柜',
            11: '汽车直流充',
            12: '二十路机',
            13: '云快充汽车交流',
            14: '云快充汽车直流',
            15: '五路机',
            16: '十六路机',
        },
        CATEGORY_TYPE_NEW_MAP: {
            "2": { value: '2', text: '组网版', type_list_value: 'plug-2' },
            "3": { value: '3', text: '两路独立版', /** 独立版 */ type_list_value: 'plug-3' },
            "4": { value: '4', text: 'NB插座', type_list_value: 'plug-4' },
            "15": { value: '15', text: '五路机', type_list_value: 'plug-15' },
            "5": { value: '5', text: '六路机', type_list_value: 'plug-5' },
            "7": { value: '7', text: '十路机', type_list_value: 'plug-7' },
            "6": { value: '6', text: '十二路机', type_list_value: 'plug-6' },
            "16": { value: '16', text: '十六路机', type_list_value: 'plug-16' },
            "12": { value: '12',text: '二十路机', type_list_value: 'plug-12' },

            "8": { value: '8', text: '交流充电桩', type_list_value: 'car-8' },
            "11": { value: '11',text: '直流充电桩', type_list_value: 'car-11' },
            "13": { value: '13',text: '云快充交流桩', type_list_value: 'car-13' },
            "14": { value: '14',text: '云快充直流桩', type_list_value: 'car-14' },

            "9": { value: '9', text: '充电柜', type_list_value: 'tank' },
            "10": { value: '10',text: '换电柜', type_list_value: 'cabinet' },
        },
        CATEGORY_TYPE_MARK: {
            CAR: [8, 11, 13, 14],                // 汽车充
            CAR_AC: [8, 13],                     // 汽车充交流桩
            CAR_DC: [11, 14],                     // 汽车充直流桩
            CAR_YKC: [13, 14],                // 云快充汽车充

            PLUG: [1, 2, 3, 4, 5, 6, 7, 12, 15, 16],  // 两轮充
            TANK: [9],                        // 充电柜
            CABINET: [10],                    // 换电柜

            SHOW_MULTIPLE_SET_ROW_SELECTION: [3, 5],      // 显示批量更改参数

            SET_SINGLE_PARAMETER: [6, 7, 12, 15, 16],      // 可以设置单路参数
        },
        // 树形展示数据
        CATEGORY_TYPE_LIST_MAP: [
            {
                title: '两轮充',
                value: 'plug',
                key: 'plug',
                selectable: false,
                children: [
                    { value: 'plug-2', key: 'plug-2', title: '组网版' },
                    { value: 'plug-3', key: 'plug-3', title: '两路独立版' },
                    { value: 'plug-4', key: 'plug-4', title: 'NB版' },
                    { value: 'plug-15', key: 'plug-15', title: '五路机' },
                    { value: 'plug-5', key: 'plug-5', title: '六路机' },
                    { value: 'plug-7', key: 'plug-7', title: '十路机' },
                    { value: 'plug-6', key: 'plug-6', title: '十二路机' },
                    { value: 'plug-16', key: 'plug-16', title: '十六路机' },
                    { value: 'plug-12', key: 'plug-12', title: '二十路机' },
                ],
            },
            {
                title: '汽车充',
                value: 'car',
                key: 'car',
                selectable: false,
                children: [
                    { value: 'car-8', key: 'car-8', title: '交流充电桩' },
                    { value: 'car-11', key: 'car-11', title: '直流充电桩' },
                    { value: 'car-13', key: 'car-13', title: '云快充交流桩' },
                    { value: 'car-14', key: 'car-14', title: '云快充直流桩' },
                ],
            },
            {
                title: '充电柜',
                value: 'tank',
                key: 'tank',
                // children: [],
            },
            {
                title: '换电柜',
                value: 'cabinet',
                key: 'cabinet',
                // children: [],
            },
        ],

        // 接入类型
        SPACE_LIST: [
            { value: '21003', text: '组网版', key: 'plug', category_type_list: [2] },
            { value: '21004', text: '独立版', key: 'plug', category_type_list: [3, 5, 6, 7, 12, 15, 16] },
            { value: '21007', text: 'NB版', key: 'plug', category_type_list: [4] },
            { value: '21008', text: '交流桩', key: 'car', category_type_list: [8] },
            { value: '21009', text: '充电柜', key: 'tank', category_type_list: [9] },
            { value: '21010', text: '换电柜', key: 'cabinet', category_type_list: [10] },
            { value: '21012',text: '直流桩', key: 'car', category_type_list: [11] },
            { value: '21016', text: '云快充汽车桩', key: 'car', category_type_list: [13, 14] },
        ],

        // 设备刷蓝 - 支付宝
        ALIPAY_SHUALAN_TYPE_MAP: {
            '0':  { value: 0, text: '无刷蓝', isSelect: false,table_text: '-' },
            '1':  { value: 1, text: '轻模式', isSelect: true, table_text: '轻模式' },
            '2':  { value: 2, text: '重模式', isSelect: true, table_text: '重模式' },
        },
        // 设备刷蓝 - 支付宝 - 推送状态
        ALIPAY_SHUALAN_PUSH_STATUS_MAP: {
            '0':  { value: 0, text: '未开启' },
            '1':  { value: 1, text: '已开启' },
        },

        SOCKET_TYPE: {
            ALL: 0,         // 全部设备
            BRUSH_BLUE: 1,  // 刷蓝设备
        },

        SPACE_MAP: {
            '21003': { value: 21003, text: '两轮充组网版' },
            '21004': { value: 21004, text: '两轮充（独立版、六路机、十路机、十二路机、二十路机）' },
            '21007': { value: 21007, text: '两轮充NB版' },
            '21008': { value: 21008, text: '汽车充交流桩' },
            '21009': { value: 21009, text: '充电柜' },
            '21010': { value: 21010, text: '换电柜' },
            // '21011': { value: 21011, text: '汽车充直流桩' },
            '21012': { value: 21012, text: '汽车充直流桩' },
            '21016': { value: 21016, text: '汽车充单枪不带屏（能通）' }, // 所有云快充设备
        },
    },
    DEVICE_TASK: {
        TYPE: {}, // 和充电站类型保持一致
        // 新增参数任务最大功率 包含产品类型
        POWER_TYPE: {
            PLUG: 1,
            CAR: 2,
            TANK: 3,
            CABINET: 4,
            PLUGTEN: 5,
            PLUGTWELVE: 6,
            PLUGOTHER: 7,
            PLUGTWENTY: 8,
            PLUGFIVE: 9,   // 五路机
            PLUGSIXTEEN: 10,  // 十六路机 
        },
        TYPE_MAP: {
            '1': { value: 1, text: '两轮充', label: '两轮充' },
            // '2': {value: 2, text: '汽车充', label: '汽车充'},
            '3': { value: 3, text: '充电柜', label: '充电柜' },
            // '5': {value: 4, text: '换电柜', label: '换电柜'},
        },
        POWER_TYPE_MAP: {
            '1': { value: 1, text: '两轮充', label: '两轮充', category_type: [2, 3, 4, 5, 6, 7], station_type: [0, 1, 2, 3, 4, 5, 11] },
            '3': { value: 3, text: '充电柜', label: '充电柜', category_type: [9], station_type: [7] },
            '9': { value: 9, text: '两轮充-五路机', label: '两轮充-五路机', category_type: [15], station_type: [14, 11] },
            '5': { value: 5, text: '两轮充-十路机', label: '两轮充-十路机', category_type: [7], station_type: [5, 11] },
            '6': { value: 6, text: '两轮充-十二路机', label: '两轮充-十二路机', category_type: [6], station_type: [4, 11] },
            '10': { value: 10, text: '两轮充-十六路机', label: '两轮充-十六路机', category_type: [16], station_type: [15, 11] },
            '8': { value: 8, text: '两轮充-二十路机', label: '两轮充-二十路机', category_type: [12], station_type: [10, 11] },
            '7': { value: 7, text: '两轮充-其他', label: '两轮充-其他', category_type: [2, 3, 4, 5], station_type: [0, 1, 2, 3, 11] },
        },
        // 树形展示数据
        NEW_TYPE_MAP: [
            {
                title: '两轮充',
                key: '1',
                children: [
                    {
                        title: '组网版/独立版/AEP/六路机',
                        key: '7',
                    },
                    {
                        title: '五路机',
                        key: '9',
                        children: [
                            {
                                title: '充电参数',
                                key: '9-a',
                            },
                            {
                                title: '最大功率',
                                key: '9-b',
                            },
                        ]
                    },
                    {
                        title: '十路机',
                        key: '5',
                        children: [
                            {
                                title: '充电参数',
                                key: '5-a',
                            },
                            {
                                title: '最大功率',
                                key: '5-b',
                            },
                        ]
                    },
                    {
                        title: '十二路机',
                        key: '6',
                        children: [
                            {
                                title: '充电参数',
                                key: '6-a',
                            },
                            {
                                title: '最大功率',
                                key: '6-b',
                            },
                        ]
                    },
                    {
                        title: '十六路机',
                        key: '10',
                        children: [
                            {
                                title: '充电参数',
                                key: '10-a',
                            },
                            {
                                title: '最大功率',
                                key: '10-b',
                            },
                        ]
                    },
                    {
                        title: '二十路机',
                        key: '8',
                        children: [
                            {
                                title: '充电参数',
                                key: '8-a',
                            },
                            {
                                title: '最大功率',
                                key: '8-b',
                            },
                        ]
                    },
                ],
            },
            {
                title: '充电柜',
                key: '3',
            },
        ],
        PARAMS_LIST: [
            { value: '', flag: false, text: '充满功率阈值', min: 0.1, max: 50, precision: 1, defult: 10, divisor: 1, unit: '瓦', key: 'charge_full_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入浮充阶段。' },
            { value: '', flag: false, text: '充满延迟时间', min: 1, max: 180, precision: 1, defult: 120, divisor: 60, unit: '分钟', key: 'charge_full_time_threshold', desc: '设备进入浮充阶段后，继续充电的时间。' },
            { value: '', flag: false, text: '空载功率阈值', min: 0.1, max: 5, precision: 1, defult: 0.8, divisor: 1, unit: '瓦', key: 'no_load_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入空载的阶段，即没有充电器接入的状态。' },
            { value: '', flag: false, text: '空载延迟时间', min: 2, max: 1800, precision: 0, defult: 45, divisor: 1, unit: '秒', key: 'no_load_time_threshold', desc: '设备进入空载后，继续充电的时间。该计时时间内，若充电功率大于空载阈值，则中断该计时。' },
            { value: '', flag: false, text: '最大充电时间', min: 1, max: 900, precision: 0, defult: 600, divisor: 1, unit: '分钟', key: 'max_time', desc: '设备支持的最长充电时间，充电时长达到该参数后，停止充电。' },
        ],
        PARAMS_NEW_LIST: [
            { value: '', flag: false, text: '充满功率阈值', min: 0.1, max: 50, precision: 1, defult: 10, divisor: 1, unit: '瓦', key: 'charge_full_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入浮充阶段。' },
            { value: '', flag: false, text: '充满延迟时间', min: 1, max: 180, precision: 1, defult: 120, divisor: 60, unit: '分钟', key: 'charge_full_time_threshold', desc: '设备进入浮充阶段后，继续充电的时间。' },
            { value: '', flag: false, text: '空载功率阈值', min: 0.1, max: 5, precision: 1, defult: 0.8, divisor: 1, unit: '瓦', key: 'no_load_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入空载的阶段，即没有充电器接入的状态。' },
            { value: '', flag: false, text: '空载延迟时间', min: 2, max: 1800, precision: 0, defult: 45, divisor: 1, unit: '秒', key: 'no_load_time_threshold', desc: '设备进入空载后，继续充电的时间。该计时时间内，若充电功率大于空载阈值，则中断该计时。' },
            { value: '', flag: false, text: '最大充电时间', min: 1, max: 900, precision: 0, defult: 600, divisor: 1, unit: '分钟', key: 'max_time', desc: '设备支持的最长充电时间，充电时长达到该参数后，停止充电。' },
            { value: '', flag: false, text: '最大充电功率', min: 1, max: 3500, precision: 0, defult: undefined, divisor: 1, unit: '瓦', key: 'max_power_list', desc: '设备支持的最大充电功率，超出后设备进行过载保护。不同类型的设备允许最大功率不同。' },
        ],
        PARAMS_POWER_LIST: [
            { value: '', flag: false, text: '充满功率阈值', min: 0.1, max: 50, precision: 1, defult: 10, divisor: 1, unit: '瓦', key: 'charge_full_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入浮充阶段。' },
            { value: '', flag: false, text: '充满延迟时间', min: 1, max: 180, precision: 1, defult: 120, divisor: 60, unit: '分钟', key: 'charge_full_time_threshold', desc: '设备进入浮充阶段后，继续充电的时间。' },
            { value: '', flag: false, text: '空载功率阈值', min: 0.1, max: 5, precision: 1, defult: 0.8, divisor: 1, unit: '瓦', key: 'no_load_power_threshold', desc: '充电功率低于该参数时，设备判定充电进入空载的阶段，即没有充电器接入的状态。' },
            { value: '', flag: false, text: '空载延迟时间', min: 2, max: 1800, precision: 0, defult: 45, divisor: 1, unit: '秒', key: 'no_load_time_threshold', desc: '设备进入空载后，继续充电的时间。该计时时间内，若充电功率大于空载阈值，则中断该计时。' },
            { value: '', flag: false, text: '最大充电时间', min: 1, max: 900, precision: 0, defult: 600, divisor: 1, unit: '分钟', key: 'max_time', desc: '设备支持的最长充电时间，充电时长达到该参数后，停止充电。' },
            { value: '', flag: false, text: '最大充电功率', min: 1, max: 3500, precision: 0, defult: 600, divisor: 1, unit: '瓦', key: 'max_power', desc: '设备支持的最大充电功率，超出后设备进行过载保护。不同类型的设备允许最大功率不同。' },
        ],

        // 自定义最大充电电流
        PARAMS_MAX_CHARGE_CURRENT_MAP: {
            '8': { value: 8, text: '8A' },
            '10': { value: 10, text: '10A' },
            '13': { value: 13, text: '13A' },
            '16': { value: 16, text: '16A' },
            '32': { value: 32, text: '32A' },
        },

        // 两轮充、充电柜 最大功率 表格
        DEVICE_MAX_POWER: [
            {
                key: '1',
                product: '两轮充',
                class: '独立版',
                device_type: '四代3500W4G独立版',
                max_power: '3500'
            },
            {
                key: '2',
                product: '两轮充',
                class: '独立版',
                device_type: '三代4G独立版大功率插座',
                max_power: '2200'
            },
            {
                key: '3',
                product: '两轮充',
                class: '独立版',
                device_type: '二代2G独立版插座',
                max_power: '800'
            },
            {
                key: '4',
                product: '两轮充',
                class: '组网版',
                device_type: '四代3500W组网插座',
                max_power: '3500'
            },
            {
                key: '5',
                product: '两轮充',
                class: '组网版',
                device_type: '四代3500W插座网关',
                max_power: '3500'
            },
            {
                key: '6',
                product: '两轮充',
                class: '组网版',
                device_type: '三代组网大功率插座',
                max_power: '2200'
            },
            {
                key: '7',
                product: '两轮充',
                class: '组网版',
                device_type: '三代网关插座',
                max_power: '2200'
            },
            {
                key: '8',
                product: '两轮充',
                class: '组网版',
                device_type: '三代组网普通功率插座',
                max_power: '800'
            },
            {
                key: '9',
                product: '两轮充',
                class: '组网版',
                device_type: '三代蓝牙插座网关',
                max_power: '2200'
            },
            {
                key: '10',
                product: '两轮充',
                class: '组网版',
                device_type: '三代2.4G插座网关',
                max_power: '2200'
            },
            {
                key: '11',
                product: '两轮充',
                class: '组网版',
                device_type: '两路智能充电桩(无线)2200W',
                max_power: '2200'
            },
            {
                key: '12',
                product: '两轮充',
                class: '组网版',
                device_type: '两路智能充电桩(无线)',
                max_power: '800'
            },
            {
                key: '13',
                product: '两轮充',
                class: '组网版',
                device_type: '二代组网大功率单路插座',
                max_power: '3500'
            },
            {
                key: '14',
                product: '两轮充',
                class: '组网版',
                device_type: '二代组网插座',
                max_power: '800'
            },
            {
                key: '15',
                product: '两轮充',
                class: 'NB插座',
                device_type: '三代5G-NB大功率插座',
                max_power: '2200'
            },
            {
                key: '16',
                product: '两轮充',
                class: '六路机',
                device_type: '六路机',
                max_power: '1500'
            },
            {
                key: '17',
                product: '充电柜',
                class: '充电柜',
                device_type: '充电柜',
                max_power: '800'
            },
        ],

        STATUS: {
            INIT: 0,
            DOING: 100,
            SUCCESS: 200,
        },
        STATUS_MAP: {
            '0': { value: 0, text: '待执行', color: 'blue' },
            '100': { value: 100, text: '执行中', color: 'orange' },
            '200': { value: 200, text: '已结束', color: 'green' },
        },
        MEMBER_STATUS: {
            SUCCESS: 1,
            FAIL: 2,
        },
        MEMBER_STATUS_MAP: {
            '0': { value: 0, text: '待执行', color: 'gray' },
            '1': { value: 1, text: '成功', color: 'green' },
            '2': { value: 2, text: '失败', color: 'red' },
        }
    },
    // 设备型号
    DEVICE_MODEL: {
        STATUS: {
            OPEN: 100,    // 开启
            CLOSE: -100,  // 关闭
        },
        STATUS_MAP: {
            '100': { value: 100, text: '开启' },
            '-100': { value: -100, text: '关闭' },
        },
        // TYPE: {
        //     GATEWAY: 1,      // 组网版
        //     INDEPENDENT: 2,  // 独立版
        //     NB: 3,           // NB插座
        //     CAR_AC: 4,       // 汽车交流充电桩
        //     CAR_DC: 5,       // 汽车直流充电桩
        //     TANK: 6,         // 充电柜
        //     CABINET: 7,      // 换电柜
        // },
        // TYPE_MAP: {
        //     '1': { value: 1, text: '组网版', station_type: 1, type_list_value: '1-1' },
        //     '2': { value: 2, text: '独立版', station_type: 1, type_list_value: '1-2' },
        //     '3': { value: 3, text: 'NB插座', station_type: 1, type_list_value: '1-3' },
        //     '4': { value: 4, text: '交流充电桩', station_type: 2, type_list_value: '4-4' },
        //     '5': { value: 5, text: '直流充电桩', station_type: 2, type_list_value: '4-5' },
        //     '6': { value: 6, text: '充电柜', station_type: 3, type_list_value: '6' },
        //     '7': { value: 7, text: '换电柜', station_type: 4, key: 'cabinet', type_list_value: '7' },
        // },
        // TYPE_MARK: {
        //     PLUG: [1, 2, 3],  // 两轮充
        // },
    },
    // 电池设备
    BATTERY: {
        STATUS_MAP: {
            '0': { value: 0, text: '搁置' },
            '1': { value: 1, text: '放电' },
            '2': { value: 2, text: '充电' },
            '3': { value: 3, text: '休眠' },
            '4': { value: 4, text: '仓储' },
            '5': { value: 5, text: '追踪' },
        },
        TYPE_MAP: {
            '1': { value: 1, text: '48V' },
            '2': { value: 2, text: '60V' },
            '3': { value: 3, text: '72V' },
        },
        GPS_STATUS_MAP: {
            '1': { value: 1, text: 'E/N' },
            '2': { value: 2, text: 'E/S' },
            '3': { value: 3, text: 'W/N' },
            '4': { value: 4, text: 'W/S' },
            '5': { value: 5, text: 'GPS未定位' },
        },
        MOS_STATUS_MAP: {
            '1': { value: 1, text: '充电MOS断开，放电MOS断开' },
            '2': { value: 2, text: '充电MOS断开，放电MOS闭合' },
            '3': { value: 3, text: '充电MOS闭合，放电MOS断开' },
            '4': { value: 4, text: '充电MOS闭合，放电MOS闭合' },
        },
    },
    // 电池包
    PACK: {
        TYPE: {
            TERNARY: 1,  // 三元锂电
            LITHIUMIRON: 2,  // 磷酸铁锂
            LITHIUM_MANGANATE: 3,  // 锰酸锂电
            LEAD_ACID_CELL: 4,  // 铅酸电池
        },
        TYPE_MAP: {
            '1': { value: 1, text: '三元锂电' },
            '2': { value: 2, text: '磷酸铁锂' },
            '3': { value: 3, text: '锰酸锂电' },
            '4': { value: 4, text: '铅酸电池' },
        }
    },
    // 道闸
    GATE: {
        STATUS: {
            STOP: 0, // 未归位 - 中间停止状态
            OPENRD: 1, // 工作中 - 开闸到位
            OPENING: 2, // 工作中 - 开闸中
            CLOSED: 3, // 空闲中 - 关闸到位
            CLOSEING: 4, // 空闲中 - 关闸中
            FAULT_MOTOR: 5, // 电机故障
            FAULT_COMMU: 6, // 通讯故障
        },
        STATUS_MAP: {
            "0": { value: 0, color: 'red', text: '未归位', detail: '未归位(中间停止)' },
            "1": { value: 1, color: 'green', text: '工作中', detail: '工作中(开闸到位)' },
            "2": { value: 2, color: 'orange', text: '开闸中', detail: '工作中(开闸中)' },
            "3": { value: 3, color: 'blue', text: '空闲中', detail: '空闲中(关闸到位)' },
            "4": { value: 4, color: 'orange', text: '关闸中', detail: '空闲中(关闸中)' },
            "5": { value: 5, color: 'red', text: '电机故障', detail: '已故障(电机故障)' },
            "6": { value: 6, color: 'red', text: '通讯故障', detail: '已故障(通讯故障)' },
        },
        TYPE: {
            SINGLE: 1, // 单杆
            DOUBLE: 2, // 双杆
        },
        TYPE_MAP: {
            "1": { value: 1, text: '单杆' },
            "2": { value: 2, text: '双杆' },
        },
        ACTION_TYPE: {
            OPEN: 1,  // 开闸
            CLOSE: 0, // 关闸
        },
        ACTION_STATUS_MAP: {
            "100": { value: 100, text: '成功', color: 'green' },
            "-100": { value: -100, text: '失败', color: 'red' },
        },
        ACTION_FINISH_CODE_MAP: {
            '0': '正常结束',
        }
    },

    // 计费模版
    CHARGE: {
        WAY: {
            SMART: 0,    // 智能
            TIME: 1,     // 定时
            MONEY: 2,    // 定额
            ENERGY: 3,   // 定量
            MERGE: 4,    // 直流桩 双枪同充
            MERGE_ADAPTIVE: 5, // 直流桩 双枪同充（自适应）
        },
        WAY_MAP: {
            '0': { value: 0, text: '智能充' },
            '1': { value: 1, text: '定时充' },
            '2': { value: 2, text: '定额充' },
            '3': { value: 3, text: '定量充' },
            '4': { value: 4, text: '双枪同充' },  // 直流桩 双枪同充
            '5': { value: 5, text: '双枪同充（自适应）' },
        },

        // 计费模式   前端定义
        CHARGE_TYPE_CUSTOM: {
            /**
             * charge_type
             * 1   两轮充按时计费
             * 2   两轮充按量计费
             * 3   两轮充按功率计费
             * 4   两轮充免费模版
             * 5   两轮充服务费模版
             * 6   两轮充电费+服务费
             * 7   汽车充电费+服务费（包括汽车充免费）
             * 8   汽车充占位费
             * 9   充电柜按时间
             * 10  充电柜按功率
             * 11  充电柜免费
             * 12  换电柜套餐
             * 13  换电柜免费
             * 14  道闸计费
             */

            TIME: 1,          // 两轮充按时计费
            ENERGY: 2,        // 两轮充按量计费
            POWER: 3,         // 两轮充按功率计费
            FREE: 4,          // 两轮充免费模版
            SERVICE: 5,       // 两轮充服务费模版
            TIME_SERVICE: 6,  // 两轮充电费+服务费

            CAR_SERVICE: 7,   // 汽车充电费+服务费（包括汽车充免费）
            CAR_OCCUPY: 8,    // 汽车充占位费

            TANK_TIME:  9,    // 充电柜按时间
            TANK_POWER: 10,   // 充电柜按功率
            TANK_FREE: 11,    // 充电柜免费

            CABINET: 12,      // 换电柜套餐
            CABINET_FREE: 13, // 换电柜免费
            
            GATE: 14,         // 道闸计费
        },

        // 协议类型  前端定义
        PROTOCOL: {
            PUBLIC: 0,          // 公版
            YKC: 1,          // 云快充
        },

        // 计费模版 类型
        TYPE: {
            TIME: 1,    // 按时
            ENERGY: 2,  // 按电量
            POWER: 3,   // 分功率
            FREE: 4,    // 免费
            SERVICE: 5, // 服务费-旧
            TIME_SERVICE: 11, // 分时段服务费-新

            CAR_SERVICE: 6,   // 汽车充服务费
            CAR_FREE: 10,     // 汽车充免费
            CAR_OCCUPY: 15,  // 汽车充占位费
            CAR_TIME_OF_USE: 17,    // 电费+服务费（按尖峰平谷）

            TANK_TIME:  7,    // 充电柜按时计费
            TANK_POWER: 8,    // 充电柜按功率计费
            TANK_FREE: 16,    // 充电柜免费模板

            CABINET: 9,       // 换电套餐 - 单个电池
            CABINET_FREE: 13, // 换电计费 - 免费
            CABINET_MORE: 14, // 换电计费 - 多个电池

            GATE: 12,         // 道闸计费
        },
        TYPE_MAP: {
            // short_text 不含设备类型(如汽车充)的
            /**
             * charge_type  对应  CHARGE_TYPE_CUSTOM
             */
            '1':  { 
                value: 1,  
                device_type: 1,
                text: '按时计费', 
                short_text: '按时间',
                charge_type: 1,
                charge_type_text: '按时间',
            },
            '2':  { 
                value: 2,  
                device_type: 1,
                text: '按量计费', 
                short_text: '按电量',
                charge_type: 2,
                charge_type_text: '按电量',
            },
            '3':  { 
                value: 3,  
                device_type: 1,
                text: '按功率计费', 
                short_text: '按功率',
                charge_type: 3,
                charge_type_text: '按功率',
            },
            '4':  { 
                value: 4,  
                device_type: 1, 
                text: '免费模版', 
                short_text: '免费',
                charge_type: 4, 
                charge_type_text: '免费',
            },
            '5':  { 
                value: 5,  
                device_type: 1, 
                text: '服务费模版', 
                short_text: '服务费模板',
                charge_type: 5, 
                charge_type_text: '服务费',
            },
            '6':  { 
                value: 6,  
                device_type: 2, 
                text: '汽车充服务费模版', 
                short_text: '电费服务费（按时段）',
                charge_type: 7, 
                charge_type_text: '电费服务费（按时段）',
            },
            '7':  { 
                value: 7,  
                device_type: 3, 
                text: '充电柜按时计费', 
                short_text: '按时间',
                charge_type: 9, 
                charge_type_text: '按时间',
            },
            '8':  { 
                value: 8,  
                device_type: 3, 
                text: '充电柜按功率计费', 
                short_text: '按功率',
                charge_type: 10, 
                charge_type_text: '按功率',
            },
            '9':  { 
                value: 9,  
                device_type: 4, 
                text: '换电套餐', 
                short_text: '换电套餐',
                charge_type: 12, 
                charge_type_text: '套餐',
            },
            '10': { 
                value: 10, 
                device_type: 2, 
                text: '汽车充免费模版', 
                short_text: '免费',
                charge_type: 7, 
                charge_type_text: '电费服务费（按时段）',
            }, 
            '11': { 
                value: 11, 
                device_type: 1, 
                text: '电费+服务费计费模板', 
                short_text: '电费+服务费',
                charge_type: 6, 
                charge_type_text: '电费+服务费',
            },
            '12': { 
                value: 12, 
                device_type: 5, 
                text: '道闸计费', 
                short_text: '道闸计费',
                charge_type: 14, 
                charge_type_text: '道闸计费',
            },
            '13': { 
                value: 13, 
                device_type: 4, 
                text: '免费换电', 
                short_text: '免费换电',
                charge_type: 13, 
                charge_type_text: '免费',
            },
            '14': { 
                value: 14, 
                device_type: 4, 
                text: '换电套餐', 
                short_text: '换电套餐',
                charge_type: 12, 
                charge_type_text: '套餐',
            },
            '15': { 
                value: 15, 
                device_type: 2, 
                text: '汽车充占位费', 
                short_text: '占位费',
                charge_type: 8, 
                charge_type_text: '占位费',
            },
            '16': { 
                value: 16, 
                device_type: 3, 
                text: '充电柜免费模板', 
                short_text: '免费',
                charge_type: 11, 
                charge_type_text: '免费',
            },
            '17': { 
                value: 17, 
                device_type: 2, 
                text: '电费+服务费（按尖峰平谷）', 
                short_text: '电费服务费（按尖峰平谷）',
                charge_type: 15, 
                charge_type_text: '电费服务费（按尖峰平谷）',
            },
        },
        TYPE_MULTILEVEL: {
            1: { 
                name: '两轮充', 
                children: { 
                    1: { 
                        name: '按时间', 
                        auth: [],
                        children: {
                            1: { name: '按时间' }
                        }
                    }, 
                    2: { 
                        name: '按电量', 
                        auth: [],
                        children: {
                            2: { name: '按电量' }
                        } 
                    }, 
                    3: { 
                        name: '按功率', 
                        auth: [],
                        children: {
                            3: { name: '按功率' }
                        } 
                    }, 
                    4: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            4: { name: '免费' }
                        } 
                    }, 
                    5: { 
                        name: '服务费', 
                        auth: [],
                        children: {
                            5: { name: '服务费' }
                        } 
                    }, 
                    6: { 
                        name: '电费+服务费', 
                        auth: [],
                        children: {
                            11: { name: '电费+服务费' }
                        } 
                    } 
                } 
            },
            2: { 
                name: '汽车充', 
                children: { 
                    7: { 
                        name: '电费服务费（按时段）', 
                        auth: [],
                        protocol: 0,
                        children: {
                            6:  { name: '收费' },   // 对应之前的汽车充电费+服务费模板
                            10: { name: '免费' },   // 对应之前的汽车充免费模板
                        } 
                    },
                    8: { 
                        name: '占位费',
                        auth: ['pre.config.update', 'car-occupy.update'],
                        protocol: 0,
                        children: {
                            15: { name: '占位费' }
                        }
                    },
                    15: {
                        name: '电费服务费（按尖峰平谷）',
                        auth: [],
                        protocol: 1,
                        children: {
                            17:  { name: '电费服务费（按尖峰平谷）' },
                        } 
                    }
                } 
            },
            3: { 
                name: '充电柜', 
                children: { 
                    9: { 
                        name: '按时间', 
                        auth: [],
                        children: {
                            7: { name: '按时间' }
                        } 
                    }, 
                    10: { 
                        name: '按功率', 
                        auth: [],
                        children: {
                            8: { name: '按功率' }
                        } 
                    }, 
                    11: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            16: { name: '免费' }
                        } 
                    } 
                } 
            },
            4: { 
                name: '换电柜', 
                children: { 
                    12: { 
                        name: '套餐', 
                        auth: [],
                        children: {
                            // 9: { name: '套餐' },
                            14: { name: '套餐' },
                        } 
                    }, 
                    13: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            13: { name: '免费' }
                        } 
                    } 
                } 
            },  // 9: '换电套餐'
            5: { 
                name: '道闸', 
                children: { 
                    14: { 
                        name: '道闸计费', 
                        auth: [],
                        children: {
                            12: { name: '道闸计费' }
                        } 
                    } 
                } 
            },
        },
        TYPE_MULTILEVEL_SP: {
            1: { 
                name: '两轮充', 
                children: { 
                    1: { 
                        name: '按时间', 
                        auth: [],
                        children: {
                            1: { name: '按时间' }
                        } 
                    }, 
                    2: { 
                        name: '按电量', 
                        auth: [],
                        children: {
                            2: { name: '按电量' }
                        } 
                    }, 
                    3: { 
                        name: '按功率', 
                        auth: [],
                        children: {
                            3: { name: '按功率' }
                        } 
                    }, 
                    4: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            4: { name: '免费' }
                        } 
                    }, 
                    5: { 
                        name: '服务费', 
                        auth: [],
                        children: {
                            5: { name: '服务费' }
                        } 
                    } 
                } 
            },
            2: { 
                name: '汽车充', 
                children: { 
                    7:  { 
                        name: '电费服务费（按时段）',
                        auth: [],
                        protocol: 0,
                        children: {
                            6:  { name: '收费' },   // 对应之前的汽车充电费+服务费模板
                            10: { name: '免费' },   // 对应之前的汽车充免费模板
                        } 
                    }, 
                    8: { 
                        name: '占位费',
                        auth: ['pre.config.update', 'car-occupy.update'],
                        protocol: 0,
                        children: {
                            15: { name: '占位费' }
                        }
                    },
                    15: {
                        name: '电费服务费（按尖峰平谷）',
                        auth: [],
                        protocol: 1,
                        children: {
                            17:  { name: '电费服务费（按尖峰平谷）' },
                        } 
                    }
                } 
            },
            3: { 
                name: '充电柜', 
                children: { 
                    9:  { 
                        name: '按时间', 
                        auth: [],
                        children: {
                            7: { name: '按时间' }
                        } 
                    }, 
                    10:  { 
                        name: '按功率', 
                        auth: [],
                        children: {
                            8: { name: '按功率' }
                        } 
                    }, 
                    11: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            16: { name: '免费' }
                        } 
                    } 
                } 
            },
            4: { 
                name: '换电柜', 
                children: { 
                    12: { 
                        name: '套餐', 
                        auth: [],
                        children: {
                            // 9: { name: '套餐' },
                            14: { name: '套餐' },
                        } 
                    }, 
                    13: { 
                        name: '免费', 
                        auth: [],
                        children: {
                            13: { name: '免费' }
                        } 
                    } 
                } 
            },  // 9: '换电套餐'
            5: { 
                name: '道闸', 
                children: { 
                    14: { 
                        name: '道闸计费', 
                        auth: [],
                        children: {
                            12: { name: '道闸计费' }
                        } 
                    } 
                } 
            },
        },
        TYPE_MARK: {
            // 按设备类型分
            PLUG: [1, 2, 3, 4, 5, 11],  // 两轮充计费方式
            TANK: [7, 8, 16],  // 充电柜模板
            CAR: [6, 10, 15, 17], // 汽车充
            CAR_CHARGE: [6, 10, 17], // 汽车充充电模板（不包括占位模板）
            CABINET: [9, 13, 14], // 换电柜
            GATE: [12], // 道闸

            // 按计费内容
            TIME: [1, 7],  // 按时
            ENERGY: [2],   // 按电量
            POWER: [3, 8], // 分功率
            FREE: [4, 10, 13, 16], // 免费模板
            OLD_SER: [5], // 旧版服务费
            SERVICE: [6, 11], // 分时段的服务费
            TANK_OCCUPY: [7, 8], // (有占用费的)充电柜模板

            INFO: [2, 3, 8], // 可选是否展示 计费信息
            CANDIDATE: [3, 6, 8, 11, 17], // 有候选金额

			NO_TIME_CARD: [6, 10, 12, 13, 7, 8], // 不可用包月卡支付
			NO_WX_SCORE: [7, 8], // 不可用微信支付分支付
            
            SHOW_OTHER_TEMP_PANEL: [2, 3, 6, 8, 11, 17],  // 创建计费模板显示其他设置

            SHOW_MODEL_TABLE: [1, 2, 3, 6, 7, 8, 9, 12, 14, 15, 17],  // 计费列表显示计费表格
            SHOW_MODEL_INFO: [2, 3, 5, 6, 7, 8, 9, 11, 14, 17],  // 计费模板展示

            NOT_ELECTRIC: [1, 2, 3, 5, 7, 8], // 有充电费用 且 非电价分离的计费模板

            ELECTRIC_SEPARATION: [6, 11, 17], // 电价分离的计费模板
        },
        // 服务费收费方式 类型
        SERVICE_FEE_TYPE: {
            TIME: 0,
            ENERGY: 1,
            REAL_POWER: 2, // 实时功率
            SETTLE_POWER: 3, // 结算功率
            COUNT: 4, // 按次
        },
        SERVICE_FEE_TYPE_MARK: {
            TIME: [0],
            ENERGY: [1],
            POWER: [2, 3],
            COUNT: [4],
        },
        SERVICE_FEE_TYPE_MAP: {
            '0': { value: 0, text: '按时间', unit: '小时' },
            '1': { value: 1, text: '按电量', unit: '度' },
            '2': { value: 2, text: '按实时功率', unit: '' },
            '3': { value: 3, text: '按结算功率', unit: '' },
            '4': { value: 4, text: '按次', unit: '' },
        },

        // 最低消费
        MIN_CONSUME_MONEY: {
            DISABLE: 0, // 禁用
            ENABLE: 1, // 启用
        },

        MIN_CONSUME_MONEY_SHOW_DETAIL: {
            HIDE: 0, // 不显示
            SHOW: 1, // 显示
        },

        // 充满自停预付金额
        CHARGE_FULL_PRE_MONEY: {
            DISABLE: 0, // 禁用
            ENABLE: 1, // 启用
        },

        // 充电订单 charge_mode 字段，未和 计费模板类型保持一致
        CHARGE_MODE: {
            TIME: 1,    // 按时
            ENERGY: 2,  // 按电量
            POWER: 3,   // 分功率
            FREE: 4,    // 免费
            SERVICE: 5, // 服务费-旧
            TIME_SERVICE: 11, // 分时段服务费-新

            CAR_SERVICE: 6,   // 汽车充服务费
            CAR_FREE: 10,     // 汽车充免费
            CAR_OCCUPY: 12,  // 汽车充预约充电
            CAR_TIME_OF_USE: 14, // 汽车充尖峰平谷

            TANK_TIME:  7,    // 充电柜按时计费
            TANK_POWER: 8,    // 充电柜按功率计费
            TANK_FREE: 13,    // 充电柜免费模板
        },
        CHARGE_MODE_MAP: {
            '1':  { value: 1,  text: '按时计费', short_text: '按时计费' },
            '2':  { value: 2,  text: '按量计费', short_text: '按量计费' },
            '3':  { value: 3,  text: '按功率计费', short_text: '按功率计费' },
            '4':  { value: 4,  text: '免费模版', short_text: '免费模版' },
            '5':  { value: 5,  text: '服务费模版', short_text: '服务费模版' },
            '6':  { value: 6,  text: '汽车充服务费模版', short_text: '服务费模版' },
            '7':  { value: 7,  text: '充电柜按时计费', short_text: '按时计费' },
            '8':  { value: 8,  text: '充电柜按功率计费', short_text: '按功率计费' },
            '9':  { value: 9,  text: '换电套餐', short_text: '换电套餐' },
            '10': { value: 10, text: '汽车充免费模版', short_text: '免费模版' },
            '11': { value: 11, text: '电费+服务费计费模板', short_text: '电费+服务费计费模板' },
            '12': { value: 12, text: '汽车充预约充电计费模板', short_text: '预约充电计费模板' },
            '13': { value: 13, text: '充电柜免费模板', short_text: '免费模板' },
            '14': { value: 14, text: '汽车充尖峰平谷模板', short_text: '电费+服务费按尖峰平谷模板' },
        },
        CHARGE_MODE_MARK: {
            // 按设备类型分
            PLUG: [1, 2, 3, 4, 5, 11],  // 两轮充计费方式
            TANK: [7, 8, 13],  // 充电柜模板
            CAR: [6, 10, 12, 14], // 汽车充

            // 按计费内容
            TIME: [1, 7],  // 按时
            ENERGY: [2],   // 按电量
            POWER: [3, 8], // 分功率
            FREE: [4, 10, 13], // 免费模板
            OLD_SER: [5], // 旧版服务费
            SERVICE: [6, 11, 14], // 分时段的服务费
            TANK_OCCUPY: [7, 8], // 有占用费的 充电柜模板

            INFO: [2, 3, 8], // 可选是否展示 计费信息
            CANDIDATE: [3, 6, 8, 11, 14], // 有候选金额
        },

        // 产品类型
        PRODUCT_TYPE: {
            PLUG: 1,     // 两轮充
            CAR: 2,      // 汽车充
            TANK: 3,     // 充电柜
            CABINET: 4,  // 换电柜
            GATE: 5,     // 道闸
            PRE_CAR: 6,     // 汽车充预约充电
        },
        PRODUCT_TYPE_MAP: {
            '1': {
                value: 1,
                text: '两轮充',
                count: 0,
                list: [],
                children_mode_list: [1, 2, 3, 4, 5, 11],
                children: {
                    '1': { 
                        value: 1,   
                        count: 0, 
                        list: [], 
                        text: '按时间',
                        children_mode_list: [1],
                        children: {
                            '1': {
                                value: 1,   
                                count: 0, 
                                list: [], 
                                text: '按时间',
                            }
                        }
                    },
                    '2': { 
                        value: 2,   
                        count: 0, 
                        list: [], 
                        text: '按电量',
                        children_mode_list: [2],
                        children: {
                            '2': {
                                value: 2,   
                                count: 0, 
                                list: [], 
                                text: '按电量',
                            }
                        }
                    },
                    '3': { 
                        value: 3,   
                        count: 0, 
                        list: [], 
                        text: '按功率',
                        children_mode_list: [3],
                        children: {
                            '3': {
                                value: 3,   
                                count: 0, 
                                list: [], 
                                text: '按功率',
                            }
                        }
                    },
                    '4': { 
                        value: 4,   
                        count: 0, 
                        list: [], 
                        text: '免费',
                        children_mode_list: [4],
                        children: {
                            '4': {
                                value: 4,   
                                count: 0, 
                                list: [], 
                                text: '免费',
                            }
                        }
                    },
                    '5': { 
                        value: 5,   
                        count: 0, 
                        list: [], 
                        text: '服务费',
                        children_mode_list: [5],
                        children: {
                            '5': {
                                value: 5,   
                                count: 0, 
                                list: [], 
                                text: '服务费',
                            }
                        }
                    },
                    '6': { 
                        value: 6, 
                        count: 0, 
                        list: [], 
                        text: '电费+服务费',
                        children_mode_list: [11],
                        children: {
                            '11': {
                                value: 11,   
                                count: 0, 
                                list: [], 
                                text: '电费+服务费',
                            }
                        }
                    },
                }
            },
            '2': {
                value: 2,
                text: '汽车充',
                count: 0,
                list: [],
                children_mode_list: [6, 10, 15, 17],
                children: {
                    '7': { 
                        value: 7,   
                        count: 0, 
                        list: [], 
                        text: '电费服务费-按时段',
                        children_mode_list: [6, 10],
                        protocol: 0,
                        order: 0,
                        children: {
                            '6': {
                                value: 6,   
                                count: 0, 
                                list: [], 
                                text: '收费',
                            },
                            '10': {
                                value: 10,   
                                count: 0, 
                                list: [], 
                                text: '免费',
                            }
                        }
                    },
                    '8': { 
                        value: 8, 
                        count: 0, 
                        list: [], 
                        text: '占位费',
                        children_mode_list: [15],
                        protocol: 0,
                        order: 1,
                        children: {
                            '15': {
                                value: 15,   
                                count: 0, 
                                list: [], 
                                text: '占位费',
                            }
                        }
                    },
                    '15': {
                        value: 15, 
                        count: 0, 
                        list: [], 
                        text: '电费服务费-按尖峰平谷',
                        children_mode_list: [17],
                        protocol: 1,
                        order: 0,
                        children: {
                            '17': {
                                value: 17,   
                                count: 0, 
                                list: [], 
                                text: '电费+服务费-按尖峰平谷',
                            }
                        }
                    }
                }
            },
            '3': {
                value: 3,
                text: '充电柜',
                count: 0,
                list: [],
                children_mode_list: [7, 8, 16],
                children: {
                    '9': { 
                        value: 9,   
                        count: 0, 
                        list: [], 
                        text: '按时间',
                        children_mode_list: [7],
                        children: {
                            '7': {
                                value: 7,   
                                count: 0, 
                                list: [], 
                                text: '按时间',
                            }
                        } 
                    },
                    '10': { 
                        value: 10,   
                        count: 0, 
                        list: [], 
                        text: '按功率',
                        children_mode_list: [8],
                        children: {
                            '8': {
                                value: 8,   
                                count: 0, 
                                list: [], 
                                text: '按功率',
                            }
                        }
                    },
                    '11': { 
                        value: 11, 
                        count: 0, 
                        list: [], 
                        text: '免费',
                        children_mode_list: [16],
                        children: {
                            '16': {
                                value: 16,   
                                count: 0, 
                                list: [], 
                                text: '免费',
                            }
                        }
                    },
                }
            },
            '4': {
                value: 4,
                text: '换电柜',
                count: 0,
                list: [],
                children_mode_list: [9, 13, 14],
                children: {
                    '12': { 
                        value: 12,   
                        count: 0, 
                        list: [], 
                        text: '套餐',
                        children_mode_list: [9, 14],
                        children: {
                            '9': {
                                value: 9,   
                                count: 0, 
                                list: [], 
                                text: '套餐(旧)',
                            },
                            '14': {
                                value: 14,   
                                count: 0, 
                                list: [], 
                                text: '套餐',
                            },
                        } 
                    },
                    '13': { 
                        value: 13,   
                        count: 0, 
                        list: [], 
                        text: '免费',
                        children_mode_list: [13],
                        children: {
                            '13': {
                                value: 13,   
                                count: 0, 
                                list: [], 
                                text: '免费',
                            }
                        } 
                    },
                }
            },
            '5': {
                value: 5,
                text: '道闸',
                count: 0,
                list: [],
                children_mode_list: [12],
                children: {}
            },
        },

        CAR_OCCUPY: { // 汽车充占位费
            // 占位阶段 前端定义  和后端没关联
            STAGE: {
                CHARGE_BEFORE: 1, // 充电前
                CHARGE_AFTER: 2, // 充电后
            },
            STAGE_MAP: {
                '1': { value: 1, text: '充电前', disabled: false, key: 'flag_car_occupy_before_charge', auth: 'pre.config.update' },
                '2': { value: 2, text: '充电后', disabled: false, key: 'flag_car_occupy_after_charge', auth: 'car-occupy.update' },
            },
            MODE: {  // 计费模式
                TIME: 1,  // 实时计费(分钟)
                MONEY: 2, // 一口价
            },
            MODE_MAP: {
                '1': { value: 1, text: '实时计费' },
                '2': { value: 2, text: '一口价' },
            },
            FLAG_CHARGE: { // 是否开启汽车充预约充电
                CLOSE: 0,  // 关闭
                OPEN: 1, // 开启
            },
            FLAG_CHARGE_MAP: {
                '': { value: '', text: '全部' },
                '0': { value: 0, text: '关闭' },
                '1': { value: 1, text: '开启' },
            },
            FLAG_CHARGE_LIST: [
                { value: '', text: '全部' },
                { value: 0, text: '关闭' },
                { value: 1, text: '开启' },
            ],
            FLAG_CHARGE_CHARGE: {  // 预约充电是否收费
                CHARGE: 1, // 收费
                FREE: 0, // 不收费
            },
            FLAG_CHARGE_CHARGE_MAP: {
                '0': { value: 0, text: '不收费' },
                '1': { value: 1, text: '收费' },
            },
        },
        TIME_OF_USE_MAP: { // 汽车充电费+服务费（按尖峰平谷）
            '0': { value: 0, text: '尖' }, // edge
            '1': { value: 1, text: '峰' }, // peak
            '2': { value: 2, text: '平' }, // normal
            '3': { value: 3, text: '谷' }, // valley
        },
        PROTOCOL_TYPE: {
            NORMAL: 0,
            CAR_YKC: 1,
        },
        PROTOCOL_TYPE_MAP: { // 汽车充协议类型
            '0': { value: 0, text: '公版'  , label: '公版协议'},
            '1': { value: 1, text: '云快充' , label: '云快充协议'},
        },
        // 两轮充计费模式
        PLUG_CHARGE_TYPE_MAP: {
            '0': { value: 0, label: '按时间', mode: [1], title: '时间模版' },
            '1': { value: 1, label: '按电量', mode: [2], title: '电量模版' },
            '2': { value: 2, label: '按功率', mode: [3], title: '功率模版' },
            '3': { value: 3, label: '按电费和服务费', mode: [5, 11], title: '按电费和服务费' },
            '4': { value: 4, label: '免费', mode: [4], title: '免费模版', isFree: true },
        },
    },

    // 分账模板管理
    SETTLE_MODEL: {
        // 服务费分摊模式
        SERVICE_FEE_ACCOUNT_MODE: {
            TOGETHER: 1, // 共同承担模式
            UNILATERAL: 2, // 单方承担模式
        },
        SERVICE_FEE_ACCOUNT_MODE_MAP: {
            '1': { value: 1, text: '共同承担' },
            '2': { value: 2, text: '单方承担' },
        },
    },

    // 支付
    PAY: {
        STATUS: {
            INIT: 0, // 初始化
            PREPAY_SUCCESS: 150, // 预支付成功
            SUCCESS: 200, // 支付成功
            FAIL: -1, // 支付失败
        },
        STATUS_MAP: {
            '0':   { value: 0,   color: 'orange', status_text: '中',        text: '初始化'    },
            '150': { value: 150, color: 'green',  status_text: '预支付成功', text: '预支付成功', admin_text: '预支付成功', operator_text: '支付成功' },
            '200': { value: 200, color: 'green',  status_text: '成功',      text: '支付成功'   },
            '-1':  { value: -1,  color: 'red',    status_text: '失败',      text: '支付失败'  , admin_text: '预支付成功', operator_text: '支付成功'},
        },
        // 目标订单类型
        TARGET_TYPE: {
            CHARING: 1,  // 充电订单
            CABINET: 800, // 换电订单
            TANK_OCCUPY: 700, // 充电柜占用费订单
            GATE_OCCUPY: 900, // 道闸 占用费订单
            PURSUE: 1000, // 追款订单
            RECHARGE_REALITY_TIME: 200, // 实体包月卡充值订单
            RECHARGE_REALITY_MONEY: 300, // 实体储值卡充值订单
            RECHARGE_VIRTUAL_TIME: 500, // 虚拟包月卡充值订单
            RECHARGE_VIRTUAL_MONEY: 400, // 虚拟储值卡充值订单

            CLEARING_ORDER: 5,         // 结算订单
            CLEARING_TRADE: 100,       // 结算交易
            ACCOUNT_AUTO_TRANSFER: 101,// 自动提现
            REFUND_TRANSFER: 103,      // 退款转账
            CHARGE_ACCOUNT: 600,       // 虚拟账户充值订单
            SERVICE_RECHARGE: 1100, // 服务费充值订单

            INSURANCE: 1200, // 保险订单
        },

        // 科目
        SUBJECT: {
            ORDER_TRANSFER: 55,          // 打款
            ORDER_WX_PROFIT_SHARING: 58, // wx收付通分账
            ORDER_PAY: 65,               // 支付
            ORDER_POSTPAY: 70,           // 平台垫付
            ORDER_REFUND: 75,            // 退款
            ORDER_PORTION_REFUND: 85,    // 部分退款
            REFUND_AFTER_CLEARING: 95,   // 二次退款
            REFUND_INSURANCE: 98,        // 保费退还
            BOOKING_ORDER_REFUND_AFTER_CLEARING: 105,  // 预约订单占位二次退款
            SERVICE_FEE_REFUND_AFTER_CLEARING: 127,  // 服务费账户结算后退款
            USER_RECHARGE_REFUND_APPLY: 180,   // 用户退款申请
            USER_REFUND_DEPOSIT_APPLY: 190,    // 用户押金退款

            ALIPAY_AD_ORDER_REFUND: 320,    // 支付宝广告订单退款
            ALIPAY_AD_ORDER_POWER: 330,    // 支付宝广告订单充电使用
        },
        SUBJECT_MAP: {
            '55': { value: 55, text: '打款', recharge_text: '打款', occupy_text: '打款' },
            '58': { value: 58, text: '微信收付通分账', recharge_text: '微信收付通分账', occupy_text: '微信收付通分账' },
            '65': { value: 65, text: '用户支付', recharge_text: '用户支付', occupy_text: '用户支付' },
            '70': { value: 70, text: '平台垫付',  recharge_text: '平台垫付', occupy_text: '平台垫付' },
            '75': { value: 75, text: '退回用户', recharge_text: '退回用户', occupy_text: '退回用户' },
            '85': { value: 85, text: '退回用户·部分', recharge_text: '退回用户·部分', occupy_text: '占位费（充电后）' },
            '95': { value: 95, text: '退回用户·结算后·充电', recharge_text: '退回用户·结算后·充值', occupy_text: '退回用户·结算后·占位' },  // 二次退款 充电/充值/占位费
            '98': { value: 98, text: '退回用户', recharge_text: '退回用户', occupy_text: '退回用户' }, // 保费退还
            '105': { value: 105, text: '退回用户·结算后·占位', recharge_text: '退回用户·结算后·占位', occupy_text: '退回用户·结算后·占位' },  // 占位二次退款
            '127': { value: 127, text: '退回用户·设备流量服务费', recharge_text: '退回用户·设备流量服务费', occupy_text: '退回用户·设备流量服务费' },
            '180': { value: 180, text: '用户储值卡退款申请', recharge_text: '用户储值卡退款申请', occupy_text: '用户储值卡退款申请' },
            '190': { value: 190, text: '用户换电柜押金退款', recharge_text: '用户换电柜押金退款', occupy_text: '用户换电柜押金退款' },
            

            '320': { value: 320, text: '退回平台', recharge_text: '退回平台', occupy_text: '退回平台' },
            '330': { value: 330, text: '平台支付', recharge_text: '平台支付', occupy_text: '平台支付' },
        },
        SUBJECT_MARK: {
            ALIPAY_AD_ORDER: [320, 330],  // 骑行险红包
        },
        // 支付通道
        CHANNEL: {
            WECHART: 1,    // 微信支付
            ALIPAY:  2,    // 支付宝
            WX_SERVICE: 4, // 微信公众号
            ALIPAY_TRANSFER: 3, // 支付宝打款
            WX_SCORE: 5,  // 微信支付分
            ALIPAY_H5: 6, // 支付宝h5
            BF: 7,        // 宝付支付
            HF: 8,        // 汇付
            QGL: 9,       // 青橄榄支付
            VIRTUAL_CARD: 10, //虚拟卡支付
            CHAGRE_FIRST: 13, //先充后付
        },
        CHANNEL_MARK: {
            CARD: [10],  // 卡片支付
        },
        CHANNEL_MAP: {
            '1': { value: 1, text: '微信支付' },
            '2': { value: 2, text: '支付宝' },
            '4': { value: 4, text: '微信公众号' },
            '3': { value: 3, text: '支付宝打款' },
            '5': { value: 5, text: '微信支付分' },
            '6': { value: 6, text: '支付宝h5' },
            '7': { value: 7, text: '宝付支付' },
            '8': { value: 8, text: '汇付' },
            '9': { value: 9, text: '青橄榄支付' },
            '10': { value: 10, text: '虚拟卡支付' },
            '13': { value: 13, text: '先充后付' },
        },

        HANDLER_TYPE: {
            DEF: 0,    // 默认
            ICBC: 14, // 工商银行
        },

        // 支付方式
        METHOD: {
            WECHART: 1,            // 微信
            ALIPAY: 2,             // 支付宝
            RECHARGE: 3,           // 两轮实体储值卡
            MONTH: 4,              // 两轮实体包月卡
            WHITE: 5,              // 白名单
            VIRTUAL_RECHARGE: 6,   // 两轮虚拟储值卡
            VIRTUAL_MONTH: 7,      // 两轮虚拟包月卡
            WX_SCORE: 8,           // 微信支付分
            CAR_CARD: 9,           // 汽车实体储值卡
            VIRTUAL_CAR_CARD: 10,  // 汽车虚拟储值卡
            PLATFORM_FREE: 11,     // 平台充值
            COUPON: 12,            // 充值券充值
            VIRTUAL_QGL_CARD: 13,  // 青橄榄
            HALUO: 15,             // 哈啰渠道
            COIN: 16,              // 投币支付
            CHARGE_FIRST: 17,      // 先充后付
            CHARGE_FIRST_FREE: 18, // 先充后付免费
            TEAM_RECHARGE: 19,  // 集团储值卡 
        },
        METHOD_LIST: [
            { value: "",   text: '全部'},
            { value: "1",  text: '微信' },
            { value: "2",  text: '支付宝' },
            { value: "3",  text: '两轮实体储值卡' },
            { value: "4",  text: '两轮实体包月卡' },
            { value: "5",  text: '白名单' },
            { value: "6",  text: '两轮虚拟储值卡' },
            { value: "7",  text: '两轮虚拟包月卡' },
            { value: "8",  text: '微信支付分' },
            { value: "9",  text: '汽车实体储值卡' },
            { value: "10", text: '汽车虚拟储值卡' },
            { value: "12", text: '充值券充值' },
            { value: "13", text: '青橄榄一卡通' },
            { value: "15", text: '哈啰支付' },
            { value: "16", text: '投币支付' },
            { value: "17", text: '先充后付' },
            { value: "18", text: '先充后付', admin_text: '先充后付免费' },
            { value: "19", text: '集团vin码储值卡' },
        ],
        METHOD_MAP: {
            '1':  { value: 1,  icon: "i-WeChat",        text: '微信' },
            '2':  { value: 2,  icon: "i-Alipay",        text: '支付宝' },
            '3':  { value: 3,  icon: "i-recharge_card", text: '两轮实体储值卡' },
            '4':  { value: 4,  icon: "i-booyaka",       text: '两轮实体包月卡' },
            '5':  { value: 5,  icon: "i-white_list",    text: '白名单' },
            '6':  { value: 6,  icon: "i-recharge_card", text: '两轮虚拟储值卡' },
            '7':  { value: 7,  icon: "i-booyaka",       text: '两轮虚拟包月卡' },
            '8':  { value: 8,  icon: "i-WeChat",        text: '微信支付分' },
            '9':  { value: 9,  icon: "i-recharge_card", text: '汽车实体储值卡' },
            '10': { value: 10, icon: "i-recharge_card", text: '汽车虚拟储值卡' },
            '11': { value: 11, icon: "i-no_type_in",    text: '平台充值' },
            '12': { value: 12, icon: "i-coupon",        text: '充值券' },
            '13': { value: 13, icon: "i-recharge_card", text: '青橄榄一卡通', auth_key: 'qingganlan' },
            '15': { value: 15, icon: "i-haluo",         text: '哈啰支付', auth_key: 'haluo' },
            '16': { value: 16, icon: "i-coin",          text: '投币支付' },
            '17': { value: 17, icon: "i-charge_first",  text: '先充后付' },
            '18': { value: 18, icon: "i-charge_first",  text: '先充后付', admin_text: '先充后付免费', auth_key: 'admin' },
            '19': { value: 19, icon: "i-recharge_card",  text: '集团vin码储值卡' },
        },
        METHOD_MARK: {
            CARD: [3, 4, 6, 7, 9, 10, 13, 19], // 用卡片支付
            NORMAL_CARD: [3, 4, 6, 7, 9, 10, 19], // 系统中的卡片
            REALITY_CARD: [3, 4, 9],       // 用实体卡片支付
            VIRTUAL_CARD: [6, 7, 10, 13, 19],  // 用虚拟卡片支付
            TIME_CARD: [4, 7], // 包月卡
            MONEY_CARD: [3, 6, 9, 10, 19], // 储值卡

            NEED_CLEARING: [1, 2, 8, 17], // 需要结算

            MONEY: [1, 2, 3, 6, 8, 9, 10, 11, 12, 13, 15, 16, 17, 19], // 支付内容为金额
            TIME: [4, 7], // 支付内容为时间
            FREE: [5], // 免费支付

            CHARGE_FIRST: [17, 18],  // 先充后付

            DETAIL_SHOW_PAY_METHOD: [3, 4, 5, 7, 16, 17, 18, 19],  // 充电订单详情展示支付方式
        },

        CARD_METHOD_LIST: [
            { text: '全部', value: "" },
            { text: '微信', value: "1" },
            { text: '支付宝', value: "2" },
            { text: '平台充值', value: "11" },
            { text: '充值券充值', value: "12" },
        ],
        /* 占用费订单 支付方式与 充电订单支付方式不统一 不支持使用 包月卡 以及 实体卡支付 */
    },
    // 打开渠道
    BOOT: {
        TYPE: {
            QRCODE: 1,
            REALITY_CARD: 2,
            VIRTUAL_CARD: 3,
        },
        TYPE_MAP: {
            '1': { text: '扫码', value: "1" },
            '2': { text: '实体卡', value: "2" },
            '3': { text: '虚拟卡', value: "3" },
        },
    },

    // 订单
    ORDER: {
        TYPE: {
            CHARING: 201001,
            RECHARGE: 201002,
            OCCUPY: 201004,
            CABINET: 201005,
            PURSUE: 201006,
            TRANSFER: 1,
            SERVICE: 3,
            REFUND: 4,
        },
        TYPE_MAP: {
            '1': { value: 1, text: '转账订单', statement: '其他' },
            '3': { value: 3, text: '服务费缴费订单', statement: '其他' },
            '4': { value: 4, text: '退款申请转账订单', statement: '其他' },
            '201001': { value: 201001, text: '充电订单', statement: '营业额' },
            '201002': { value: 201002, text: '充值订单', statement: '其他' },
            '201004': { value: 201004, text: '占用费订单', statement: '其他' },
            '201005': { value: 201005, text: '换电订单', statement: '其他' },
            '201006': { value: 201006, text: '欠款订单', statement: '其他' },
        },
        // 费用科目
        SUBJECT_MAP: {
            '100': { value: 100, text: '结算打款' },
            '101': { value: 101, text: '手续费' },
            '102': { value: 102, text: '结算利润' },
            '103': { value: 103, text: '充值' },
            '104': { value: 104, text: '自动转出' },
            '105': { value: 105, text: '手动提现' },
            '106': { value: 106, text: '审核未通过自动转入' },
            '107': { value: 107, text: '打款失败自动转入' },
            '108': { value: 108, text: '打款取消自动转入' },
            '109': { value: 109, text: '占用费结算' },
            '110': { value: 110, text: '运营商主动退款转出' },
            '111': { value: 111, text: '退款失败自动转入' },
            '120': { value: 120, text: '服务费' },
            '130': { value: 130, text: '电费结算' },
            '140': { value: 140, text: '虚拟账户充值' },
            '150': { value: 150, text: '主运营商预分账' },
            '180': { value: 180, text: '用户退款申请' },
            '190': { value: 190, text: '用户押金退款申请' },
            '200': { value: 200, text: '换电套餐' },
            '210': { value: 210, text: '服务费转账' },
            '220': { value: 220, text: '追款订单结算' },

            '300': { value: 300, from: 'marketing', text: '后台充值' },
            '310': { value: 310, from: 'marketing', text: '后台扣减' },
            '320': { value: 320, from: 'marketing', text: '订单退款' },
            '330': { value: 330, from: 'marketing', text: '广告奖励发放' },
            '340': { value: 340, from: 'marketing', text: '订单剩余退款' },
            '350': { value: 350, from: 'marketing', text: '订单过期退款' },
            '360': { value: 360, from: 'marketing', text: '订单结算后退款' },
        },
        // 订单退款状态 - 结算后
        REFUND_STATUS: {
            DOING: 100,           // 退款中
            ACCOUNT_SUCCESS: 200, // 虚拟账户退款成功
            ALL_SUCCESS: 400,     // 全部退款成功 App + 虚拟账号
            REFUND_FAIL: -500,    // 退款失败
        },
        REFUND_STATUS_MAP: {
            '100': { value: 100, text: '退款中',     list_text: '结算后退款中' },
            '200': { value: 200, text: '虚拟账户退款成功', list_text: '结算后退款中', hidden: true },
            '400': { value: 400, text: '退款成功',   list_text: '结算后退款完成' },
            '-500': { value: -500, text: '退款失败', list_text: '结算后退款失败' },
        },
        REFUND_STATUS_LIST: [
            { value: '', text: '全部' },
            { value: 100, text: '退款中' },
            { value: 400, text: '退款成功' },
            { value: -500, text: '退款失败' },
        ],
        REFUND_STATUS_MARK: {
            CAN_NOT_REFUND: [100, 200, 400], // 处于不可进行退款的状态

            REFUNDING: [100, 200],
            REFUND_FAIL: [-500],
        },
        // 充电曲线标签
        CHART_LABEL_MAP: {
            "0": "正常",
            "1": "充满自停判断正确",
            "2": "充满自停判断错误",
        },
        FLAG_BOOKING: {  // 是否是预约充电订单
            CHARGE: 0, // 直接充电订单
            PRECONTRACT: 1, // 预约充电订单
        },
        FLAG_BOOKING_MAP: {
            '0': { value: 0, text: '直接充电' },
            '1': { value: 1, text: '预约充电' },
        },

        // 是否支持双枪并充
        PARALLEL_CHARGE_ENABLE: {
            NO: 0,  // 禁用中
            YES: 1, // 启用中
        },
        PARALLEL_CHARGE_ENABLE_MAP: {
            '0': { value: 0, text: '禁用中' },
            '1': { value: 1, text: '启用中' },
        },

        // 辅源电压
        AUXILIARY_POWER_VOLTAGE: {
            TWELVE: 1,  // 12V
            TWENTY_FOUR: 2,  // 24V
            TWELVE_AND_TWENTY_FOUR: 3, // 12V&24V
            OTHER: 4, // 其他
        },
        AUXILIARY_POWER_VOLTAGE_MAP: {
            '1': { value: 1, text: '12V', config_text: '12V' },
            '2': { value: 2, text: '24V', config_text: '24V' },
            '3': { value: 3, text: '12V&24V', config_text: '12V&24V （双辅源可切换）' },
        },

        // 双枪并充中的辅枪、双枪并充中的辅枪
        PARALLEL_CHARGE_GUN_TYPE: {
            MAIN: 1, // 当前枪是双枪并充中的主枪
            AUXILIARY: 2, //当前枪是双枪并充中的辅枪
        },
        PARALLEL_CHARGE_GUN_TYPE_MAP: {
            '1': { value: 1, text: '主' },
            '2': { value: 2, text: '辅' },
        },
    },
    // 充电订单
    CHARGING: {
        TYPE: {
            ALL: 0,     // 全部订单
            TODAY: 1,   // 今日订单
            ERFUND: 2,  // 异常订单
            SUCCESS: 3, // 成功订单
            UNPAY: 4,   // 未支付订单
            REFUND: 5,  // 已退款订单
            PRECONTRACT: 6, // 预约订单
            POSTPAY_FAIL: 7, // 先充后付欠款订单
        },

        STATUS: {      // 订单状态
            INIT: 100,                  // 初始/待支付
            ORDER_PAY: 200,             // 支付完成
            PRE_SUCCESS: 201,           // 预约成功
            PRE_TRANSFER_CHARGE: 202,   // 预约充电转立即充电状态  过度状态
            PENDING_CONFIRM: 250,     // 待审核（设备账户充值超时需人工核实）
            OPEN_SUCCESS: 300,          // 打开开关成功/使用中
            WAITING_WX_SCORE_PAY: 380,  // 等待支付分完成支付
            ORDER_CLOSE: 400,           // 充电完成
            PRE_ORDER_CLOSE: 401,       // 预约取消
            POSTPAY_PENDING: 410,       // 待扣款
            ORDER_STOP: 500,            // 停止充电
            WAITING_CANCEL: -100,       // 待取消
            CANCEL: -200,               // 已取消
            WAITING_REFUND: -300,       // 待退款
            WAITING_PORTION_REFUND: 350,// 余额退款中
            WAITING_PORTION_REFUND_NEW: -350,   // 等待退款   待审核，订单退款会进入此状态
            COMPLETE_REFUND: -400,      // 退款完成
            POSTPAY_FAIL: -420,         // 扣款失败
            COMPLETE_REFUND_FAIL: -500, // 退款失败
            REFUND_FATAL_ERROR: -600,   // 退款中出现致命错误
            ERROR_CLOSE: -700,          // 订单关闭
        },
        STATUS_MAP: {
            '100': { value: 100, color: 'orange', text: '未支付', order: 1, show: ['service-recharge-order-list'] },
            '200': { value: 200, color: 'blue', text: '已支付', order: 1, show: ['service-recharge-order-list'] },
            '201': { value: 201, color: 'blue', text: '预约成功', order: -1, show: [] },  // 充值订单需去掉
            // '202': { value: 202, color: 'blue', text: '预约充电转立即充电状态' },
            '250': { value: 250, color: 'orange-new', text: '待审核', order: 1, show: ['service-recharge-order-list'] },
            '300': { value: 300, color: 'blue', text: '使用中', order: 1, show: [] },
            '380': { value: 380, color: 'orange', text: '待支付分支付', order: 1, show: [] },
            '400': { value: 400, color: 'green', text: '充电完成', order: 1, postpay_fail: true, show: []  },
            '401': { value: 401, color: 'orange', text: '预约取消', order: -1, show: [] },
            '410': { value: 410, color: 'orange', text: '待扣款', order: 1, show: [] },
            '500': { value: 500, color: 'orange', text: '停止充电', order: 1, show: [] },
            '-100': { value: -100, color: 'red', text: '待取消', order: 1, show: [] },
            '-200': { value: -200, color: 'grey', text: '已取消', order: 1, show: ['service-recharge-order-list'] },
            '-300': { value: -300, color: 'red', text: '待退款', order: 1, show: [] },
            '350': { value: 350, color: 'red', text: '退款中', order: 1, show: [] },
            '-350': { value: -350, color: 'red', text: '退款中', order: 1, show: ['service-recharge-order-list'] },
            '-400': { value: -400, color: 'grey', text: '退款完成', order: 1, show: ['service-recharge-order-list'] },
            '-420': { value: -420, color: 'grey', text: '扣款失败', order: 1, postpay_fail: true, show: [] },
            '-500': { value: -500, color: 'red', text: '退款失败', order: 1, show: [] },
            '-600': { value: -600, color: 'red', text: '退款错误', order: 1, show: [] },
            '-700': { value: -700, color: 'grey', text: '订单关闭', order: 1, show: [] },
        },
        STATUS_MARK: {
            NOT_FINISH: [100, 200, 201, 300, 500], // 充电中
            CAN_REFUND: [-300, 200, 300, 500], // 可(结束订单并)退款

            SHOW_POWER: [300, -300], // 展示功率曲线最后一个的数据 还是 订单详情内的数据
            CAN_CLEARING: [400, 401, -600, -420],  // 可结算

            REFUNDING: [-300, 350], // 退款中
            REFUND_FAIL: [-300, -500, -600], // 退款失败
            REFUND_SUCCESS: [400, -400], // 退款成功

            CLOSE: [400, 401]  // 充电完成  预约取消
        },
        // order_action.type
        ORDER_ACTION_TYPE: {
            WAITING_REFUND_ENTER: 21001,        // 进入待退款
            WAITING_REFUND_SETTLE: 21002,       // 待退款结束关单，data.clearing_settle_source
            WAITING_REFUND_TIMEOUT_EXIT: 21003, // 待退款超时全收关单
        },
        ORDER_ACTION_TYPE_MAP: {
            '1001': { value: 1001, text: '控制IOT设备' },
            '21001': { value: 21001, text: '订单状态变更' },
            '21002': { value: 21002, text: '订单状态变更' },
            '21003': { value: 21003, text: '订单状态变更' },
        },
        ORDER_ACTION_NAME_MAP: {
            '21001': { value: 21001, text: '进入待退款' },
            '21002': { value: 21002, text: '待退款结束关单' },
            '21003': { value: 21003, text: '待退款超时全收关单' },
        },
        // 待退款 -> 充电完成 结算来源展示映射
        // type=21002 读 data.clearing_settle_source；type=21003 固定映射为 TIMEOUT_FULL_CHARGE
        CLEARING_SETTLE_SOURCE: {
            TIMEOUT_FULL_CHARGE: 1,       // 超时全收
            ADMIN_CUSTOM_REFUND: 2,       // 管理员自定义退款
            OPERATOR_CUSTOM_REFUND: 3,    // 运营商自定义退款
            DEVICE_REPORT_FINISH: 0,      // 设备上报充电结束（仅前端默认，后端不落库）
        },
        CLEARING_SETTLE_SOURCE_MAP: {
            '0': { value: 0, text: '设备上报充电结束' },
            '1': { value: 1, text: '超时自动结束' },
            '2': { value: 2, text: '后台手动退款' },
            '3': { value: 3, text: '后台手动退款' },
        },
        CLEARING_SETTLE_SOURCE_MARK: {
            // PC 端：仅「超时自动结束」「后台手动退款」隐藏充电费用明细
            HIDE_CHARGING_DETAILS: [1, 2],
        },
        PURSUE_ORDER_STATUS: {  // 先充后付订单追款状态
            DOING: 100,
            SUCCESS: 201,
        },
        PURSUE_ORDER_STATUS_MAP: {
            '100': { value: 100, text: '追款中',   color: 'orange' },
            '201': { value: 201, text: '追款成功', color: 'green' },
        },

        POWER_MODE_MAP: {
            '1': { value: 1, text: '智能' },
            '2': { value: 2, text: '定时/定额/定量' },
            '3': { value: 3, text: '双枪同充' },
            '5': { value: 5, text: '双枪同充自适应' },
        },
        // 订单结束原因
        /**
         * 
         * 使用电费+服务费模板，15秒内收到结束包，取结束包数据结算，15秒外收到结束包，取最新的状态包结算
         * 如果是非电费+服务费模板，比如按时，按量，按功率模板，只会取状态包的数据结算
         * 
         * 
         * 如果是用户主动关闭，流程是这样的；用户在手机上点关闭充电，平台会立刻下发一条获取设备状态的命令，让设备报一条最新的状态包上来，然后过3秒 下发关闭充电的控制命令，设备上报结束包，如果结束包15秒内上不来，平台就用最新的状态包结算
         * 
         * 
         * 电费+服务费模板     结束原因带* 说明取的是结束包,如果不带*说明取的是状态包
         * 其他模板           结束原因，都是不带*的,取状态包
         */
        FINISH_CODE_MAP: {
            '0': { order: 1, value: 0, text: '正常停止' },
            '1': { order: 1, value: 1, text: '金额用完' },
            '2': { order: 1, value: 2, text: '充满自停' },
            '4': { order: 1, value: 4, text: '充电时间到' },
            '7': { order: 1, value: 7, text: '平台方强制关闭' },
            '3': { order: 1, value: 3, text: '用户主动关闭' },
            '5': { order: 1, value: 5, text: '运营商主动关闭' },
            '6': { order: 1, value: 6, text: '平台方主动关闭' },
            '8': { order: 1, value: 8, text: '用户主动关闭*' },
            '9': { order: 1, value: 9, text: '运营商主动关闭*' },
            '10':{ order: 1, value: 10,text: '平台方主动关闭*' },

            '11': { order: 1, value: 11, text: '打开失败' },
            '12': { order: 1, value: 12, text: '网关信号弱' },
            '13': { order: 1, value: 13, text: '设备信号弱' },
            '14': { order: 1, value: 14, text: '限制时段运营商关闭' },
            '101': { order: 1, value: 101, text: '过载停止' },
            '102': { order: 1, value: 102, text: '空载停止' },
            '103': { order: 1, value: 103, text: '过流停止' },
            '104': { order: 1, value: 104, text: '异常停止' },
            '105': { order: 1, value: 105, text: '过温停止' },
            '198': { order: 1, value: 198, text: '平台自动结束' },
            '201': { order: 1, value: 201, text: '超时强制关闭' },
            '202': { order: 1, value: 202, text: '超包月卡功率限制' },
            '204': { order: 1, value: 204, text: '过压停止' },
            '205': { order: 1, value: 205, text: '欠压停止' },
            '206': { order: 1, value: 206, text: '插头拔出' },
            '207': { order: 1, value: 207, text: '已达最大充电时长' },
            '208': { order: 1, value: 208, text: '功率过低', tip: "充电桩未检测到正常充电级别的功率，可能是充电器和电瓶没连接好" },

            '301': { order: 1, value: 301, text: '远程结束' },
            '302': { order: 1, value: 302, text: '刷卡主动结束' },
            '303': { order: 1, value: 303, text: '车端结束充电' },
            '304': { order: 1, value: 304, text: '漏电结束' },
            '305': { order: 1, value: 305, text: '电表通讯异常结束' },
            '306': { order: 1, value: 306, text: '拔枪停止' },
            '307': { order: 1, value: 307, text: '急停按钮按下' },
            '308': { order: 1, value: 308, text: '时间用完' },
            '309': { order: 1, value: 309, text: '电量用完' },
            '310': { order: 1, value: 310, text: '未插枪' },
            '311': { order: 1, value: 311, text: '车端未启动充电' },
            '312': { order: 1, value: 312, text: '充电桩未接地' },
            '313': { order: 1, value: 313, text: '充电桩短路' },
            '314': { order: 1, value: 314, text: '汽车充继电器粘连' },
            '315': { order: 1, value: 315, text: '汽车充计量故障' },
            '316': { order: 1, value: 316, text: 'CP电压异常' },

            '500': { order: 1, value: 500, text: "直流输出接触器粘连故障" }, // 以归至 408 启动失败[0xAD]
            '501': { order: 1, value: 501, text: "并联接触器粘连故障" },    // 以归至 424 异常中止[0xBC]
            '502': { order: 1, value: 502, text: "TCU与CCU通讯故障" },     // 以归至 394 启动失败[0xA3]
            '503': { order: 1, value: 503, text: "充电接口过温度故障" },    // 以归至 401 异常中止[0xA9]
            '504': { order: 1, value: 504, text: "烟感告警" },
            '505': { order: 1, value: 505, text: "设备倾倒" },

            '901': { order: 1, value: 901, text: 'APP远程停止' },
            '902': { order: 1, value: 902, text: 'SOC达到100(已充满)' },
            '903': { order: 1, value: 903, text: '电量用完' },
            '904': { order: 1, value: 904, text: '金额用完' },
            '905': { order: 1, value: 905, text: '时间用完' },
            '906': { order: 1, value: 906, text: '手动停止' },
            '907': { order: 4, value: 907, text: "异常中止[0x6B]", tip: "导引断开" },
            '908': { order: 4, value: 908, text: "异常中止[0x6D]", tip: "电表通信中断" },
            '909': { order: 4, value: 909, text: "异常中止[0x6E]", tip: "余额不足" },
            '910': { order: 4, value: 910, text: "异常中止[0x6F]", tip: "交流保护动作" },
            '911': { order: 6, value: 911, text: "异常中止[0x72]", tip: "急停开入" },
            '912': { order: 6, value: 912, text: "异常中止[0x74]", tip: "温度异常" },
            '913': { order: 6, value: 913, text: "异常中止[0x76]", tip: "充电无流" },
            '914': { order: 6, value: 914, text: "异常中止[0x79]", tip: "总充电电压异常" },
            '915': { order: 6, value: 915, text: "异常中止[0x7A]", tip: "总充电电流异常" },
            '916': { order: 6, value: 916, text: "异常中止[0x83]", tip: "充电桩断电" },
            '917': { order: 1, value: 917, text: '设置充电费率失败' },
            '918': { order: 1, value: 918, text: '其他' },

            '1031': { order: 2, value: 1031, text: "BMS正常终止充电" },
            '1032': { order: 2, value: 1032, text: "达到所需SOC目标(BST)" },
            '1033': { order: 2, value: 1033, text: "达到单体电压的设定值" },
            '1034': { order: 2, value: 1034, text: "达到总电压的设定值" },
            '1035': { order: 2, value: 1035, text: "BMS主动终止充电(BSM报文)" },
            '1036': { order: 2, value: 1036, text: "达到用户设定的SOC目标值 80%" },
            '1037': { order: 2, value: 1037, text: "达到用户设定的SOC目标值 85%" },
            '1038': { order: 2, value: 1038, text: "达到用户设定的SOC目标值 90%" },
            '1039': { order: 2, value: 1039, text: "达到用户设定的SOC目标值 95%" },

            '926': { order: 3, value: 926, text: "启动失败[0x4A]", tip: "充电桩控制系统故障" },
            '927': { order: 3, value: 927, text: "启动失败[0x4B]", tip: "控制导引断开" },
            '928': { order: 3, value: 928, text: "启动失败[0x4C]", tip: "断路器跳位" },
            '929': { order: 3, value: 929, text: "启动失败[0x4D]", tip: "电表通信中断" },
            '930': { order: 3, value: 930, text: "启动失败[0x4E]", tip: "余额不足" },
            '931': { order: 3, value: 931, text: "启动失败[0x4F]", tip: "充电模块故障" },
            '932': { order: 3, value: 932, text: "启动失败[0x50]", tip: "急停开入" },
            '933': { order: 3, value: 933, text: "启动失败[0x51]", tip: "防雷器异常" },
            '934': { order: 3, value: 934, text: "启动失败[0x52]", tip: "BMS 未就绪" },
            '935': { order: 3, value: 935, text: "启动失败[0x53]", tip: "温度异常" },
            '936': { order: 3, value: 936, text: "启动失败[0x54]", tip: "电池反接故障" },
            '937': { order: 3, value: 937, text: "启动失败[0x55]", tip: "电子锁异常" },
            '938': { order: 3, value: 938, text: "启动失败[0x56]", tip: "合闸失败" },
            '939': { order: 3, value: 939, text: "启动失败[0x57]", tip: "绝缘异常" },
            '940': { order: 3, value: 940, text: "启动失败[0x58]", tip: "预留" },
            '941': { order: 3, value: 941, text: "启动失败[0x59]", tip: "接收 BMS 握手报文 BHM 超时" },
            '942': { order: 3, value: 942, text: "启动失败[0x5A]", tip: "接收 BMS 和车辆的辨识报文超时 BRM" },
            '943': { order: 3, value: 943, text: "启动失败[0x5B]", tip: "接收电池充电参数报文超时 BCP" },
            '944': { order: 3, value: 944, text: "启动失败[0x5C]", tip: "接收 BMS 完成充电准备报文超时 BRO AA" },
            '945': { order: 3, value: 945, text: "启动失败[0x5D]", tip: "接收电池充电总状态报文超时 BCS" },
            '946': { order: 3, value: 946, text: "启动失败[0x5E]", tip: "接收电池充电要求报文超时 BCL" },
            '947': { order: 3, value: 947, text: "启动失败[0x5F]", tip: "接收电池状态信息报文超时 BSM" },
            '948': { order: 3, value: 948, text: "启动失败[0x60]", tip: "GB2015 电池在BHM 阶段有电压不允许充电" },
            '949': { order: 3, value: 949, text: "启动失败[0x61]", tip: "GB2015 辨识阶段在 BRO_AA 时候电池实际电压与 BCP 报文电池电压差距大于 5%" },
            '950': { order: 3, value: 950, text: "启动失败[0x62]", tip: "B2015 充电机在预充电阶段从 BRO_AA 变成BRO_00 状态" },
            '951': { order: 3, value: 951, text: "启动失败[0x63]", tip: "接收主机配置报文超时" },
            '952': { order: 3, value: 952, text: "启动失败[0x64]", tip: "充电机未准备就绪,我们没有回 CRO AA，对应老国标" },

            '953': { order: 4, value: 953, text: "异常中止[0x6A]", tip: "系统闭锁" },
            '954': { order: 4, value: 954, text: "异常中止[0x6C]", tip: "断路器跳位" },
            '955': { order: 5, value: 955, text: "异常中止[0x70]", tip: "直流保护动作" },
            '956': { order: 6, value: 956, text: "异常中止[0x71]", tip: "充电模块故障" },
            '957': { order: 6, value: 957, text: "异常中止[0x73]", tip: "防雷器异常" },
            '958': { order: 6, value: 958, text: "异常中止[0x75]", tip: "输出异常" },
            '959': { order: 6, value: 959, text: "异常中止[0x77]", tip: "电子锁异常" },
            '960': { order: 6, value: 960, text: "异常中止[0x78]", tip: "预留" },
            '961': { order: 6, value: 961, text: "异常中止[0x7B]", tip: "单体充电电压异常" },
            '962': { order: 6, value: 962, text: "异常中止[0x7C]", tip: "电池组过温" },
            '963': { order: 6, value: 963, text: "异常中止[0x7D]", tip: "最高单体充电电压异常" },
            '964': { order: 6, value: 964, text: "异常中止[0x7E]", tip: "最高电池组过温" },
            '965': { order: 6, value: 965, text: "异常中止[0x7F]", tip: "BMV 单体充电电压异常" },
            '966': { order: 6, value: 966, text: "异常中止[0x80]", tip: "BMT 电池组过温" },
            '967': { order: 6, value: 967, text: "异常中止[0x81]", tip: "电池状态异常停止充电" },
            '968': { order: 6, value: 968, text: "异常中止[0x82]", tip: "车辆发报文禁止充电" },
            '969': { order: 6, value: 969, text: "异常中止[0x84]", tip: "接收电池充电总状态报文超时" },
            '970': { order: 6, value: 970, text: "异常中止[0x85]", tip: "接收电池充电要求报文超时" },
            '971': { order: 6, value: 971, text: "异常中止[0x86]", tip: "接收电池状态信息报文超时" },
            '972': { order: 6, value: 972, text: "异常中止[0x87]", tip: "接收 BMS 中止充电报文超时" },
            '973': { order: 6, value: 973, text: "异常中止[0x88]", tip: "接收 BMS 充电统计报文超时" },
            '974': { order: 6, value: 974, text: "异常中止[0x89]", tip: "接收对侧 CCS 报文超时" },
            '975': { order: 6, value: 975, text: "异常中止[0xA0]", tip: 'TCU&CCU通讯超时' },
            '976': { order: 6, value: 976, text: "异常中止[0xA1]", tip: '功率模组故障' },
            '977': { order: 6, value: 977, text: "异常中止[0xA2]", tip: '仓门开启结束充电' },
            '978': { order: 3, value: 978, text: "启动失败[0xA3]", tip: 'TCU与CCU通讯故障' },
            '979': { order: 3, value: 979, text: "启动失败[0xA4]", tip: '直流输出短路故障' },
            '980': { order: 6, value: 980, text: "异常中止[0xA5]", tip: '充电桩充电中暂停超时' },
            '981': { order: 6, value: 981, text: "异常中止[0xA6]", tip: 'BSM 报文中充电过电流' },
            '982': { order: 6, value: 982, text: "异常中止[0xA7]", tip: 'BSM 报文中动力蓄电池绝缘状态异常' },
            '983': { order: 6, value: 983, text: "异常中止[0xA8]", tip: 'BSM 报文中连接器连接状态异常' },
            '984': { order: 6, value: 984, text: "异常中止[0xA9]", tip: '充电接口过温故障' },
            '985': { order: 3, value: 985, text: "启动失败[0xAA]", tip: 'BMS未就绪(空闲下收到BEM)' },
            '986': { order: 3, value: 986, text: "启动失败[0xAB]", tip: 'BMS通讯故障(不能收到BMS任何报文）' },
            '987': { order: 3, value: 987, text: "启动失败[0xAC]", tip: 'BRM报文接收超时 (BRM报文不能收全）' },
            '988': { order: 3, value: 988, text: "启动失败[0xAD]", tip: '直流输出接触器粘连故障' },
            '989': { order: 3, value: 989, text: "启动失败[0xAE]", tip: '并联接触器据动/误动故障' },
            '990': { order: 3, value: 990, text: "启动失败[0xAF]", tip: '预充时功率模组电压无输出' },
            '991': { order: 6, value: 991, text: "异常中止[0xB0]", tip: 'TCU与CCU通讯故障' },
            '992': { order: 6, value: 992, text: "异常中止[0xB1]", tip: '设备倾倒' },
            '993': { order: 6, value: 993, text: "异常中止[0xB2]", tip: '烟感告警' },
            '994': { order: 6, value: 994, text: "异常中止[0xB3]", tip: 'CC1电压异常' },
            '995': { order: 6, value: 995, text: "异常中止[0xB4]", tip: "TCU与功率模组通讯故障" },
            '996': { order: 3, value: 996, text: "启动失败[0xB5]", tip: "TCU与功率模组通讯故障" },
            '997': { order: 3, value: 997, text: "启动失败[0xB6]", tip: "绝缘检测时功率模组电压无输出" },
            '998': { order: 3, value: 998, text: "启动失败[0xB7]", tip: "充电枪温度故障" },
            '999': { order: 3, value: 999, text: "启动失败[0xB8]", tip: "BCP最高允许充电总电压不在桩输出电压范围内" },
            '1000': { order: 3, value: 1000, text: "启动失败[0xB9]", tip: "电池电压大于电池最高允许充电电压(BCP报文)" },
            '1001': { order: 3, value: 1001, text: "启动失败[0xBA]", tip: "柜门开启" },
            '1002': { order: 6, value: 1002, text: "异常中止[0xBB]", tip: "并联接触器据动/误动故障" },
            '1003': { order: 6, value: 1003, text: "异常中止[0xBC]", tip: "并联接触器黏连故障" },
            '1004': { order: 6, value: 1004, text: "异常中止[0xBD]", tip: "BMS绝缘故障(BST报文故障)" },
            '1005': { order: 6, value: 1005, text: "异常中止[0xBE]", tip: "输出连接器过温故障(BST报文故障)" },
            '1006': { order: 6, value: 1006, text: "异常中止[0xBF]", tip: "BMS元件过温故障(BST报文故障)" },
            '1007': { order: 6, value: 1007, text: "异常中止[0xC0]", tip: "充电连接器故障(BST报文故障)" },
            '1008': { order: 6, value: 1008, text: "异常中止[0xC1]", tip: "电池组温度过高故障(BST报文故障)" },
            '1009': { order: 6, value: 1009, text: "异常中止[0xC2]", tip: "高压继电器故障(BST报文故障)" },
            '1010': { order: 6, value: 1010, text: "异常中止[0xC3]", tip: "检测点2电压故障(BST报文故障)" },
            '1011': { order: 6, value: 1011, text: "异常中止[0xC4]", tip: "电流过大故障(BST报文故障)" },
            '1012': { order: 6, value: 1012, text: "异常中止[0xC5]", tip: "电压异常故障(BST报文故障)" },
            '1044': { order: 6, value: 1044, text: "启动失败[0xC6]", tip: "VIN码获取失败" },
            '1045': { order: 6, value: 1045, text: "启动失败[0xC7]", tip: "TCU&CCU充电状态不一致" },
            '1013': { order: 6, value: 1013, text: "异常中止[0xC9]", tip: "水浸告警结束" },
            '1014': { order: 6, value: 1014, text: "异常中止[0xCA]", tip: "枪借用PDU故障" },
            '1015': { order: 6, value: 1015, text: "异常中止[0xCB]", tip: "枪借用模块故障" },
            '1016': { order: 6, value: 1016, text: "异常中止[0xCC]", tip: "枪关联PDU故障" },
            '1017': { order: 6, value: 1017, text: "异常中止[0xCD]", tip: "功率柜门开启" },
            '1018': { order: 6, value: 1018, text: "异常中止[0xCE]", tip: "功率柜急停按下" },
            '1019': { order: 6, value: 1019, text: "异常中止[0xCF]", tip: "功率柜水浸告警" },
            '1020': { order: 6, value: 1020, text: "异常中止[0xD1]", tip: "功率柜烟感告警" },
            '1021': { order: 6, value: 1021, text: "异常中止[0xD2]", tip: "功率柜CAN通讯异常" },
            '1022': { order: 6, value: 1022, text: "异常中止[0xD3]", tip: "功率柜防雷告警" },
            '1023': { order: 6, value: 1023, text: "异常中止[0xD4]", tip: "功率柜接触器断开" },
            '1024': { order: 3, value: 1024, text: "启动失败[0xD5]", tip: '交流接触器拒动误动' },
            '1046': { order: 3, value: 1046, text: "启动失败[0xD6]", tip: "电表反装" },
            '1025': { order: 3, value: 1025, text: "启动失败[0xD7]", tip: "绝缘检测完成后功率模块泄放失败" },
            '1026': { order: 3, value: 1026, text: "启动失败[0xD8]", tip: "绝缘启动前模组输出释放失败" },
            '1027': { order: 3, value: 1027, text: "启动失败[0xD9]", tip: "绝缘启动时模块正常有输出电表检测不到电压" },
            '1028': { order: 3, value: 1028, text: "启动失败[0xDA]", tip: "预充时电表检测到电池电压不在桩允许范围内" },
            '1029': { order: 3, value: 1029, text: "异常中止[0xDB]", tip: "充电中，电表采集到的电流大于bms需求电流值" },
            '1030': { order: 3, value: 1030, text: "启动失败[0xDF]", tip: "桩最小输出大于车的最大需求" },

            '320': { order: 2, value: 320, text: "APP远程停止" },
            '321': { order: 2, value: 321, text: "SOC达到100(已充满)" },
            '322': { order: 2, value: 322, text: "电量用完" },
            '323': { order: 2, value: 323, text: "金额用完" },
            '324': { order: 2, value: 324, text: "时间用完" },
            '325': { order: 2, value: 325, text: "手动停止" },
            '402': { order: 2, value: 402, text: "BMS正常终止充电" },
            '403': { order: 2, value: 403, text: "达到所需SOC目标(BST)" },
            '404': { order: 2, value: 404, text: "达到单体电压的设定值" },

            // soc满(达到设定值)停止
            '701': { order: 2, value: 701, text: "达到用户设定的SOC目标值 80%" },
            '702': { order: 2, value: 702, text: "达到用户设定的SOC目标值 85%" },
            '703': { order: 2, value: 703, text: "达到用户设定的SOC目标值 90%" },
            '704': { order: 2, value: 704, text: "达到用户设定的SOC目标值 95%" },

            '800': { order: 2, value: 800, text: "达到所需SOC目标值(BST)" },
            '801': { order: 2, value: 801, text: "达到总电压的设定值" },
            '802': { order: 2, value: 802, text: "BMS主动终止充电(BSM报文)" },

            '329': { order: 3, value: 329, text: "启动失败[0x4A]", tip: "充电桩控制系统故障" },
            '330': { order: 3, value: 330, text: "启动失败[0x4B]", tip: "控制导引断开" },
            '331': { order: 3, value: 331, text: "启动失败[0x4C]", tip: "断路器跳位" },
            '332': { order: 3, value: 332, text: "启动失败[0x4D]", tip: "电表通信中断" },
            '333': { order: 3, value: 333, text: "启动失败[0x4E]", tip: "余额不足" },
            '334': { order: 3, value: 334, text: "启动失败[0x4F]", tip: "充电模块故障" },
            '335': { order: 3, value: 335, text: "启动失败[0x50]", tip: "急停开入" },
            '336': { order: 3, value: 336, text: "启动失败[0x51]", tip: "防雷器异常" },
            '337': { order: 3, value: 337, text: "启动失败[0x52]", tip: "BMS 未就绪" },
            '338': { order: 3, value: 338, text: "启动失败[0x53]", tip: "温度异常" },
            '339': { order: 3, value: 339, text: "启动失败[0x54]", tip: "电池反接故障" },
            '340': { order: 3, value: 340, text: "启动失败[0x55]", tip: "电子锁异常" },
            '341': { order: 3, value: 341, text: "启动失败[0x56]", tip: "合闸失败" },
            '342': { order: 3, value: 342, text: "启动失败[0x57]", tip: "绝缘异常" },
            '343': { order: 3, value: 343, text: "启动失败[0x58]", tip: "预留" },
            '344': { order: 3, value: 344, text: "启动失败[0x59]", tip: "接收 BMS 握手报文 BHM 超时" },
            '345': { order: 3, value: 345, text: "启动失败[0x5A]", tip: "接收 BMS 和车辆的辨识报文超时 BRM" },
            '346': { order: 3, value: 346, text: "启动失败[0x5B]", tip: "接收电池充电参数报文超时 BCP" },
            '347': { order: 3, value: 347, text: "启动失败[0x5C]", tip: "接收 BMS 完成充电准备报文超时 BRO AA" },
            '348': { order: 3, value: 348, text: "启动失败[0x5D]", tip: "接收电池充电总状态报文超时 BCS" },
            '349': { order: 3, value: 349, text: "启动失败[0x5E]", tip: "接收电池充电要求报文超时 BCL" },
            '350': { order: 3, value: 350, text: "启动失败[0x5F]", tip: "接收电池状态信息报文超时 BSM" },
            '351': { order: 3, value: 351, text: "启动失败[0x60]", tip: "GB2015 电池在BHM 阶段有电压不允许充电" },
            '352': { order: 3, value: 352, text: "启动失败[0x61]", tip: "GB2015 辨识阶段在 BRO_AA 时候电池实际电压与 BCP 报文电池电压差距大于 5%" },
            '353': { order: 3, value: 353, text: "启动失败[0x62]", tip: "B2015 充电机在预充电阶段从 BRO_AA 变成BRO_00 状态" },
            '354': { order: 3, value: 354, text: "启动失败[0x63]", tip: "接收主机配置报文超时" },
            '355': { order: 3, value: 355, text: "启动失败[0x64]", tip: "充电机未准备就绪,我们没有回 CRO AA，对应老国标" },
            '394': { order: 3, value: 394, text: "启动失败[0xA3]", tip: 'TCU与CCU通讯故障' },
            '395': { order: 3, value: 395, text: "启动失败[0xA4]", tip: '直流输出短路故障' },
            '405': { order: 3, value: 405, text: "启动失败[0xAA]", tip: 'BMS未就绪(空闲下收到BEM)' },
            '406': { order: 3, value: 406, text: "启动失败[0xAB]", tip: 'BMS通讯故障(不能收到BMS任何报文）' },
            '407': { order: 3, value: 407, text: "启动失败[0xAC]", tip: 'BRM报文接收超时 (BRM报文不能收全）' },
            '408': { order: 3, value: 408, text: "启动失败[0xAD]", tip: '直流输出接触器粘连故障' },
            '409': { order: 3, value: 409, text: "启动失败[0xAE]", tip: '并联接触器据动/误动故障' },
            '410': { order: 3, value: 410, text: "启动失败[0xAF]", tip: '预充时功率模组电压无输出' },
            '417': { order: 3, value: 417, text: "启动失败[0xB5]", tip: "TCU与功率模组通讯故障" },
            '418': { order: 3, value: 418, text: "启动失败[0xB6]", tip: "绝缘检测时功率模组电压无输出" },
            '419': { order: 3, value: 419, text: "启动失败[0xB7]", tip: "充电枪温度故障" },
            '420': { order: 3, value: 420, text: "启动失败[0xB8]", tip: "BCP最高允许充电总电压不在桩输出电压范围内" },
            '421': { order: 3, value: 421, text: "启动失败[0xB9]", tip: "电池电压大于电池最高允许充电电压(BCP报文)" },
            '422': { order: 3, value: 422, text: "启动失败[0xBA]", tip: "柜门开启" },
            '434': { order: 3, value: 434, text: "启动失败[0xC6]", tip: "VIN码获取失败" },
            '435': { order: 3, value: 435, text: "启动失败[0xC7]", tip: "TCU&CCU充电状态不一致" },

            '508': { order: 3, value: 508, text: "启动失败[0xD5]", tip: '交流接触器拒动误动' },
            '616': { order: 3, value: 616, text: "启动失败[0xD6]", tip: "电表反装" },
            '920': { order: 3, value: 920, text: "启动失败[0xD7]", tip: "绝缘检测完成后功率模块泄放失败" },
            '921': { order: 3, value: 921, text: "启动失败[0xD8]", tip: "绝缘启动前模组输出释放失败" },
            '922': { order: 3, value: 922, text: "启动失败[0xD9]", tip: "绝缘启动时模块正常有输出电表检测不到电压" },
            '923': { order: 3, value: 923, text: "启动失败[0xDA]", tip: "预充时电表检测到电池电压不在桩允许范围内" },
            '924': { order: 3, value: 924, text: "异常中止[0xDB]", tip: "充电中，电表采集到的电流大于bms需求电流值" },
            '925': { order: 3, value: 925, text: "启动失败[0xDF]", tip: "桩最小输出大于车的最大需求" },

            '1040': { order: 6, value: 1040, text: "异常中止[0xC8]", tip: "TCU&CCU充电状态不一致" },
            '1041': { order: 3, value: 1041, text: "启动失败[0xDE]", tip: "充电启动失败，绝缘检测无可用模块" },
            '1042': { order: 6, value: 1042, text: "异常中止[0xC8]", tip: "ykc-TCU&CCU充电状态不一致" },
            '1043': { order: 3, value: 1043, text: "启动失败[0xDE]", tip: "ykc-充电启动失败，绝缘检测无可用模块" },

            '360': { order: 4, value: 360, text: "异常中止[0x6A]", tip: "系统闭锁" },
            '361': { order: 4, value: 361, text: "异常中止[0x6B]", tip: "导引断开" },
            '362': { order: 4, value: 362, text: "异常中止[0x6C]", tip: "断路器跳位" },
            '363': { order: 4, value: 363, text: "异常中止[0x6D]", tip: "电表通信中断" },
            '364': { order: 4, value: 364, text: "异常中止[0x6E]", tip: "余额不足" },
            '365': { order: 4, value: 365, text: "异常中止[0x6F]", tip: "交流保护动作" },
            '415': { order: 5, value: 415, text: "异常中止[0x70]", tip: "直流保护动作" },
            '366': { order: 6, value: 366, text: "异常中止[0x71]", tip: "充电模块故障" },
            '367': { order: 6, value: 367, text: "异常中止[0x72]", tip: "急停开入" },
            '368': { order: 6, value: 368, text: "异常中止[0x73]", tip: "防雷器异常" },
            '369': { order: 6, value: 369, text: "异常中止[0x74]", tip: "温度异常" },
            '370': { order: 6, value: 370, text: "异常中止[0x75]", tip: "输出异常" },
            '371': { order: 6, value: 371, text: "异常中止[0x76]", tip: "充电无流" },
            '372': { order: 6, value: 372, text: "异常中止[0x77]", tip: "电子锁异常" },
            '373': { order: 6, value: 373, text: "异常中止[0x78]", tip: "预留" },
            '374': { order: 6, value: 374, text: "异常中止[0x79]", tip: "总充电电压异常" },
            '375': { order: 6, value: 375, text: "异常中止[0x7A]", tip: "总充电电流异常" },
            '376': { order: 6, value: 376, text: "异常中止[0x7B]", tip: "单体充电电压异常" },
            '377': { order: 6, value: 377, text: "异常中止[0x7C]", tip: "电池组过温" },
            '378': { order: 6, value: 378, text: "异常中止[0x7D]", tip: "最高单体充电电压异常" },
            '379': { order: 6, value: 379, text: "异常中止[0x7E]", tip: "最高电池组过温" },
            '380': { order: 6, value: 380, text: "异常中止[0x7F]", tip: "BMV 单体充电电压异常" },
            '381': { order: 6, value: 381, text: "异常中止[0x80]", tip: "BMT 电池组过温" },
            '382': { order: 6, value: 382, text: "异常中止[0x81]", tip: "电池状态异常停止充电" },
            '383': { order: 6, value: 383, text: "异常中止[0x82]", tip: "车辆发报文禁止充电" },
            '384': { order: 6, value: 384, text: "异常中止[0x83]", tip: "充电桩断电" },
            '385': { order: 6, value: 385, text: "异常中止[0x84]", tip: "接收电池充电总状态报文超时" },
            '386': { order: 6, value: 386, text: "异常中止[0x85]", tip: "接收电池充电要求报文超时" },
            '387': { order: 6, value: 387, text: "异常中止[0x86]", tip: "接收电池状态信息报文超时" },
            '388': { order: 6, value: 388, text: "异常中止[0x87]", tip: "接收 BMS 中止充电报文超时" },
            '389': { order: 6, value: 389, text: "异常中止[0x88]", tip: "接收 BMS 充电统计报文超时" },
            '390': { order: 6, value: 390, text: "异常中止[0x89]", tip: "接收对侧 CCS 报文超时" },
            '391': { order: 6, value: 391, text: "异常中止[0xA0]", tip: 'TCU&CCU通讯超时' },
            '392': { order: 6, value: 392, text: "异常中止[0xA1]", tip: '功率模组故障' },
            '393': { order: 6, value: 393, text: "异常中止[0xA2]", tip: '仓门开启结束充电' },
            '396': { order: 6, value: 396, text: "异常中止[0xA5]", tip: '充电桩充电中暂停超时' },
            '397': { order: 6, value: 397, text: "异常中止[0xA6]", tip: 'BSM 报文中充电过电流' },
            '398': { order: 6, value: 398, text: "异常中止[0xA7]", tip: 'BSM 报文中动力蓄电池绝缘状态异常' },
            '399': { order: 6, value: 399, text: "异常中止[0xA8]", tip: 'BSM 报文中连接器连接状态异常' },
            '401': { order: 6, value: 401, text: "异常中止[0xA9]", tip: '充电接口过温故障' },
            '411': { order: 6, value: 411, text: "异常中止[0xB0]", tip: 'TCU与CCU通讯故障' },
            '412': { order: 6, value: 412, text: "异常中止[0xB1]", tip: '设备倾倒' },
            '413': { order: 6, value: 413, text: "异常中止[0xB2]", tip: '烟感告警' },
            '414': { order: 6, value: 414, text: "异常中止[0xB3]", tip: 'CC1电压异常' },
			'416': { order: 6, value: 416, text: "异常中止[0xB4]", tip: "TCU与功率模组通讯故障" },

            '423': { order: 6, value: 423, text: "异常中止[0xBB]", tip: "并联接触器据动/误动故障" },
            '424': { order: 6, value: 424, text: "异常中止[0xBC]", tip: "并联接触器黏连故障" },
            '425': { order: 6, value: 425, text: "异常中止[0xBD]", tip: "BMS绝缘故障(BST报文故障)" },
            '426': { order: 6, value: 426, text: "异常中止[0xBE]", tip: "输出连接器过温故障(BST报文故障)" },
            '427': { order: 6, value: 427, text: "异常中止[0xBF]", tip: "BMS元件过温故障(BST报文故障)" },
            '428': { order: 6, value: 428, text: "异常中止[0xC0]", tip: "充电连接器故障(BST报文故障)" },
            '429': { order: 6, value: 429, text: "异常中止[0xC1]", tip: "电池组温度过高故障(BST报文故障)" },
            '430': { order: 6, value: 430, text: "异常中止[0xC2]", tip: "高压继电器故障(BST报文故障)" },
            '431': { order: 6, value: 431, text: "异常中止[0xC3]", tip: "检测点2电压故障(BST报文故障)" },
            '432': { order: 6, value: 432, text: "异常中止[0xC4]", tip: "电流过大故障(BST报文故障)" },
            '433': { order: 6, value: 433, text: "异常中止[0xC5]", tip: "电压异常故障(BST报文故障)" },

            '919': { order: 6, value: 919, text: "异常中止[0xC9]", tip: "水浸告警结束" },
            '605': { order: 6, value: 605, text: "异常中止[0xCA]", tip: "枪借用PDU故障" },
            '606': { order: 6, value: 606, text: "异常中止[0xCB]", tip: "枪借用模块故障" },
            '607': { order: 6, value: 607, text: "异常中止[0xCC]", tip: "枪关联PDU故障" },
            '608': { order: 6, value: 608, text: "异常中止[0xCD]", tip: "功率柜门开启" },
            '610': { order: 6, value: 610, text: "异常中止[0xCE]", tip: "功率柜急停按下" },
            '611': { order: 6, value: 611, text: "异常中止[0xCF]", tip: "功率柜水浸告警" },
            '612': { order: 6, value: 612, text: "异常中止[0xD1]", tip: "功率柜烟感告警" },
            '613': { order: 6, value: 613, text: "异常中止[0xD2]", tip: "功率柜CAN通讯异常" },
            '614': { order: 6, value: 614, text: "异常中止[0xD3]", tip: "功率柜防雷告警" },
            '615': { order: 6, value: 615, text: "异常中止[0xD4]", tip: "功率柜接触器断开" },

            '601': { order: 7, value: 601, text: '道闸异常' },
            '602': { order: 7, value: 602, text: '道闸电机故障' },
            '603': { order: 7, value: 603, text: '道闸通讯故障' },
            '604': { order: 7, value: 604, text: "接线座过温停止" },

            '400': { order: 99, value: 400, text: "未知原因停止" },
        },
        FINISH_CODE_MARK: {
            HAVE_ASTERISK: [8, 9, 10], // 有*号
        },
        FINISH_CODE_NEW_MAP: [
            {
                label: '通用',
                value: 'current',
                selectable: false,
                children: [
                    { value: '3',   label: '用户主动关闭' },
                    { value: '5',   label: '运营商主动关闭' },
                    { value: '6',   label: '平台方主动关闭' },
                    { value: '7',   label: '平台方强制关闭' },
                    { value: '198', label: '平台自动结束' },
                    { value: '201', label: '超时强制关闭' },
                    { value: '8',   label: '用户主动关闭*' },
                    { value: '9',   label: '运营商主动关闭*' },
                    { value: '10',  label: '平台方主动关闭*' },
                    { value: '11',  label: '打开失败' },
                    { value: '1',   label: '金额用完' },
                    { value: '101', label: '过载停止' },
                    { value: '102', label: '空载停止' },
                    { value: '105', label: '过温停止' },
                    { value: '204', label: '过压停止' },
                    { value: '205', label: '欠压停止' },
                    { value: '14', label: '限制时段运营商关闭' },
                ]
            },
            {
                label: '两轮',
                value: 'plug',
                selectable: false,
                children: [
                    { value: '0',   label: '正常停止' },
                    { value: '2',   label: '充满自停' },
                    { value: '4',   label: '充电时间到' },
                    { value: '12',  label: '网关信号弱' },
                    { value: '13',  label: '设备信号弱' },
                    { value: '103', label: '过流停止' },
                    { value: '104', label: '异常停止' },
                    { value: '202', label: '超包月卡功率限制' },
                    { value: '206', label: '插头拔出' },
                    { value: '207', label: '已达最大充电时长' },
                    { value: '208', label: '功率过低' },
                ]
            },
            {
                label: '汽车-交流',
                value: 'carac',
                selectable: false,
                children: [
                    { value: '301', label: '远程结束' },
                    { value: '302', label: '刷卡主动结束' },
                    { value: '303', label: '车端结束充电' },
                    { value: '304', label: '漏电结束' },
                    { value: '305', label: '电表通讯异常结束' },
                    { value: '306', label: '拔枪停止' },
                    { value: '307', label: '急停按钮按下' },
                    { value: '308', label: '时间用完' },
                    { value: '309', label: '电量用完' },
                    { value: '310', label: '未插枪' },
                    { value: '311', label: '车端未启动充电' },
                    { value: '312', label: '充电桩未接地' },
                    { value: '313', label: '充电桩短路' },
                    { value: '314', label: '汽车充继电器粘连' },
                    { value: '315', label: '汽车充计量故障' },
                    { value: '316', label: 'CP电压异常' },

                    { value: '601', label: '道闸异常' },
                    { value: '602', label: '道闸电机故障' },
                    { value: '603', label: '道闸通讯故障' },
                    { value: '604', label: '接线座过温停止' },
                    { value: '504', label: '烟感告警' },
                    { value: '505', label: '设备倾倒' },
                ]
            },
            {
                label: '汽车-直流',
                value: 'cardc',
                selectable: false,
                children: [
                    { value: '320', label: 'APP远程停止' },
                    { value: '321', label: 'SOC达到100' },
                    { value: '322', label: '电量用完' },
                    { value: '323', label: '金额用完' },
                    { value: '324', label: '时间用完' },
                    { value: '325', label: '手动停止' },
                    { value: '402', label: 'BMS正常终止充电' },
                    { value: '403', label: '达到所需SOC目标(BST)' },
                    { value: '404', label: '达到单体电压的设定值' },

                    { value: '800', label: '达到所需SOC目标值(BST)' },
                    { value: '801', label: '达到总电压的设定值' },
                    { value: '802', label: 'BMS主动终止充电(BSM报文)' },

                    // soc满(达到设定值)停止
                    { value: '701', label: '达到用户设定的SOC目标值 80%' },
                    { value: '702', label: '达到用户设定的SOC目标值 85%' },
                    { value: '703', label: '达到用户设定的SOC目标值 90%' },
                    { value: '704', label: '达到用户设定的SOC目标值 95%' },

                    { value: '329', label: '启动失败[0x4A]', scopedSlots: { title: 'tooltip' } },
                    { value: '330', label: '启动失败[0x4B]', scopedSlots: { title: 'tooltip' } },
                    { value: '331', label: '启动失败[0x4C]', scopedSlots: { title: 'tooltip' } },
                    { value: '332', label: '启动失败[0x4D]', scopedSlots: { title: 'tooltip' } },
                    { value: '333', label: '启动失败[0x4E]', scopedSlots: { title: 'tooltip' } },
                    { value: '334', label: '启动失败[0x4F]', scopedSlots: { title: 'tooltip' } },
                    { value: '335', label: '启动失败[0x50]', scopedSlots: { title: 'tooltip' } },
                    { value: '336', label: '启动失败[0x51]', scopedSlots: { title: 'tooltip' } },
                    { value: '337', label: '启动失败[0x52]', scopedSlots: { title: 'tooltip' } },
                    { value: '338', label: '启动失败[0x53]', scopedSlots: { title: 'tooltip' } },
                    { value: '339', label: '启动失败[0x54]', scopedSlots: { title: 'tooltip' } },
                    { value: '340', label: '启动失败[0x55]', scopedSlots: { title: 'tooltip' } },
                    { value: '341', label: '启动失败[0x56]', scopedSlots: { title: 'tooltip' } },
                    { value: '342', label: '启动失败[0x57]', scopedSlots: { title: 'tooltip' } },
                    { value: '343', label: '启动失败[0x58]', scopedSlots: { title: 'tooltip' } },
                    { value: '344', label: '启动失败[0x59]', scopedSlots: { title: 'tooltip' } },
                    { value: '345', label: '启动失败[0x5A]', scopedSlots: { title: 'tooltip' } },
                    { value: '346', label: '启动失败[0x5B]', scopedSlots: { title: 'tooltip' } },
                    { value: '347', label: '启动失败[0x5C]', scopedSlots: { title: 'tooltip' } },
                    { value: '348', label: '启动失败[0x5D]', scopedSlots: { title: 'tooltip' } },
                    { value: '349', label: '启动失败[0x5E]', scopedSlots: { title: 'tooltip' } },
                    { value: '350', label: '启动失败[0x5F]', scopedSlots: { title: 'tooltip' } },
                    { value: '351', label: '启动失败[0x60]', scopedSlots: { title: 'tooltip' } },
                    { value: '352', label: '启动失败[0x61]', scopedSlots: { title: 'tooltip' } },
                    { value: '353', label: '启动失败[0x62]', scopedSlots: { title: 'tooltip' } },
                    { value: '354', label: '启动失败[0x63]', scopedSlots: { title: 'tooltip' } },
                    { value: '355', label: '启动失败[0x64]', scopedSlots: { title: 'tooltip' } },
                    { value: '394', label: '启动失败[0xA3]', scopedSlots: { title: 'tooltip' } },
                    { value: '395', label: '启动失败[0xA4]', scopedSlots: { title: 'tooltip' } },
                    { value: '405', label: '启动失败[0xAA]', scopedSlots: { title: 'tooltip' } },
                    { value: '406', label: '启动失败[0xAB]', scopedSlots: { title: 'tooltip' } },
                    { value: '407', label: '启动失败[0xAC]', scopedSlots: { title: 'tooltip' } },
                    { value: '408', label: '启动失败[0xAD]', scopedSlots: { title: 'tooltip' } },
                    { value: '409', label: '启动失败[0xAE]', scopedSlots: { title: 'tooltip' } },
                    { value: '410', label: '启动失败[0xAF]', scopedSlots: { title: 'tooltip' } },

                    { value: '417', label: "启动失败[0xB5]", scopedSlots: { title: 'tooltip' } },
                    { value: '418', label: "启动失败[0xB6]", scopedSlots: { title: 'tooltip' } },
                    { value: '419', label: "启动失败[0xB7]", scopedSlots: { title: 'tooltip' } },
                    { value: '420', label: "启动失败[0xB8]", scopedSlots: { title: 'tooltip' } },
                    { value: '421', label: "启动失败[0xB9]", scopedSlots: { title: 'tooltip' } },
                    { value: '422', label: "启动失败[0xBA]", scopedSlots: { title: 'tooltip' } },


                    { value: '360', label: "异常中止[0x6A]", scopedSlots: { title: 'tooltip' } },
                    { value: '361', label: "异常中止[0x6B]", scopedSlots: { title: 'tooltip' } },
                    { value: '362', label: "异常中止[0x6C]", scopedSlots: { title: 'tooltip' } },
                    { value: '363', label: "异常中止[0x6D]", scopedSlots: { title: 'tooltip' } },
                    { value: '364', label: "异常中止[0x6E]", scopedSlots: { title: 'tooltip' } },
                    { value: '365', label: "异常中止[0x6F]", scopedSlots: { title: 'tooltip' } },
                    { value: '415', label: "异常中止[0x70]", scopedSlots: { title: 'tooltip' } },
                    { value: '366', label: "异常中止[0x71]", scopedSlots: { title: 'tooltip' } },
                    { value: '367', label: "异常中止[0x72]", scopedSlots: { title: 'tooltip' } },
                    { value: '368', label: "异常中止[0x73]", scopedSlots: { title: 'tooltip' } },
                    { value: '369', label: "异常中止[0x74]", scopedSlots: { title: 'tooltip' } },
                    { value: '370', label: "异常中止[0x75]", scopedSlots: { title: 'tooltip' } },
                    { value: '371', label: "异常中止[0x76]", scopedSlots: { title: 'tooltip' } },
                    { value: '372', label: "异常中止[0x77]", scopedSlots: { title: 'tooltip' } },
                    { value: '373', label: "异常中止[0x78]", scopedSlots: { title: 'tooltip' } },
                    { value: '374', label: "异常中止[0x79]", scopedSlots: { title: 'tooltip' } },
                    { value: '375', label: "异常中止[0x7A]", scopedSlots: { title: 'tooltip' } },
                    { value: '376', label: "异常中止[0x7B]", scopedSlots: { title: 'tooltip' } },
                    { value: '377', label: "异常中止[0x7C]", scopedSlots: { title: 'tooltip' } },
                    { value: '378', label: "异常中止[0x7D]", scopedSlots: { title: 'tooltip' } },
                    { value: '379', label: "异常中止[0x7E]", scopedSlots: { title: 'tooltip' } },
                    { value: '380', label: "异常中止[0x7F]", scopedSlots: { title: 'tooltip' } },
                    { value: '381', label: "异常中止[0x80]", scopedSlots: { title: 'tooltip' } },
                    { value: '382', label: "异常中止[0x81]", scopedSlots: { title: 'tooltip' } },
                    { value: '383', label: "异常中止[0x82]", scopedSlots: { title: 'tooltip' } },
                    { value: '384', label: "异常中止[0x83]", scopedSlots: { title: 'tooltip' } },
                    { value: '385', label: "异常中止[0x84]", scopedSlots: { title: 'tooltip' } },
                    { value: '386', label: "异常中止[0x85]", scopedSlots: { title: 'tooltip' } },
                    { value: '387', label: "异常中止[0x86]", scopedSlots: { title: 'tooltip' } },
                    { value: '388', label: "异常中止[0x87]", scopedSlots: { title: 'tooltip' } },
                    { value: '389', label: "异常中止[0x88]", scopedSlots: { title: 'tooltip' } },
                    { value: '390', label: "异常中止[0x89]", scopedSlots: { title: 'tooltip' } },
                    { value: '391', label: "异常中止[0xA0]", scopedSlots: { title: 'tooltip' } },
                    { value: '392', label: "异常中止[0xA1]", scopedSlots: { title: 'tooltip' } },
                    { value: '393', label: "异常中止[0xA2]", scopedSlots: { title: 'tooltip' } },
                    { value: '396', label: "异常中止[0xA5]", scopedSlots: { title: 'tooltip' } },
                    { value: '397', label: "异常中止[0xA6]", scopedSlots: { title: 'tooltip' } },
                    { value: '398', label: "异常中止[0xA7]", scopedSlots: { title: 'tooltip' } },
                    { value: '399', label: "异常中止[0xA8]", scopedSlots: { title: 'tooltip' } },
                    { value: '401', label: "异常中止[0xA9]", scopedSlots: { title: 'tooltip' } },
                    { value: '411', label: "异常中止[0xB0]", scopedSlots: { title: 'tooltip' } },
                    { value: '412', label: "异常中止[0xB1]", scopedSlots: { title: 'tooltip' } },
                    { value: '413', label: "异常中止[0xB2]", scopedSlots: { title: 'tooltip' } },
                    { value: '414', label: "异常中止[0xB3]", scopedSlots: { title: 'tooltip' } },
                    { value: '416', label: "异常中止[0xB4]", scopedSlots: { title: 'tooltip' } },

                    { value: '423', label: "异常中止[0xBB]", scopedSlots: { title: 'tooltip' } },
                    { value: '424', label: "异常中止[0xBC]", scopedSlots: { title: 'tooltip' } },
                    { value: '425', label: "异常中止[0xBD]", scopedSlots: { title: 'tooltip' } },
                    { value: '426', label: "异常中止[0xBE]", scopedSlots: { title: 'tooltip' } },
                    { value: '427', label: "异常中止[0xBF]", scopedSlots: { title: 'tooltip' } },
                    { value: '428', label: "异常中止[0xC0]", scopedSlots: { title: 'tooltip' } },
                    { value: '429', label: "异常中止[0xC1]", scopedSlots: { title: 'tooltip' } },
                    { value: '430', label: "异常中止[0xC2]", scopedSlots: { title: 'tooltip' } },
                    { value: '431', label: "异常中止[0xC3]", scopedSlots: { title: 'tooltip' } },
                    { value: '432', label: "异常中止[0xC4]", scopedSlots: { title: 'tooltip' } },
                    { value: '433', label: "异常中止[0xC5]", scopedSlots: { title: 'tooltip' } },

                    { value: '434', label: "启动失败[0xC6]", scopedSlots: { title: 'tooltip' } },
                    { value: '435', label: "启动失败[0xC7]", scopedSlots: { title: 'tooltip' } },
                    { value: '1040', label: "异常中止[0xC8]", scopedSlots: { title: 'tooltip' } },
                    { value: '919', label: "异常中止[0xC9]", scopedSlots: { title: 'tooltip' } },
                    { value: '605', label: "异常中止[0xCA]", scopedSlots: { title: 'tooltip' } },
                    { value: '606', label: "异常中止[0xCB]", scopedSlots: { title: 'tooltip' } },
                    { value: '607', label: "异常中止[0xCC]", scopedSlots: { title: 'tooltip' } },
                    { value: '608', label: "异常中止[0xCD]", scopedSlots: { title: 'tooltip' } },
                    { value: '610', label: "异常中止[0xCE]", scopedSlots: { title: 'tooltip' } },
                    { value: '611', label: "异常中止[0xCF]", scopedSlots: { title: 'tooltip' } },
                    { value: '612', label: "异常中止[0xD1]", scopedSlots: { title: 'tooltip' } },
                    { value: '613', label: "异常中止[0xD2]", scopedSlots: { title: 'tooltip' } },
                    { value: '614', label: "异常中止[0xD3]", scopedSlots: { title: 'tooltip' } },
                    { value: '615', label: "异常中止[0xD4]", scopedSlots: { title: 'tooltip' } },
                    { value: '508', label: "启动失败[0xD5]", scopedSlots: { title: 'tooltip' } },
                    { value: '616', label: "启动失败[0xD6]", scopedSlots: { title: 'tooltip' } },
                    { value: '920', label: "启动失败[0xD7]", scopedSlots: { title: 'tooltip' } },
                    { value: '921', label: "启动失败[0xD8]", scopedSlots: { title: 'tooltip' } },
                    { value: '922', label: "启动失败[0xD9]", scopedSlots: { title: 'tooltip' } },
                    { value: '923', label: "启动失败[0xDA]", scopedSlots: { title: 'tooltip' } },
                    { value: '924', label: "异常中止[0xDB]", scopedSlots: { title: 'tooltip' } },
                    { value: '1041', label: "启动失败[0xDE]", scopedSlots: { title: 'tooltip' } },
                    { value: '925', label: "启动失败[0xDF]", scopedSlots: { title: 'tooltip' } },
                    { value: '400', label: "未知原因停止" },
                ]
            },
            {
                label: "云快充交/直流",
                value: 'cloud_fast',
                selectable: false,
                auth: 'device-manage.car.ykc',
                children: [
                    { value: '901', label: 'APP远程停止' },
                    { value: '902', label: 'SOC达到100' },
                    { value: '903', label: '电量用完' },
                    { value: '904', label: '金额用完' },
                    { value: '905', label: '时间用完' },
                    { value: '906', label: '手动停止' },
                    { value: '917', label: '设置充电费率失败' },
                    { value: '918', label: '其他' },

                    { value: '1031', label: 'BMS正常终止充电' },
                    { value: '1032', label: '达到所需SOC目标(BST)' },
                    { value: '1033', label: '达到单体电压的设定值' },
                    { value: '1034', label: '达到总电压的设定值' },
                    { value: '1035', label: 'BMS主动终止充电(BSM报文)' },
                    { value: '1036', label: '达到用户设定的SOC目标值 80%' },
                    { value: '1037', label: '达到用户设定的SOC目标值 85%' },
                    { value: '1038', label: '达到用户设定的SOC目标值 90%' },
                    { value: '1039', label: '达到用户设定的SOC目标值 95%' },

                    { value: '926', label: '启动失败[0x4A]', scopedSlots: { title: 'tooltip' } },
                    { value: '927', label: '启动失败[0x4B]', scopedSlots: { title: 'tooltip' } },
                    { value: '928', label: '启动失败[0x4C]', scopedSlots: { title: 'tooltip' } },
                    { value: '929', label: '启动失败[0x4D]', scopedSlots: { title: 'tooltip' } },
                    { value: '930', label: '启动失败[0x4E]', scopedSlots: { title: 'tooltip' } },
                    { value: '931', label: '启动失败[0x4F]', scopedSlots: { title: 'tooltip' } },
                    { value: '932', label: '启动失败[0x50]', scopedSlots: { title: 'tooltip' } },
                    { value: '933', label: '启动失败[0x51]', scopedSlots: { title: 'tooltip' } },
                    { value: '934', label: '启动失败[0x52]', scopedSlots: { title: 'tooltip' } },
                    { value: '935', label: '启动失败[0x53]', scopedSlots: { title: 'tooltip' } },
                    { value: '936', label: '启动失败[0x54]', scopedSlots: { title: 'tooltip' } },
                    { value: '937', label: '启动失败[0x55]', scopedSlots: { title: 'tooltip' } },
                    { value: '938', label: '启动失败[0x56]', scopedSlots: { title: 'tooltip' } },
                    { value: '939', label: '启动失败[0x57]', scopedSlots: { title: 'tooltip' } },
                    { value: '940', label: '启动失败[0x58]', scopedSlots: { title: 'tooltip' } },
                    { value: '941', label: '启动失败[0x59]', scopedSlots: { title: 'tooltip' } },
                    { value: '942', label: '启动失败[0x5A]', scopedSlots: { title: 'tooltip' } },
                    { value: '943', label: '启动失败[0x5B]', scopedSlots: { title: 'tooltip' } },
                    { value: '944', label: '启动失败[0x5C]', scopedSlots: { title: 'tooltip' } },
                    { value: '945', label: '启动失败[0x5D]', scopedSlots: { title: 'tooltip' } },
                    { value: '946', label: '启动失败[0x5E]', scopedSlots: { title: 'tooltip' } },
                    { value: '947', label: '启动失败[0x5F]', scopedSlots: { title: 'tooltip' } },
                    { value: '948', label: '启动失败[0x60]', scopedSlots: { title: 'tooltip' } },
                    { value: '949', label: '启动失败[0x61]', scopedSlots: { title: 'tooltip' } },
                    { value: '950', label: '启动失败[0x62]', scopedSlots: { title: 'tooltip' } },
                    { value: '951', label: '启动失败[0x63]', scopedSlots: { title: 'tooltip' } },
                    { value: '952', label: '启动失败[0x64]', scopedSlots: { title: 'tooltip' } },
                    { value: '953', label: "异常中止[0x6A]", scopedSlots: { title: 'tooltip' } },
                    { value: '907', label: "异常中止[0x6B]", scopedSlots: { title: 'tooltip' } },
                    { value: '954', label: "异常中止[0x6C]", scopedSlots: { title: 'tooltip' } },
                    { value: '908', label: "异常中止[0x6D]", scopedSlots: { title: 'tooltip' } },
                    { value: '909', label: "异常中止[0x6E]", scopedSlots: { title: 'tooltip' } },
                    { value: '910', label: "异常中止[0x6F]", scopedSlots: { title: 'tooltip' } },
                    { value: '955', label: "异常中止[0x70]", scopedSlots: { title: 'tooltip' } },
                    { value: '956', label: "异常中止[0x71]", scopedSlots: { title: 'tooltip' } },
                    { value: '911', label: "异常中止[0x72]", scopedSlots: { title: 'tooltip' } },
                    { value: '957', label: "异常中止[0x73]", scopedSlots: { title: 'tooltip' } },
                    { value: '912', label: "异常中止[0x74]", scopedSlots: { title: 'tooltip' } },
                    { value: '958', label: "异常中止[0x75]", scopedSlots: { title: 'tooltip' } },
                    { value: '913', label: "异常中止[0x76]", scopedSlots: { title: 'tooltip' } },
                    { value: '959', label: "异常中止[0x77]", scopedSlots: { title: 'tooltip' } },
                    { value: '960', label: "异常中止[0x78]", scopedSlots: { title: 'tooltip' } },
                    { value: '914', label: "异常中止[0x79]", scopedSlots: { title: 'tooltip' } },
                    { value: '915', label: "异常中止[0x7A]", scopedSlots: { title: 'tooltip' } },
                    { value: '961', label: "异常中止[0x7B]", scopedSlots: { title: 'tooltip' } },
                    { value: '962', label: "异常中止[0x7C]", scopedSlots: { title: 'tooltip' } },
                    { value: '963', label: "异常中止[0x7D]", scopedSlots: { title: 'tooltip' } },
                    { value: '964', label: "异常中止[0x7E]", scopedSlots: { title: 'tooltip' } },
                    { value: '965', label: "异常中止[0x7F]", scopedSlots: { title: 'tooltip' } },
                    { value: '966', label: "异常中止[0x80]", scopedSlots: { title: 'tooltip' } },
                    { value: '967', label: "异常中止[0x81]", scopedSlots: { title: 'tooltip' } },
                    { value: '968', label: "异常中止[0x82]", scopedSlots: { title: 'tooltip' } },
                    { value: '916', label: "异常中止[0x83]", scopedSlots: { title: 'tooltip' } },
                    { value: '969', label: "异常中止[0x84]", scopedSlots: { title: 'tooltip' } },
                    { value: '970', label: "异常中止[0x85]", scopedSlots: { title: 'tooltip' } },
                    { value: '971', label: "异常中止[0x86]", scopedSlots: { title: 'tooltip' } },
                    { value: '972', label: "异常中止[0x87]", scopedSlots: { title: 'tooltip' } },
                    { value: '973', label: "异常中止[0x88]", scopedSlots: { title: 'tooltip' } },
                    { value: '974', label: "异常中止[0x89]", scopedSlots: { title: 'tooltip' } },
                    { value: '975', label: "异常中止[0xA0]", scopedSlots: { title: 'tooltip' } },
                    { value: '976', label: "异常中止[0xA1]", scopedSlots: { title: 'tooltip' } },
                    { value: '977', label: "异常中止[0xA2]", scopedSlots: { title: 'tooltip' } },
                    { value: '978', label: '启动失败[0xA3]', scopedSlots: { title: 'tooltip' } },
                    { value: '979', label: '启动失败[0xA4]', scopedSlots: { title: 'tooltip' } },
                    { value: '980', label: "异常中止[0xA5]", scopedSlots: { title: 'tooltip' } },
                    { value: '981', label: "异常中止[0xA6]", scopedSlots: { title: 'tooltip' } },
                    { value: '982', label: "异常中止[0xA7]", scopedSlots: { title: 'tooltip' } },
                    { value: '983', label: "异常中止[0xA8]", scopedSlots: { title: 'tooltip' } },
                    { value: '984', label: "异常中止[0xA9]", scopedSlots: { title: 'tooltip' } },
                    { value: '985', label: '启动失败[0xAA]', scopedSlots: { title: 'tooltip' } },
                    { value: '986', label: '启动失败[0xAB]', scopedSlots: { title: 'tooltip' } },
                    { value: '987', label: '启动失败[0xAC]', scopedSlots: { title: 'tooltip' } },
                    { value: '988', label: '启动失败[0xAD]', scopedSlots: { title: 'tooltip' } },
                    { value: '989', label: '启动失败[0xAE]', scopedSlots: { title: 'tooltip' } },
                    { value: '990', label: '启动失败[0xAF]', scopedSlots: { title: 'tooltip' } },
                    { value: '991', label: "异常中止[0xB0]", scopedSlots: { title: 'tooltip' } },
                    { value: '992', label: "异常中止[0xB1]", scopedSlots: { title: 'tooltip' } },
                    { value: '993', label: "异常中止[0xB2]", scopedSlots: { title: 'tooltip' } },
                    { value: '994', label: "异常中止[0xB3]", scopedSlots: { title: 'tooltip' } },
                    { value: '995', label: "异常中止[0xB4]", scopedSlots: { title: 'tooltip' } },
                    { value: '996', label: "启动失败[0xB5]", scopedSlots: { title: 'tooltip' } },
                    { value: '997', label: "启动失败[0xB6]", scopedSlots: { title: 'tooltip' } },
                    { value: '998', label: "启动失败[0xB7]", scopedSlots: { title: 'tooltip' } },
                    { value: '999', label: "启动失败[0xB8]", scopedSlots: { title: 'tooltip' } },
                    { value: '1000', label: "启动失败[0xB9]", scopedSlots: { title: 'tooltip' } },
                    { value: '1001', label: "启动失败[0xBA]", scopedSlots: { title: 'tooltip' } },

                    { value: '1002', label: "异常中止[0xBB]", scopedSlots: { title: 'tooltip' } },
                    { value: '1003', label: "异常中止[0xBC]", scopedSlots: { title: 'tooltip' } },
                    { value: '1004', label: "异常中止[0xBD]", scopedSlots: { title: 'tooltip' } },
                    { value: '1005', label: "异常中止[0xBE]", scopedSlots: { title: 'tooltip' } },
                    { value: '1006', label: "异常中止[0xBF]", scopedSlots: { title: 'tooltip' } },
                    { value: '1007', label: "异常中止[0xC0]", scopedSlots: { title: 'tooltip' } },
                    { value: '1008', label: "异常中止[0xC1]", scopedSlots: { title: 'tooltip' } },
                    { value: '1009', label: "异常中止[0xC2]", scopedSlots: { title: 'tooltip' } },
                    { value: '1010', label: "异常中止[0xC3]", scopedSlots: { title: 'tooltip' } },
                    { value: '1011', label: "异常中止[0xC4]", scopedSlots: { title: 'tooltip' } },
                    { value: '1012', label: "异常中止[0xC5]", scopedSlots: { title: 'tooltip' } },
                    { value: '1044', label: "异常中止[0xC6]", scopedSlots: { title: 'tooltip' } },
                    { value: '1045', label: "异常中止[0xC7]", scopedSlots: { title: 'tooltip' } },

                    { value: '1042', label: "异常中止[0xC8]", scopedSlots: { title: 'tooltip' } },
                    { value: '1013', label: "异常中止[0xC9]", scopedSlots: { title: 'tooltip' } },
                    { value: '1014', label: "异常中止[0xCA]", scopedSlots: { title: 'tooltip' } },
                    { value: '1015', label: "异常中止[0xCB]", scopedSlots: { title: 'tooltip' } },
                    { value: '1016', label: "异常中止[0xCC]", scopedSlots: { title: 'tooltip' } },
                    { value: '1017', label: "异常中止[0xCD]", scopedSlots: { title: 'tooltip' } },
                    { value: '1018', label: "异常中止[0xCE]", scopedSlots: { title: 'tooltip' } },
                    { value: '1019', label: "异常中止[0xCF]", scopedSlots: { title: 'tooltip' } },
                    { value: '1020', label: "异常中止[0xD1]", scopedSlots: { title: 'tooltip' } },
                    { value: '1021', label: "异常中止[0xD2]", scopedSlots: { title: 'tooltip' } },
                    { value: '1022', label: "异常中止[0xD3]", scopedSlots: { title: 'tooltip' } },
                    { value: '1023', label: "异常中止[0xD4]", scopedSlots: { title: 'tooltip' } },
                    { value: '1024', label: "启动失败[0xD5]", scopedSlots: { title: 'tooltip' } },
                    { value: '1046', label: "启动失败[0xD6]", scopedSlots: { title: 'tooltip' } },
                    { value: '1025', label: "启动失败[0xD7]", scopedSlots: { title: 'tooltip' } },
                    { value: '1026', label: "启动失败[0xD8]", scopedSlots: { title: 'tooltip' } },
                    { value: '1027', label: "启动失败[0xD9]", scopedSlots: { title: 'tooltip' } },
                    { value: '1028', label: "启动失败[0xDA]", scopedSlots: { title: 'tooltip' } },
                    { value: '1029', label: "异常中止[0xDB]", scopedSlots: { title: 'tooltip' } },
                    { value: '1043', label: "启动失败[0xDE]", scopedSlots: { title: 'tooltip' } },
                    { value: '1030', label: "启动失败[0xDF]", scopedSlots: { title: 'tooltip' } },
                ],
            },
        ],

        // 订单免费原因
        FREE_REASON: {
            DEFAULT: 0,              // 默认值 - 不免费
            ORG_LOW_ENERGY: 120,     // 结算策略-片区-低电量
            ORG_FREE_TIME: 121,      // 结算策略-片区-充电时长免费
            STATION_LOW_ENERGY: 130, // 结算策略-站点-低电量
            STATION_FREE_TIME: 131,  // 结算策略-站点-充电时长免费
            OPERATOR_FREE_USER: 210, // 运营商免费用户
            ORG_FREE: 320,           // 用户规则-片区-免费
            ORG_DISCOUNT: 321,       // 用户规则-片区-折扣为0
            DEVICE_USER: 440,        // 免费白名单-设备-用户
            DEVICE_CARD: 441,        // 免费白名单-设备-卡片
            PORT_USER: 450,          // 免费白名单-端口-用户
            PORT_CARD: 451,          // 免费白名单-端口-卡片
        },
        FREE_REASON_MAP: {
            '0':   { value: 0,   text: '不免费', reason: '不免费策略' },
            '120': { value: 120, text: '片区低电量结算策略', reason: '符合低电量免收费策略' },
            '121': { value: 121, text: '片区充电时长结算策略', reason: '符合充电时长免收费策略' },
            '130': { value: 130, text: '站点低电量结算策略', reason: '符合低电量免收费策略' },
            '131': { value: 131, text: '站点充电时长结算策略', reason: '符合充电时长免收费策略' },
            '210': { value: 210, text: '运营商免费用户', reason: '运营商免费用户' },
            '320': { value: 320, text: '片区用户规则免费', reason: '片区免费用户' },
            '321': { value: 321, text: '片区用户规则折扣为0', reason: '用户规则折扣为0' },
            '440': { value: 440, text: '设备免费用户白名单', reason: '设备免费白名单' },
            '441': { value: 441, text: '设备免费卡片白名单', reason: '卡片免费白名单' },
            '450': { value: 450, text: '端口免费用户白名单', reason: '端口免费白名单' },
            '451': { value: 451, text: '端口免费卡片白名单', reason: '卡片免费白名单' },
        },


        // 线上支付订单审核操作类型
        AUDIT_TYPE: {
            CONFIRM: 801,  // 确认待确认的充值订单
            REFUND: 802,  // 退款待确认的充值订单 
        },
        AUDIT_TYPE_MAP: {
            '801': { value: 801, text: '完结订单' },
            '802': { value: 802, text: '订单退款' },
        },
    },
    // 充值订单
    RECHARGE: {
        TYPE: { // 充值订单
            ALL: 0,     // 全部订单
            REFUND: 1,  // 已退款订单
        },
        // 充值订单状态
        STATUS_MAP: {
            '100':  { value: 100,  color: 'orange', text: '未支付' },
            '200':  { value: 200,  color: 'blue',   text: '已支付' },
            '400':  { value: 400,  color: 'green',  text: '充值完成' },
            '-200': { value: -200, color: 'grey',   text: '已取消' },
            '-400': { value: -400, color: 'grey',   text: '退款完成' },
        },
        CARD_TYPE: {
            MONEY: 1, // 实体两轮充储值卡
            TIME: 2,  // 实体两轮充包月卡
            VIRTUAL_MONEY: 3,  // 虚拟两轮充储值卡
            VIRTUAL_TIME: 4,   // 虚拟两轮充包月卡
            ACCOUNT: 5,  // 虚拟账户
            CAR_MONEY: 6,      // 实体汽车充储值卡
            VIRTUAL_CAR_MONEY: 7, // 虚拟汽车充储值卡
        },
        CARD_TYPE_MAP: {
            '1': { value: 1, icon: 'i-recharge_card', text: '实体两轮充储值卡' },
            '2': { value: 2, icon: 'i-booyaka', text: '实体两轮充包月卡' },
            '3': { value: 3, icon: 'i-recharge_card', text: '虚拟两轮充储值卡' },
            '4': { value: 4, icon: 'i-booyaka', text: '虚拟两轮充包月卡' },
            '5': { value: 5, icon: 'i-booyaka', text: '虚拟账户' },
            '6': { value: 6, icon: 'i-recharge_card', text: '实体汽车充储值卡' },
            '7': { value: 7, icon: 'i-recharge_card', text: '虚拟汽车充储值卡' },
        },
        CARD_TYPE_MARK: {
            REALITY: [1, 2, 6],
            VIRTUAL: [3, 4, 7],
        },
    },
    // 占用费订单
    OCCUPY: {
        TYPE: {
            TANK: 1, // 充电柜 占用单
            GATE: 2, // 道闸  占用单
            CHARGE: 3, // 充电  占用单
        },
        TYPE_MAP: {
            '1': { value: 1, key: 'tank', text: '充电柜' },
            '2': { value: 2, key: 'gate', text: '道闸' },
            '3': { value: 3, key: 'charge', text: '充电' },
        },

        STATUS: {
            UNPAY: 100,   // 待支付
            PAY: 200,     // 支付成功
            SUCCESS: 400, // 打开成功
            FINISH: 500, // 已结束
            WAITING_REFUND: 350,   // 余额退款中
            WAITING_REFUND_NEW: -350, // 退款中
            COMPLETE_REFUND: -400, // 退款成功
        },
        STATUS_MAP: {
            '100': { value: 100, color: 'grey', text: '待支付' },
            '200': { value: 200, color: 'orange', text: '支付成功' },
            '400': { value: 400, color: 'blue', text: '占位中', text_gate: '占位中' },  // 打开成功
            '500': { value: 500, color: 'green', text: '已结束' },
            '350': { value: 350, color: 'red', text: '退款中' },
            '-350': { value: -350, color: 'red', text: '退款中' },
            '-400': { value: -400, color: 'grey', text: '已退款' },
        },
        STATUS_MARK: {
            NOT_FINISH: [100, 200, 400], // 充电中
        },
        PAY_METHOD: {
            WECHART: 1,  // 微信
            ALIPAY: 2,   // 支付宝
            RECHARGE: 3, // 两轮充虚拟储值卡
            WHITE: 4,    // 白名单
            CAR_CARD: 5, // 汽车充虚拟卡储值卡
        },
        PAY_METHOD_MAP: {
            '1': { value: 1, icon: 'i-WeChat', text: '微信' },
            '2': { value: 2, icon: 'i-Alipay', text: '支付宝' },
            '3': { value: 3, icon: 'i-recharge_card', text: '两轮充储值卡', type: [1, 2] },
            '4': { value: 4, icon: 'i-white_list', text: '白名单' },
            '5': { value: 5, icon: 'i-recharge_card', text: '汽车虚拟储值卡' },
        },
        PAY_METHOD_MARK: {
            CARD: [3, 5], // 用卡片支付
            NORMAL_CARD: [3, 5], // 系统中的卡片
            REALITY_CARD: [],       // 用实体卡片支付
            VIRTUAL_CARD: [3, 5],  // 用虚拟卡片支付

            NEED_CLEARING: [1, 2], // 需要结算
        },

        // 订单结束原因
        FINISH_CODE_MAP: {
            '12': { value: 12, text: '无车驶入超时结束' },
            '13': { value: 13, text: '车辆驶出自动结束' },
            '14': { value: 14, text: '远程控制结束' },
            '15': { value: 15, text: '远程强制控制结束' },

            '601': { value: 601, text: '道闸异常' },
            '602': { value: 602, text: '道闸电机故障' },
            '603': { value: 603, text: '道闸通讯故障' },
        },
    },
    // 换电柜订单
    CABINET: {
        STATUS: {
            INIT: 100,        // 待支付
            PAY_SUCCESS: 200, // 支付成功
            REFUNDING: 300,   // 退款中
            CANCEL: -200,     // 已取消
        },
        STATUS_MAP: {
            '100': { value: 100, class: 'unpay', color: 'orange', text: '待支付' },
            '200': { value: 200, class: 'success', color: 'green', text: '支付成功' },
            '300': { value: 300, class: 'refund', color: 'red', text: '退款中' },
            '-200': { value: -200, class: 'cancel', color: 'grey', text: '已取消' },
        },
        PAY_METHOD: {
            WECHART: 1,  // 微信
            ALIPAY: 2,   // 支付宝
        },
        PAY_METHOD_MAP: {
            '1': { value: 1, icon: 'i-WeChat', text: '微信' },
            '2': { value: 2, icon: 'i-Alipay', text: '支付宝' },
        },

        PACKAGE_STATUS: {
            INIT: 0,
            USE: 100,
            EXPIRED: 150,
            PASS: 200,
        },
        PACKAGE_STATUS_MAP: {
            '0': { value: 0, color: 'orange', text: '待支付' },
            '100': { value: 100, color: 'green', text: '使用中' },
            '150': { value: 150, color: 'gray', text: '已逾期' },
            '200': { value: 200, color: 'gray', text: '已失效' },
        },
        LOG_TYPE: {
            TAKE: 1,     // 取电
            EXCHANGE_RETURN: 2, // 换电-还电
            RETURN: 3,   // 退电
            EXCHANGE_TAKE: 4 // 换电-取电
        },
        LOG_TYPE_MAP: {
            '1': { value: 1, text: '取电', isSelect: true },
            '2': { value: 2, text: '换电', isSelect: true },  // 换电-还电
            '3': { value: 3, text: '退电', isSelect: true },
            '4': { value: 4, text: '换电', isSelect: false },  // 换电-取电
        },
        LOG_STATUS: {
            PUT_DOOR_OPEN: 100,  // 还电电池仓门已开启
            PUT_BATTERY: 200,    // 还电电池已放入
            PUT_DOOR_CLOSE: 300, // 还电电池已放入，且仓门已关闭

            TAKE_DOOR_OPEN: 400,  // 取电电池仓门开启成功
            TAKE_BATTERY: 500,    // 取电电池已取出
            TAKE_DOOR_CLOSE: 600, // 取电电池已取出，且仓门已关闭

            FAIL: -200, // 换电失败
        },
        LOG_STATUS_MAP: {
            '100': { value: 100, text: '还电电池仓门已开启' },
            '200': { value: 200, text: '还电电池已放入' },
            '300': { value: 300, text: '还电电池仓门已关闭' },
            '400': { value: 400, text: '取电电池仓门已开启' },
            '500': { value: 500, text: '取电电池已取出' },
            '600': { value: 600, text: '取电电池仓门已关闭' },

            '-200': { value: -200, text: '失败' },   // 换电
        },
        LOG_FINISH_MAP: {
            '1': { value: 1, text: '成功' },
            '2': { value: 2, text: '成功，但仓门未关' },
            '3': { value: 3, text: '失败，电池未取走但门已关' },
            '4': { value: 4, text: '失败，未接入电池但门已关' },
            '5': { value: 5, text: '失败，未接入电池且门未关' },
            '20': { value: 20, text: '未识别的电池[]', need_more: true },
            '21': { value: 21, text: '失败，归还的电池非上次租借的电池' },  //  电池[]不属于当前用户 , need_more: true
            '22': { value: 22, text: '失败，设备应答超时' },
            '23': { value: 23, text: '失败，控制设备失败' },

            '30': { value: 30, text: '失败，正常' },
            '31': { value: 31, text: '失败，无空仓' },
            '32': { value: 32, text: '失败，无同规格电池' },
            '33': { value: 33, text: '失败，同规格电池尚未充满' },
            '34': { value: 34, text: '失败，充电仓故障' },
            '35': { value: 35, text: '失败，控制命令不完整' },
            '36': { value: 36, text: '失败，充电仓已有订单被占用' },
            '37': { value: 37, text: '失败，电池锁定' },
            '38': { value: 38, text: '失败，电池故障' },
            '39': { value: 39, text: '失败，空仓数量不足' },
            '40': { value: 40, text: '失败，电池数量不足' },
            '41': { value: 41, text: '失败，开仓响应超时' },
            '42': { value: 42, text: '失败，开仓指令无响应' },
        },
        LOG_FINISH: {
            SUCCESS: 1,                // 成功
            SUCCESS_DOOR_UNCLOSE: 2,   // 成功，但仓门未关
            FAIL_BATTERY_NOT_TAKE: 3,  // 失败，电池未取走但门已关
            FAIL_NOT_BATTERY_DOOR_CLOSE: 4,// 失败，未接入电池但门已关
            FAIL_NOT_BATTERY_DOOR_UNCLOSE: 5,// 失败，未接入电池且门未关
            BATTERY_NOT_EXIST: 20,      // 失败，未识别的电池【packId】
            BATTERY_IS_ILLEGAL: 21,     // 失败，归还的电池非上次租借的电池
            DEVICE_TIME_OUT: 22,        // 失败，设备应答超时
            DEVICE_FAIL: 23,            // 失败，控制设备失败
            // 失败，控制设备失败  细分
            SUCCESS_OPEN: 30,              // 0-正常
            OPEN_POSITION: 31,             // 1-无空仓
            NO_SAME_SPEC_BATTERY: 32,      // 2-无同规格电池
            SAME_SPEC_NOT_FULL: 33,        // 3-同规格电池尚未充满
            CHARGING_BAY_FAULT: 34,        // 4-充电仓故障
            CONTROL_COMMAND_INCOMPLETE: 35, // 5-控制命令不完整
            HAS_ORDER: 36,                 // 6-充电仓已有订单被占用
            BATTERY_LOCK: 37,              // 7-电池锁定
            BATTERY_FAILURE: 38,           // 8-电池故障
            EMPTY_INDEX_INSUFFICIENT: 39,  // 9-空仓数量不足 （空仓数量=1，不允许退电）
            INSUFFICIENT_BATTERY: 40,      // 16-电池数量不足 （电池数量=1，不允许取电）
            OPENING_RESPONSE_TIMED_OUT: 41, // 10-开仓响应超时
            NO_RESPONSE_TO_OPEN_ORDER: 42, // 11-开仓指令无响应
        },
        LOG_FINISH_MARK: {
            'SUCCESS': [1, 2],
            'FAIL': [3, 4, 5, 20, 21, 22, 23]
        },
        LOG_FINISH_MARK_MAP: {
            'SUCCESS': { value: 1, text: '成功' },
            'FAIL': { value: 2, text: '失败' },
        },
        LOG_RETURN_MAP: {
            '1': { value: 1, text: '还电后需取电池' },
            '2': { value: 2, text: '仅退电池' },
        },
        FLAG_CHILD: {
            CHILD_FALSE: 0,  // 父流程
            CHILD_TRUE: 1,   // 子流程
        },
        RESULT_CODE: {
            '-1': { value: -1, text: '设备响应超时' },
            '0': { value: 0, text: '正常' },
            '1': { value: 1, text: '无空仓' },
            '2': { value: 2, text: '无同规格电池' },
            '3': { value: 3, text: '同规格电池尚未充满' },
            '4': { value: 4, text: '充电仓故障' },
            '5': { value: 5, text: '控制命令不完整' },
            '6': { value: 6, text: '充电仓已有订单被占用' },
            '7': { value: 7, text: '电池锁定' },
            '8': { value: 8, text: '电池故障' },
            '9': { value: 9, text: '空仓数量不足' },
            '10': { value: 10, text: '电池数量不足' },
        },

        EXCHANGE_MDOE: {
            LEAD_CELL: 1,   //  先领电池
            DIRECT_COMMUTATION: 2,   //  直接换电
        },

        EXCHANGE_MDOE_MAP: {
            '1': { value: 1, text: '先领电池' },
            '2': { value: 2, text: '直接换电' },
        },

        // 电池组数量
        TAKE_BATTERY_COUNT_MAP: {
            '1': { value: 1, text: '1组' },
            '2': { value: 2, text: '2组' },
            '3': { value: 3, text: '3组' },
        },
    },
    // 欠款订单
    PURSUE: {
        /* TYPE: {
            GATE: 200, // 道闸 欠款订单
        }, */

        STATUS: {
            INIT: 0,       // 初始化
            WAIT_PAY: 100, // 等待支付
            PAYED: 200,    // 支付完成
            REFUNDING: 350,   // 余额退款中
            REFUNDED: -400,     // 退款成功
        },
        // 欠款订单状态
        STATUS_MAP: {
            '100': { value: 100, text: '待补款', color: 'orange' },
            '200': { value: 200, text: '已补款', color: 'green' },
            // '-400': { value: -400, text: '退款成功', color: 'grey' }, // 退款后欠款订单状态不会变更
        },
        STATUS_MARK: {
            NOT_PAY: [0, 100],  // 没有支付
        },

        // parent_type 
        PARENT_TYPE: {
            GATE_OCCUPY: 1,    // 道闸占用
            CAR_OCCUPY: 2,    // 充电后占用
        },

        PARENT_TYPE_MAP: {
            '1': { value: 1, text: '道闸占用', color: 'orange' },
            '2': { value: 2, text: '充电后占用', color: 'green' },
        },

        PAY_METHOD: {
            WECHART: 1,  // 微信
            ALIPAY: 2,   // 支付宝
            CAR_CARD: 5, // 汽车充虚拟卡储值卡
        },
        PAY_METHOD_MAP: {
            '1': { value: 1, icon: 'i-WeChat', text: '微信' },
            '2': { value: 2, icon: 'i-Alipay', text: '支付宝' },
            '5': { value: 5, icon: 'i-recharge_card', text: '汽车虚拟储值卡' },
        },
        PAY_METHOD_MARK: {
            NORMAL_CARD: [5]
        }
    },

    // 有序充电
    ORDERLY_CHARGING: {
        // 策略
        STRATEGY: {
            TYPE: {
                FIRST_COME_FIRST_SERVED: 2, // 先到先得
            },
            TYPE_LIST: [
                // {
                // 	text: '快充优先',
                // 	tip: '优先保证先开启充电车辆的充电功率需求',
                // 	value: 1,
                // },
                {
                    text: '先到先得',
                    tip: '优先保证先开启充电车辆的充电功率需求',
                    value: 2,
                },
            ],
            TYPE_MAP: {
                // {
                // 	text: '快充优先',
                // 	tip: '优先保证先开启充电车辆的充电功率需求',
                // 	value: 1,
                // },
                "2": {
                    text: '先到先得',
                    tip: '优先保证先开启充电车辆的充电功率需求',
                    value: 2,
                },
            },
        },
    },

    // 订单退款
    REFUND: {
        TARGET_TYPE: {
            REALITY_CARD: 1,
            VIRTUAL_CARD: 2,
            DEPOSIT: 3,
            REALITY_CAR_CARD: 4,
        },
        TARGET_TYPE_MAP: {
            '1': { value: 1, text: '实体储值卡' },
            '2': { value: 2, text: '虚拟储值卡' },
            '3': { value: 3, text: '换电柜押金' },
            '4': { value: 4, text: '实体汽车充卡' },
        },

        STATUS: {
            WAIT_AUDIT: 100,       // 发起退款 等待审核
            AUDIT_SUCCESS: 200,    // 审核成功
            AUDIT_REJECT: -200,    // 拒绝
            CANCEL: -300,          // 取消
        },
        STATUS_MAP: {
            '100': { value: 100, color: 'orange', transfer_text: '待审核', transfer_color: 'orange', text: '待审核' },
            '200': { value: 200, color: 'blue', transfer_text: '打款中', transfer_color: 'blue', text: '同意退款' },
            '-200': { value: -200, color: 'red', transfer_text: '已拒绝', transfer_color: '', text: '拒绝退款' },
            '-300': { value: -300, color: 'gray', transfer_text: '已取消', transfer_color: '', text: '已取消' },
        },

        TRANSFER_STATUS: {
            INIT: 0,       // 待审核
            DOING: 100,    // 打款中
            SUCCESS: 200,  // 打款成功
            FATAL: -200,   // 打款失败
        },
        TRANSFER_STATUS_MAP: {
            '0': { value: 0, color: 'orange', text: '待审核' },
            '100': { value: 100, color: 'blue', text: '打款中' },
            '200': { value: 200, color: 'green', text: '打款成功' },
            '-200': { value: -200, color: 'red', text: '打款失败' },
        },
    },

    VIN: {
        WEIGHT: {
            DELETE: -1,       // 已删除
            DEFAULT: 0,    // 正常
        },
        WEIGHT_MAP: {
            '-1': { value: -1, color: 'orange', transfer_text: '已删除', transfer_color: 'orange', text: '已删除' },
            '0': { value: 0, color: 'blue', transfer_text: '正常', transfer_color: 'blue', text: '正常' },
        },
    },

    // 服务费
    SERVICE_CHARGE: {
        PAY_MODE_MAP: {
            '1': { value: 1, text: '每月扣款' }
        },
        DEVICE_SUBJECT: {
            SERVICE_CHARGE: 120, // 服务费
            ONLINE_PAY_IN: 121, // 线上支付转入
            ORDER_REVENUE_IN: 122, // 订单收益转入
            CROSS_DEVICE_IN: 123,  // 跨设备服务费转入
            CROSS_DEVICE_OUT: 124, // 跨设备服务费转出
            CROSS_DEVICE_ORDER_REVENUE_IN: 125, // 跨设备订单收益转入
        },
        DEVICE_SUBJECT_MAP: {
            '120': { value: 120, text: '设备服务费', remark: '' },
            '121': { value: 121, text: '线上支付转入', remark: '' },
            '122': { value: 122, text: '订单收益转入', remark: '' },
            '123': { value: 123, text: '跨设备服务费转入', remark: '设备[${uid}]服务费转入' },
            '124': { value: 124, text: '跨设备服务费转出', remark: '服务费转出至设备[${uid}]' },
            '125': { value: 125, text: '跨设备订单收益转入', remark: '设备[${uid}]订单收益转入' },
            '140': { value: 140, text: '线上支付转入', remark: '设备[${uid}]订单收益转入' },
        }
    },
    // 对账单
    SETTLEMENT: {
        STATUS: {
            INIT: 0,
            RUNNING: 100,
            COMPLETE: 200,
            FAIL: -100,
        },
        STATUS_MAP: {
            '0': '初始化',
            '100': '生成中',
            '200': '已生成',
            '-100': '生成失败',
        }
    },

    // '打款' 状态
    REMIT_STATUS_MAP: {
        '0': { value: 0, tag: 'orange', color: 'blue', text: '初始化' },
        '100': { value: 100, tag: 'cyan', color: 'grey', text: '合并' },
        '200': { value: 200, tag: 'blue', color: 'orange', text: '进行中' },
        '300': { value: 300, tag: 'green', color: 'green', text: '打款成功' },
        '-100': { value: -100, tag: 'red', color: 'red', text: '打款失败' },
    },
    PAYMENT_REMIT_STATUS_MAP: {
        '50': { value: 50, tag: 'orange', color: 'blue', text: '初始化' },
        '100': { value: 100, tag: 'blue', color: 'orange', text: '等待支付' },
        '200': { value: 200, tag: 'green', color: 'green', text: '打款成功' },
        '-1': { value: -1, tag: 'red', color: 'red', text: '打款失败' },
    },

    // 结算
    CLEARING: {
        // 结算状态
        STATUS: {
            BEFORE: 0,     // 未结算
            DOING: 100,    // 结算中
            SUCCESS: 200,  // 已结算
            FAILURE: -1,   // 结算失败:实际金额不足
            FAILURE_BY_DEL: -2,   // 结算失败: 站点运营商不存在
            // FAILURE: -100, // 结算失败
        },
        STATUS_LIST: [
            { value: "",    text: '全部' },
            { value: "0",   text: '未结算' },
            { value: "100", text: '结算中' },
            { value: "200", text: '结算完成' },
            { value: "-1",  text: '结算失败' },
            // { value: "-2",  text: '结算失败' }, // 此结算失败已修复
        ],
        STATUS_MAP: {
            '0':    { value: "0",    color: 'color: #363D42;', text: '未结算',   },
            '100':  { value: "100",  color: 'color: #363D42;', text: '结算中',   },
            '200':  { value: "200",  color: 'color: #A9AFBD;', text: '结算完成',  },
            '-1':   { value: "-1",   color: 'color: #363D42;', text: '结算失败', tip: '实际金额不足' },
            '-2':   { value: "-2",   color: 'color: #363D42;', text: '结算失败', tip: '站点运营商不存在' },
            '-100': { value: "-100", color: 'color: #363D42;', text: '结算失败',  },
        },
        STATUS_MARK: {
            PURSUE_NEED_CLEARING: [0, -1, -2],  // 欠款订单需要结算的结算状态
            SHOW_TRADE_DETAILS: [200, -1, -2], // 可以展示结算明细
            FAIL: [-1, -2], // 结算失败 
        },
        // 结算结束原因
        FINISH_CODE_MAP: {
            '401': { value: 401, text: '默认打款账户不存在' },
            '402': { value: 402, text: '打款金额非法' },
            '403': { value: 403, text: '结算项的金额总和与订单金额不一致' },
            '404': { value: 404, text: '分成配置非法' },
            '405': { value: 405, text: '分成配置比例非法' },
            '406': { value: 406, text: '最终分成配置为空' },
            '407': { value: 407, text: '最终分成配置比例非法' },
            '408': { value: 408, text: '最终分成某个结算账户不存在' },
            '409': { value: 409, text: '最终分成金额列表为空' },
            '410': { value: 410, text: '最终分成某个结算账户支付宝信息无效' },
        },
    },

    // 虚拟账户
    VIRTUAL_ACCOUNT: {
        TYPE: {
            CLEARING: 1, // 结算账户
            PLAT: 10,    // 平台账户
            SERVICE_PAY: 20,     // 服务费应付账户
            SERVICE_COLLECT: 30, // 服务费收款账户
        },
    },
    // 银行账户
    BANK_ACCOUNT: {
        TYPE: {
            PUBLIC: 1, // 对公
            PRIVATE: 2, // 对私
        },
        TYPE_MAP: {
            '1': { value: 1, text: '对公账户/个体户' },
            '2': { value: 2, text: '对私账户' },
        },
        /* // 对公银行
        PUBLIC_BANK_LIST: [
            '中国建设银行','杭州银行','中国光大银行','中国工商银行','兴业银行','宁波银行','中信银行','平安银行','中国民生银行','浦发银行','交通银行','中国农业银行','广发银行','招商银行','网商银行',
        ], */
        // 对私银行
        BANK_LIST: [
            '中国工商银行', '晋城银行', '中国建设银行', '九江银行', '中国农业银行', '长春经开融丰村镇银行', '中国银行', '吉林银行', '交通银行', '吉林省农村信用社联合社', '中国邮政储蓄银行', '济宁银行', '招商银行', '江苏江阴农村商业银行', '中国光大银行', '晋商银行', '中信银行', '江苏银行', '广发银行', '江苏省农村信用社联合社', '浦发银行', '嘉兴银行', '兴业银行', '江西省农村信用社', '平安银行', '晋中银行', '中国民生银行', '焦作中旅银行', '网商银行', '梅县客家村镇银行', '安徽省农村信用社', '昆仑银行', '鞍山银行', '昆山农村商业银行', '潍坊银行', '廊坊银行', '保定银行', '辽宁省农村信用社', '广西北部湾银行', '莱商银行', '河北银行', '临商银行', '北京银行', '乐山市商业银行', '北京农商行', '泸州市商业银行', '东营莱商村镇银行', '辽阳银行', '长春绿园融泰村镇银行', '中银富登村镇银行', '柳州银行', '朝阳银行', '兰州银行', '沧州银行', '浙江民泰商业银行', '东莞银行', '绵阳市商业银行', '渤海银行', '宁波银行', '海南农商银行', '宁波通商银行', '锦州银行', '宁波鄞州农商行', '洛阳银行', '江西银行', '平顶山银行', '南海农商银行', '青海银行', '南京银行', '泉州银行', '内蒙古农村信用社联合社', '新韩银行', '宁夏银行', '苏州银行', '宁夏黄河农村商业银行', '营口银行', '广东南粤银行', '蒙商银行', '鄂尔多斯银行', '长安银行', '攀枝花市商业银行', '长春朝阳和润村镇银行', '青岛银行', '青岛农商银行', '重庆三峡银行', '青海省农村信用社', '成都银行', '曲靖市商业银行', '成都农商银行', '齐鲁银行', '四川天府银行', '珠海华润银行', '江苏长江商业银行', '日照银行', '重庆银行', '四川省农村信用社联合社', '重庆农村商业银行', '顺德农商银行', '长沙银行', '山东省农村信用社联合社', '常熟农商银行', '上海银行', '浙商银行', '上海农商银行', '浙江稠州商业银行', '盛京银行', '江南农村商业银行', '遂宁银行', '龙江银行', '上饶银行', '大连银行', '深圳农村商业银行', '大连农村商业银行', '绍兴银行', '东莞农村商业银行', '陕西省农信社', '长城华西银行', '山西省农村信用社', '东营银行', '石嘴山银行', '德州银行', '泰安银行', '恒丰银行', '天津银行', '富邦华一银行', '江苏太仓农村商业银行', '富滇银行', '天津滨海农村商业银行', '福建海峡银行', '天津农商银行', '福建省农村信用社联合社', '台州银行', '阜新银行', '海口联合农商银行', '广州银行', '联合村镇银行', '广东省农村信用社联合社', '乌鲁木齐银行', '广东华兴银行', '乌海银行', '桂林银行', '威海市商业银行', '广州农村商业银行', '武汉农村商业银行', '甘肃银行', '苏州农村商业银行', '甘肃省农村信用社', '友利银行', '广西壮族自治区农村信用社联合社', '广西农村商业联合银行股份有限公司', '无锡农村商业银行', '贵阳银行', '温州银行', '赣州银行', '西安银行', '贵州省农村信用社联合社', '厦门国际银行', '内蒙古银行', '新疆农村信用社', '新疆北屯农村商业银行', '韩亚银行', '厦门银行', '湖北银行', '邢台银行', '河北省农村信用社', '宜宾市商业银行', '邯郸银行', '尧都农商银行村镇银行', '汉口银行', '营口沿海银行', '东亚银行', '云南省农村信用社', '葫芦岛银行', '烟台银行', '黑龙江省农村信用社联合社', '云南红塔银行', '湖南省农村信用社', '齐商银行', '河南省农村信用社', '自贡银行', '哈尔滨银行', '张家口银行', '华融湘江银行', '浙江农商联合银行', '徽商银行', '浙江泰隆商业银行', '衡水市商业银行', '张家港农村商业银行', '湖商村镇银行', '中原银行', '湖北省农村信用社联合社', '贵州银行', '华夏银行', '郑州银行', '杭州银行', '枣庄银行', '湖州银行', '企业银行', '百信银行', '花旗银行(中国)', '海南银行股份有限公司', '温州民商银行', '恒生银行', '星展银行', '承德银行', '贵阳农村商业银行', '金华银行', '山东张店农村商业银行', '中国农业发展银行', '浙江永嘉恒升村镇银行股份有限公司', '湖南银行股份有限公司', '杭州联合农村商业银行股份有限公司', '惠州农村商业银行股份有限公司', '新疆农村商业银行'
        ]
    },

    // 转账打款
    TRANSFER: {
        // 打款状态
        REMIT_STATUS: {
            INIT: 0,     // 初始化
            DOING: 100,   // 打款中
            SUCCESS: 200, // 打款成功
            FAILURE: -100, // 打款失败
            FAILURE_AND_REFUND: -200, // 打款失败并退款(旧)
            REFUND: -400, // 打款失败并退款
            CANCEL: -500, // 取消打款
        },
        REMIT_STATUS_MAP: {
            '0': { value: 0, color: 'blue', tag: 'blue', text: '初始化' },
            '100': { value: 100, color: 'orange', tag: 'orange', text: '打款中' },
            '200': { value: 200, color: 'green', tag: 'green', text: '打款成功' },
            '-100': { value: -100, color: 'red', tag: 'red', text: '打款失败' },
            '-400': { value: -400, color: 'grey', tag: 'cyan', text: '打款失败并退款' },
            '-500': { value: -500, color: 'grey', tag: 'cyan', text: '取消打款' },
            // '-200': { value: -200, color: 'grey',   tag: 'cyan',   text: '致命失败'},
        },
        // 转账审核
        AUDIT_STATUS: {
            WAITING: 0,   // 待审核
            PASS: 1,      // 已通过
            NOT_PASS: -1, // 未通过
        },
        AUDIT_STATUS_MAP: {
            '0': { value: 0, tag: 'orange', color: 'orange', text: '待审核' },
            '1': { value: 1, tag: 'green', color: 'green', text: '已通过' },
            '-1': { value: -1, tag: 'red', color: 'red', text: '未通过' },
        },
        // 转账周期
        PERIOD_MAP: {
            '1': { text: 'D+1', desc: '每天凌晨收到昨天收益打款' },   // T+1
            '2': { text: 'D+7', desc: '每周一凌晨收到上一周的收益打款' },   // T+7
            '3': { text: 'M+1', desc: '每月一号凌晨收到上一月的收益打款' },
        },
        TARGET_TYPE_MAP: {
            '-1': { text: '全部', value: -1 },
            '0': { text: '系统', value: 0 },
            '1': { text: '独立', value: 1 },
        },

        // 转账周期
        BANK_CARD_TRANSFER_CHANNEL_MAP: {
            '1': { text: '支付宝' },
            '2': { text: '宝付' },
            '3': { text: '汇付' },
        },

        // 打款渠道
        METHOD: {
            DEFAULT: 0,   // 默认
            WECHART: 1,   // 微信
            ALIPAY: 2,    // 支付宝
            BANK_CARD: 3, // 银行卡-支付宝
            BANK_CARD_BF: 4, // 银行卡-宝付
        },
        METHOD_MAP: {
            "-1": { value:-1, index: 0, icon: "", text: "全部", key: '' },
            "0":  { value: 0, index: 1, icon: "", text: "未设置", key: '' },
            "1":  { value: 1, index: 1, icon: "i-WeChat", text: "微信", key: 'wx'/* , hidden: true */ },
            "2":  { value: 2, index: 1, icon: "i-Alipay", text: "支付宝", key: 'ali'/* , hidden: true  */ },
            "3":  { value: 3, index: 1, icon: "i-bank_card", text: "银行卡-支付宝", key: 'bank' },
            "4":  { value: 4, index: 1, icon: "i-bank_card", text: "银行卡-宝付", key: 'bank' },
        },
        /* 允许 打款的渠道 */
        AUTO_CONFIRM_METHOD_MAP: {
            "2":  { value: 2, index: 1, icon: "i-Alipay", text: "支付宝", key: 'ali'/* , hidden: true  */ },
            "3":  { value: 3, index: 1, icon: "i-bank_card", text: "银行卡-支付宝", key: 'bank' },
            "4":  { value: 4, index: 1, icon: "i-bank_card", text: "银行卡-宝付", key: 'bank' },
        }
    },

    // 卡片
    CARD: {
        STATUS: {
            INACTIVE: 0,
            UNBOUND: 100,
            USEING: 200,
            LOSSED: -101,
            DISCARD: -201,
            AUDITING: -301,
            RECYCLE: -400,
        },
        STATUS_MAP: {
            '0': { value: 0, color: 'blue', text: '未激活' },
            '100': { value: 100, color: 'orange', text: '未绑定' },
            '200': { value: 200, color: 'green', text: '已绑定' },
            '-101': { value: -101, color: 'red', text: '已挂失' },
            '-201': { value: -201, color: 'grey', text: '已废弃' },
            '-301': { value: -301, color: 'red', text: '退款审核中' },
            '-400': { value: -400, color: 'red', text: '已回收' },
        },
        VIRTUAL_STATUS_MAP: {
            '0': { value: 0, color: 'green', text: '使用中' },
            '-301': { value: -301, color: 'red', text: '退款审核中' },
            '-400': { value: -400, color: 'red', text: '已回收' },
        },
        VIRTUAL_VIN_STATUS_MAP: {
            '0': { value: 0, color: 'green', text: '启用中' },
            '-401': { value: -401, color: 'red', text: '禁用中' },
        },

        TYPE: {
            MONEY: 1,
            TIME: 2,
            CAR_MONEY: 3,
            QGL_MONEY: 4,
        },
        TYPE_MAP: {
            '1': { value: 1, icon: 'i-recharge_card', text: '两轮充储值卡', edit: true, key: 'plug_money' },
            '2': { value: 2, icon: 'i-booyaka', text: '两轮充包月卡', edit: true, key: 'plug_time' },
            '3': { value: 3, icon: 'i-recharge_card', text: '汽车充储值卡', edit: true, key: 'car_money' },
            '4': { value: 3, icon: 'i-recharge_card', text: '青橄榄一卡通', edit: false, key: 'car_money' },
        },
        MARK: {
            MONEY: [1, 3, 4],
            TIME: [2]
        },

        OPERATOR_MAP: {
            '0': { value: 0, text: '系统' },
            '1': { value: 1, text: '管理员' },
            '2': { value: 2, text: '运营商' },
            '3': { value: 3, text: '用户' },
            '4': { value: 4, text: '运营商' },
        },

        REALITY_SUBJECT_MAP: {
            1: '激活',
            2: '充值',
            3: '订单消费',
            4: '订单退款',
            5: '卡片更换，余额由旧卡转入',
            6: '包卡消费',
            7: '后台充值',
            8: '后台扣减',
            12: '充值任务充值',
            10: '余额转出',
            14: '卡片更换，余额转入新卡',
            15: '逾期自动扣减',
        },
        REALITY_SUBJECT: {
            ACTIVATE: 1,  // 激活
            RECHARGE: 2,  // 充值
            ORDER_CONSUME: 3,  // 订单消费
            ORDER_REFUND: 4,  // 订单退款
            CARD_REPLACE_BALANCE_IN: 5,  // 卡片更换，余额由旧卡转入
            PACKAGE_CARD_CONSUME: 6,  // 包卡消费
            BACKEND_RECHARGE: 7,  // 后台充值
            BACKEND_DEDUCT: 8,  // 后台扣减
            BALANCE_TRANSFER_OUT: 10,  // 余额转出
            RECHARGE_TASK_RECHARGE: 12,  // 充值任务充值
            CARD_REPLACE_BALANCE_TO_NEW: 14,  // 卡片更换，余额转入新卡
            OVERDUE_AUTO_DEDUCT: 15,  // 逾期自动扣减
        },
        VIRTUAL_SUBJECT_MAP: {
            1: '激活',
            2: '充值',
            3: '订单消费',
            4: '订单退款',
            5: '换卡平账恢复金额',
            6: '包卡消费',
            11: '后台充值',
            7: '后台扣减',
            12: '充值任务充值',
            9: '充值券充值',
            10: '余额转出',
            15: '道闸占位订单消费',
            16: '充电柜占位订单消费',
            17: '追款订单消费',
            18: '欠款订单退款',
            19: '占用费订单退款',   // 充电柜占用费订单退款
            20: '道闸占用费订单退款',
            22: '充电费支付',
            23: '逾期自动扣减',
            24: '订单预扣', // 集团vin码储值卡
        },
        VIRTUAL_SUBJECT: {
            ACTIVATE: 1,  // 激活
            RECHARGE: 2,  // 充值
            ORDER_CONSUME: 3,  // 订单消费
            ORDER_REFUND: 4,  // 订单退款
            CARD_REPLACE_RECOVER: 5,  // 换卡平账恢复金额
            PACKAGE_CARD_CONSUME: 6,  // 包卡消费
            BACKEND_DEDUCT: 7,  // 后台扣减
            COUPON_RECHARGE: 9,  // 充值券充值
            BALANCE_TRANSFER_OUT: 10,  // 余额转出
            BACKEND_RECHARGE: 11,  // 后台充值
            RECHARGE_TASK_RECHARGE: 12,  // 充值任务充值
            GATE_OCCUPY_ORDER_CONSUME: 15,  // 道闸占位订单消费
            CHARGING_CABINET_OCCUPY_ORDER_CONSUME: 16,  // 充电柜占位订单消费
            DEBT_COLLECTION_ORDER_CONSUME: 17,  // 追款订单消费
            DEBT_ORDER_REFUND: 18,  // 欠款订单退款
            OCCUPY_FEE_ORDER_REFUND: 19,  // 占用费订单退款
            GATE_OCCUPY_FEE_ORDER_REFUND: 20,  // 道闸占用费订单退款
            CHARGING_FEE_PAYMENT: 22,  // 充电费支付
            OVERDUE_AUTO_DEDUCT: 23,  // 逾期自动扣减
            ORDER_PRE_DEDUCT: 24,  // 订单预扣
        },


        REALITY_OPERATION_MAP: {
            1000: '卡片被导入，等待激活',
            1001: '卡片被重置',
            2000: '卡片被激活',
            3000: '卡片被用户绑定',
            4000: '卡片挂失',
            5000: '卡片找回',
            6000: '卡片充值',
            7000: '卡片解绑',
            8000: '卡片被新卡替换',
            9000: '卡片切换片区',
            10000: '卡片注销', // 卡片删除
            11000: '卡片扣减',
            13000: '卡片由旧卡替换',
        },
        VIRTUAL_OPERATION_MAP: {
            1000: '卡片重置',
            2000: '卡片被激活',
            3000: '卡片被用户绑定',
            4000: '卡片挂失',
            5000: '卡片找回',
            6000: '卡片充值',
            7000: '卡片解绑',
            8000: '老卡被新卡替换',
            9000: '卡片切换片区',
            10000: '卡片扣减',
            12000: '卡片注销',
            13000: '卡片注销', // 卡片删除
        },

        ERROR_CODE_MAP: {
            '400': { value: 400, text: '未知异常' },
            '401': { value: 401, text: '卡余额不足' },
            '402': { value: 402, text: '不是该片区的卡' },
            '403': { value: 403, text: '不是该运营商的卡' },
            '404': { value: 404, text: '卡已挂失' },
            '405': { value: 405, text: '卡已废弃' },
            '406': { value: 406, text: '卡未激活' },
            '407': { value: 407, text: '包月卡已过期' },
            '409': { value: 409, text: '包月卡没有配置信息' },
            '410': { value: 410, text: '订单已存在，不能重复创建' },
            '411': { value: 411, text: '充电站充电配置不存在' },
            '412': { value: 412, text: '获取按时计费配置失败' },
            '413': { value: 413, text: '获取按量计费配置失败' },
            '414': { value: 414, text: '卡充电失败，按时收费，下发时间为0' },
            '415': { value: 415, text: '卡充电失败，按量收费，下发电量为0' },
            '416': { value: 416, text: '包月卡已用完' },
            '417': { value: 417, text: '不是该设备的卡' },
            '418': { value: 418, text: '该卡不允许开启多笔订单' },
            '419': { value: 419, text: '卡片退款审核中，暂不能使用' },
            '420': { value: 420, text: '急停按钮已按下' },
            '421': { value: 421, text: '限制时段禁止下单' },
            '422': { value: 422, text: '不支持使用按次收取服务费模版' },
        },

        PRODUCT_TYPE: {
            REALITY: 1,
            VIRTUAL: 2,
        },
        PRODUCT_TYPE_MAP: {
            '1': { value: 1, text: '实体卡' },
            '2': { value: 2, text: '虚拟卡' },
        },

        CARD_TYPE: {
            PLUG: 1,
            CAR: 2,
        },
        CARD_TYPE_MAP: {
            '1': { value: 1, text: '两轮充' },
            '2': { value: 2, text: '汽车充' },
        },
    },
    // 充值模版管理
    RECHARGE_MODEL: {
        TYPE: {
            TIME: 1, // 包月卡
            MONEY_PLUG: 2, // 储值卡 - 两轮充
            MONEY_CAR: 3,  // 储值卡 - 汽车充
        },
        TYPE_MAP: {
            "1": { value: 1, text: '两轮·包月', name: '两轮充包月', key: 'time' },
            "2": { value: 2, text: '两轮·储值', name: '两轮充储值', key: 'money_plug' },
            "3": { value: 3, text: '汽车·储值', name: '汽车充储值', key: 'money_car' },
        },
    },
    // 卡片充值任务
    RECHARGE_TASK: {
        TYPE: {
            ONCE: 1,
            CYCLE: 2,
        },
        TYPE_MAP: {
            '1': { value: '1', text: '一次性' },
            '2': { value: '2', text: '每月执行' },
        },
        CARD_TYPE: {
            ENTITY: 10,
            VIRTUAL: 20,
        },
        CARD_TYPE_MAP: {
            '10': { value: '10', text: '实体卡', key: 'reality' },
            '20': { value: '20', text: '虚拟卡', key: 'virtual' },
        },
        STATUS: {
            INIT: 0,
            DOING: 20,
            FINISH: 50,
        },
        STATUS_MAP: {
            '0': { value: '0', text: '待执行', color: 'orange' },
            '20': { value: '20', text: '执行中', color: 'blue' },
            '50': { value: '50', text: '已结束', color: 'green' },
        },
    },

    // 统计
    STAT: {
        TARGET_TYPE: {
            ADMIN: 1,    // 管理员
            OPERATOR: 2, // 运营商
            ORG: 3,      // 片区
            STATION: 4,  // 充电站
            DEVICE: 5,   // 设备
        },
        CUSTOM_OPERATOR: [
            9217, // 众一智慧
            9862, // 万兆智能
            13819, // 宁投智慧
            13832, // 宁投智慧运营
            10123, // 上海正向新能源科技有限公司
            10059, // 上海正向科技有限公司
            13283, // 上海领充新能源科技有限公司
            16350, // zytz
            16289, // 琛电科技有限责任公司
            16394, // 13681264234
            16244, // 18538086033
            16394, // 15868840536
        ]
    },
    // 导出
    EXPORT: {
        TYPE: {
            ORDER: 1,     // 充电订单
            CARD_STAT: 3, // 卡片统计

            SERVICE: 2,     // 服务费账单（旧版运营商）
            SERVICE_NEW: 4, // 服务费账单（新版运营商）
            SERVICE_ORG: 7, // 服务费账单（新版片区）

            CLEARING_SUMMARY: 5, // 分账账户收支报表账单
            CLEARING_DETAIL: 6,  // 分账账户收支明细账单

            RECHARGE_ORDER: 8, // 卡片统计

            INSURANCE_ORDER: 9, // 自燃险导出
            VENUE_INSURANCE_ORDER: 10, // 场地险导出

            DEVICE: 11, // 旧 设备列表 设备导出
            DEVICE_NORMAL: 12, // 设备管理 设备导出
            STATION: 13, // 站点导出

            STATEMENT: 14, // 对账单导出
            SHUALAN_ORDER: 15, //刷蓝订单导出

            ALIPAY_AD_ORDER: 16, // 支付宝广告订单导出
        },
        TYPE_MAP: {
            '1': { value: 1, text: '充电订单' },
            '3': { value: 3, text: '卡片统计' },
            '2': { value: 2, text: '服务费账单（运营商）' },
            '4': { value: 4, text: '服务费账单（片区）' },
            '5': { value: 5, text: '分账账户收支报表账单' },
            '6': { value: 6, text: '分账账户收支明细账单' },
        },
        STATUS: {
            INIT: 0,
            DOING: 100,
            SUCCESS: 200,
            FAILURE: -100,
        },
        STATUS_MAP: {
            // '0':   { value: 0,    color: 'blue',   text: '初始化' },
            '100': { value: 100, color: 'orange', text: '进行中' },
            '200': { value: 200, color: 'green', text: '导出成功' },
            '-100': { value: -100, color: 'red', text: '导出失败' },
        },
        OPERATOR_MAP: {
            '1': { value: 1, text: '管理员' },
            '1': { value: 1, text: '管理员' },
            '10': { value: 10, text: '子管理员' },
            '2': { value: 2, text: '运营商' },
            '3': { value: 3, text: '运营商分账账户' },
            '4': { value: 4, text: '运营商子账户' },
        },

        STATEMENT_TASK_TYPE: {
            DAILY: 1,
            MONTHLY: 2,
            CUSTOM: 3,
            CUSTOIV2: 4,
        },
    },
    // 告警
    ALARM: {
        STATUS: {
            INIT: 0,    // 初始化
            WAITING: 1, // 待处理
            HANDLED: 2, // 已处理
        },
        STATUS_MAP: {
            // '0': { value: 0, text: '初始化', color: 'blue'},
            '1': { value: 1, text: '告警中', color: 'red' },
            '2': { value: 2, text: '已消警', color: 'gray' },
        },

        SOURCE: {
            STATION: 100, // 充电站
            DEVICE: 200, // 设备
        },
        SOURCE_MAP: {
            '100': { value: 100, text: '充电站' },
            '200': { value: 200, text: '设备' },
        },

        SUBJECT: {
            STATION_OFFLINE: 101,      // 网关离线
            ORDER_EXCEPTION_RATE: 111, // 订单失败率过高

            DEVICE_OFFLINE: 201,   // 设备离线
            OVER_LOAD: 202,        // 设备过载
            OVER_TEMPERATURE: 203, // 设备过温
            FUZE_BREAKAGE: 205,    // 保险丝烧断
            RELAY_JOIN: 210,       // 继电器粘连
            OVER_VOLTAGE: 211,     // 过压
            UNDER_VOLTAGE: 212,    // 欠压
            CAR_STOP: 213,         // 汽车充急停
            MEASURING_COMMUNICATION: 214, // 计量通讯
            RELAY_OVER_TEMPERATURE: 215,  // 继电器过温
            CABINET_SMOKE: 216,    // 充换电柜烟感报警
            CABINET_PONDING: 217,  // 充换电柜积水报警
            CABINET_AC_POWER: 218, // 电源断开
            OVER_CURRENT: 219,     // 过流
        },
        SUBJECT_MAP: {
            '101': { value: 101, text: '网关离线' },
            '111': { value: 111, text: '订单失败率过高' },
            '201': { value: 201, text: '设备离线' },
            '202': { value: 202, text: '设备过载' },
            '203': { value: 203, text: '设备过温' },
            '205': { value: 205, text: '保险丝烧断' },
            '210': { value: 210, text: '继电器粘连' },
            '215': { value: 215, text: '继电器过温' },
            '211': { value: 211, text: '过压' },
            '212': { value: 212, text: '欠压' },
            '219': { value: 219, text: '过流' },
            '220': { value: 220, text: '过载过流' },
            '214': { value: 214, text: '计量通讯' },
            '213': { value: 213, text: '汽车充急停' },
            '216': { value: 216, text: '充换电柜烟感报警' },
            '217': { value: 217, text: '充换电柜积水报警' },
            '218': { value: 218, text: '电源断开' },

            '221': { value: 221, text: '接地/相序接反异常' },
            '222': { value: 222, text: '漏电发生' },
            '223': { value: 223, text: '短路发生' },
            '224': { value: 224, text: 'CP电压异常' },
            '225': { value: 225, text: 'TCP连接强制断开后重连' },
            '226': { value: 226, text: '超时复位重连[模组]' },
            '227': { value: 227, text: '超时复位重连[MCU]' },
            '228': { value: 228, text: '过温暂停输出' },
            '229': { value: 229, text: '过温降额输出' },
            '230': { value: 230, text: 'MIPI屏白屏' },
        },
        SUBJECT_LIST_MAP: [
            {
                title: '两轮充',
                value: '1',
                key: 'plug',
                children: [
                    { value: '1-101', key: '1-101', title: '两轮-网关离线' },
                    { value: '1-111', key: '1-111', title: '两轮-订单失败率过高' },
                    { value: '1-201', key: '1-201', title: '两轮-设备离线' },
                    { value: '1-202', key: '1-202', title: '两轮-设备过载' },
                    { value: '1-203', key: '1-203', title: '两轮-设备过温' },
                    { value: '1-205', key: '1-205', title: '两轮-保险丝烧断' },
                    { value: '1-210', key: '1-210', title: '两轮-继电器粘连' },
                    { value: '1-215', key: '1-215', title: '两轮-继电器过温' },
                    { value: '1-211', key: '1-211', title: '两轮-过压' },
                    { value: '1-212', key: '1-212', title: '两轮-欠压' },
                    { value: '1-219', key: '1-219', title: '两轮-过流' },
                    { value: '1-220', key: '1-220', title: '两轮-过载过流' },
                    { value: '1-214', key: '1-214', title: '两轮-计量通讯' },
                    { value: '1-216', key: '1-216', title: '两轮-充换电柜烟感报警' },
                    { value: '1-217', key: '1-217', title: '两轮-充换电柜积水报警' },
                    { value: '1-218', key: '1-218', title: '两轮-电源断开' },
                ]
            },
            {
                title: '汽车充',
                value: '2',
                key: 'car',
                children: [
                    { value: '2-111', key: '2-111', title: '汽车-订单失败率过高' },
                    { value: '2-201', key: '2-201', title: '汽车-设备离线' },
                    { value: '2-202', key: '2-202', title: '汽车-设备过载' },
                    { value: '2-203', key: '2-203', title: '汽车-设备过温' },
                    { value: '2-210', key: '2-210', title: '汽车-继电器粘连' },
                    { value: '2-215', key: '2-215', title: '汽车-继电器过温' },
                    { value: '2-211', key: '2-211', title: '汽车-过压' },
                    { value: '2-212', key: '2-212', title: '汽车-欠压' },
                    { value: '2-213', key: '2-213', title: '汽车-汽车充急停' },
                    { value: '2-219', key: '2-219', title: '汽车-过流' },
                    { value: '2-220', key: '2-220', title: '汽车-过载过流' },
                    { value: '2-214', key: '2-214', title: '汽车-计量通讯' },
                    { value: '2-221', key: '2-221', title: '汽车-接地/相序接反异常' },
                    { value: '2-222', key: '2-222', title: '汽车-漏电发生' },
                    { value: '2-223', key: '2-223', title: '汽车-短路发生' },
                    { value: '2-224', key: '2-224', title: '汽车-CP电压异常' },
                    { value: '2-225', key: '2-225', title: '汽车-TCP连接强制断开后重连' },
                    { value: '2-226', key: '2-226', title: '汽车-超时复位重连[模组]' },
                    { value: '2-227', key: '2-227', title: '汽车-超时复位重连[MCU]' },
                    { value: '2-228', key: '2-228', title: '汽车-过温暂停输出' },
                    { value: '2-229', key: '2-229', title: '汽车-过温降额输出' },
                    // { value: '2-230', key: '2-230', title: '汽车-MIPI屏白屏' },
                    { value: '2-218', key: '2-218', title: '汽车-电源断开' },
                ]
            }
        ],

        EVENT_CODE_MAP: {
            '4097': '汽车充电桩插枪事件',
            '4098': '汽车充电桩拔枪事件',
            '4113': '充换电柜开门事件',
            '4114': '充换电柜关门事件',
            '8193': '过压发生',
            '8194': '过压恢复',
            '8209': '欠压发生',
            '8210': '欠压恢复',
            '8225': '异常大电流发生',
            '8226': '异常大电流恢复',
            '12289': '汽车充电桩急停按钮发生',
            '12290': '汽车充电桩急停按钮恢复',
            '12305': '继电器过温发生',
            '12306': '继电器过温恢复',
            '12321': '过载过流发生',
            '12322': '过载过流恢复',
            '12337': '计量通讯异常',
            '12338': '计量通讯恢复',
            '12353': '继电器粘连发生',
            '12354': '继电器粘连恢复',
            '12369': '充换电柜烟感告警发生',
            '12370': '充换电柜烟感告警恢复',
            '12385': '充换电柜设备积水发生',
            '12386': '充换电柜设备积水恢复',
            '12401': '电源断开',
            '12402': '电源恢复',
            '8241': '接地/相序接反异常',
            '8242': '接地/相序接反正常',
            '12417': '漏电发生',
            '12418': '漏电恢复',
            '12433': '短路发生',
            '12434': '短路恢复',
            '12545': 'CP电压异常',
            '12546': 'CP电压异常恢复',
            '12561': 'TCP连接强制断开后重连',
            '12562': '超时复位重连【模组】',
            '12563': '超时复位重连【MCU】',
            '12564': '过温暂停输出',
            '12565': '过温暂停恢复',
            '12566': '过温降额输出',
            '12567': '过温降额恢复',
            '12568': 'MIPI屏白屏发生',
            '12569': 'MIPI屏白屏恢复',
            '12641': '保险丝熔断',
            '12642': '保险丝熔断恢复',
        },
    },
    // 系统通知
    NOTICE: {
        TYPE: {
            USER: 10,     //面向用户
            OPERATOR: 20, //面向运营商
        },
        TYPE_MAP: {
            '10': { value: 10, text: '面向用户' },
            '20': { value: 20, text: '面向运营商' },
        }
    },
    // 用户反馈
    FEEDBACK: {
        TYPE_MAP: {
            1: '故障反馈',
            2: '功能建议',
            3: '内容建议',
            4: '软件使用问题',
            5: '找不到充电站/设备',
            6: '其他',
        },
        SCENE_TYPE: {
            RECHARGE: 1,
            INVOICE: 2,
        },
        SCENE_TYPE_MAP: {
            '1': { value: 1, text: '卡片咨询', },
			'2': { value: 2, text: '开票申请', },
			// '2': { value: 2, text: '充电订单咨询', },
			// '3': { value: 3, text: '站点设备反馈', },
			// '4': { value: 4, text: '其他', },
        },
        STATUS: {
            WAITING:    100, // 待处理
            CANCEL:     120, // 已取消
            PROCESSING: 150, // 处理中 - 开票申请
            PROCESSED : 200, // 已处理
            FINISH:     300, // 已关闭
        },
        STATUS_MAP: {
            '100': { value: 100, text: '待处理', color: 'orange', order: 1, auth: 'ALL'},
            '120': { value: 120, text: '已取消', color: 'gray',   order: 2, auth: 'ALL'},
            '150': { value: 150, text: '处理中', color: 'orange', order: 1, auth: 'ADMIN'}, // 开票申请
            '200': { value: 200, text: '已处理', color: 'green' , order: 1, auth: 'ALL'},
            '300': { value: 300, text: '已关闭', color: 'gray'  , order: 1, auth: 'ALL'},
        },
        PROGRESS: {
            // 待处理
            WAITING: 10001,                     // 待商家处理
            TIMEOUT_NOT_PROCESSED: 10002,       // 超时 商家未处理
            // 已取消
            CANCEL: 12001,                      // 用户手动取消
            // 处理中 - 开票申请
            PROCESSING_WAITING_ADMIN: 15001,    // 待平台处理, 运营商已处理 - 开票申请
            PROCESSING_WAITING_OPERATOR: 15002, // 待运营商处理, 平台已处理 - 开票申请
            PROCESSING_BY_PART_OPERATOR: 15003, // 部分运营商已处理 - 开票申请
            // 已处理
            PROCESSED: 20000,                   // 已处理 - 开票申请
            PROCESSED_WAITING_ADMIN: 20001,     // 平台已处理，待用户确认，平台介入
            PROCESSED_WAITING_OPERATOR: 20002,  // 商家已处理，待用户确认
            USER_NOT_FINISH: 20003,             // 用户反馈未解决，平台介入
            USER_FINISH: 20043,                 // 用户反馈已解决
            // 已关闭
            FINISHED: 30000,                    // 已关闭 - 开票申请
            HAND_FINISH_ADMIN: 30001,           // 平台手动关闭
            HAND_FINISH_OPERATOR: 30002,        // 运营商手动关闭
            FINISH: 30003,                      // 已解决 [用户无反馈｜用户反馈已解决]
            TIMEOUT_NOT_FINISH: 30004,          // 超时 用户反馈未解决
        },
        PROGRESS_MAP: {
            // 待处理
            '10001': { auth: 'ALL',   value: 10001, text: '待处理',                short_text: '未处理',         color: 'orange' },
            '10002': { auth: 'ALL',   value: 10002, text: '超时未处理',             short_text: '超时未处理',     color: 'orange' },
            // 已取消
            '12001': { auth: 'ALL',   value: 12001, text: '用户已取消',             short_text: '用户已取消',      color: 'gray' },
            // 处理中
            '15001': { auth: 'ADMIN', value: 15001, text: '待平台处理, 运营商已处理', short_text: '待平台处理',      color: 'orange' },
            '15002': { auth: 'ADMIN', value: 15002, text: '待运营商处理, 平台已处理', short_text: '待运营商处理',    color: 'orange' },
            '15003': { auth: 'ADMIN', value: 15003, text: '部分运营商已处理',        short_text: '部分运营商已处理', color: 'orange' },
            // 已处理
            '20000': { auth: 'ALL',   value: 20000, text: '已处理',                short_text: '工单已处理',            color: 'green' },
            '20001': { auth: 'ALL',   value: 20001, text: '平台已处理，待用户确认',   short_text: '平台直接介入',          color: 'green' },
            '20002': { auth: 'ALL',   value: 20002, text: '商家已处理，待用户确认',   short_text: '已回应，待用户确认',     color: 'green' },
            '20003': { auth: 'ALL',   value: 20003, text: '用户反馈未解决，平台介入', short_text: '用户反馈未解决，平台介入', color: 'green' },
            '20004': { auth: 'ALL',   value: 20004, text: '用户反馈已解决',          short_text: '用户反馈已解决',         color: 'green' },
            // 已关闭
            '30000': { auth: 'ALL',   value: 30000, text: '已关闭',                 short_text: '工单已关闭',           color: 'gray' },
            '30001': { auth: 'ALL',   value: 30001, text: '平台手动关闭',            short_text: '平台已关闭',           color: 'gray' },
            '30002': { auth: 'ALL',   value: 30002, text: '运营商手动关闭',          short_text: '运营商已关闭',          color: 'gray' },
            '30003': { auth: 'ALL',   value: 30003, text: '运营商已解决',            short_text: '工单已解决',           color: 'gray' },
            '30004': { auth: 'ALL',   value: 30004, text: '用户反馈未解决，超时关',    short_text: '超时关闭',            color: 'gray' },
        },
        // 卡片咨询 - 充值退款
        RECHARGE: {
            STATUS_MAP: {
                '100': { value: 100, text: '待处理', color: 'orange'},
                '200': { value: 200, text: '已处理', color: 'green'  },
                '300': { value: 300, text: '已关闭', color: 'gray'  },
                '120': { value: 120, text: '已取消', color: 'gray'},
            },
            PROGRESS_MAP: {
                // 待处理
                '10001': { value: 10001, text: '待处理',              short_text: '未处理', color: 'orange' },
                '10002': { value: 10002, text: '超时未处理',           short_text: '超时未处理', color: 'orange' },
                // 已取消
                '12001': { value: 12001, text: '已取消',               short_text: '用户已取消', color: 'gray' },
                // 已处理
                '20001': { value: 20001, text: '平台已处理，待用户确认',  short_text: '平台直接介入', color: 'green' },
                '20002': { value: 20002, text: '商家已处理，待用户确认',  short_text: '已回应，待用户确认', color: 'green' },
                '20003': { value: 20003, text: '用户反馈未解决，平台介入', short_text: '用户反馈未解决，平台介入', color: 'green' },
                '20004': { value: 20004, text: '用户反馈已解决',         short_text: '用户反馈已解决', color: 'green' },
                // 已关闭
                '30001': { value: 30001, text: '平台手动关闭',         short_text: '平台已关闭',   color: 'gray' },
                '30002': { value: 30002, text: '运营商手动关闭',       short_text: '运营商已关闭',   color: 'gray' },
                '30003': { value: 30003, text: '运营商已解决',         short_text: '工单已解决',   color: 'gray' },
                '30004': { value: 30004, text: '用户反馈未解决，超时关', short_text: '超时关闭',   color: 'gray' },
            },
            PROGRESS_FILTER_MAP: {
                '10002': { value: 10002, text: '超时未处理' },
                '20001': { value: 20001, text: '平台直接介入' },
                '20002': { value: 20002, text: '已回应，待用户确认' },
                '20003': { value: 20003, text: '用户反馈未解决，平台介入' },
            },
            REFUND_STATUS: {
                INIT: 0,              // 初始化
                DOING: 100,           // 退款中
                ACCOUNT_SUCCESS: 200, // 退款成功
                REFUND_FAIL: -1,    // 部分退款失败
                REFUND_FAIL_ALL: -2,    // 全部退款失败
            },
            REFUND_STATUS_MAP: {
                '0':   { value: 0,   text: '初始化', color: 'black' },
                '100': { value: 100, text: '退款中', color: 'orange' },
                '200': { value: 200, text: '退款成功', color: 'green' },
                '-1':  { value: -1,  text: '部分退款失败', color: 'red' },
                '-2':  { value: -2,  text: '全部退款失败', color: 'red' },
            },
            // 消息类型
            MESSAGE_TYPE: {
                SCORE: 11001,   // 用户评价得分
                STATUS: 11002,  // 是否解决
                MESSAGE: 11010, // 沟通信息
                PROCESS: 11020, // 更新进度
            },
            USER_STATUS: {
                INIT: 0,
                UNRESOLVED: 100,
                RESOLVED: 200,
            },
            CARD_TYPE_MARK: {
                // 储值卡
                MONEY: [1, 2],
                // 包月卡
                TIME: [3, 4],
                // 实体卡
                REALITY: [1, 3],
                // 虚拟卡
                VIRTUAL: [2, 4],
            }
        },
        
        // 开票申请
        INVOICE: {
            STATUS_MAP: {
                '100': { value: 100, text: '待处理', color: 'orange', auth: 'ALL'},
                '120': { value: 120, text: '已取消', color: 'orange', auth: 'ALL'},  
                '200': { value: 200, text: '已处理', color: 'green'  , auth: 'ALL'},
                '300': { value: 300, text: '已关闭', color: 'gray'  , auth: 'ALL'},
            },
            PROGRESS_MAP: {
                // 待处理
                '10001': { auth: 'ALL',    value: 10001, text: '待处理',                short_text: '未处理',        color: 'orange' },
                '10002': { auth: 'ALL',    value: 10002, text: '超时未处理',             short_text: '超时未处理',     color: 'orange' },
                // 已取消
                '12001': { auth: 'ALL',    value: 12001, text: '用户已取消',             short_text: '用户已取消',     color: 'gray' },
                // 已处理
                '20000': { auth: 'ALL',    value: 20000, text: '已处理',                short_text: '工单已处理',       color: 'green' },
                // 已关闭
                '30001': { auth: 'ALL',    value: 30001, text: '平台手动关闭',           short_text: '平台已关闭',       color: 'gray' },
                '30002': { auth: 'ALL',    value: 30002, text: '运营商手动关闭',          short_text: '运营商已关闭',     color: 'gray' },
                '30004': { auth: 'ALL',    value: 30004, text: '用户反馈未解决，超时关',   short_text: '超时关闭',         color: 'gray' },
            },
            PROGRESS_FILTER_MAP: {
                '10001': { auth: 'OPERATOR', value: 10001, text: '未处理' },
                '10002': { auth: 'ALL',      value: 10002, text: '超时未处理' },
                '20000': { auth: 'ALL',      value: 20000, text: '工单已处理' },
            },
            // 发票抬头类型
            INVOICE_TYPE: {
                COMPANY: 1,  // 公司
                PERSONAL: 2, // 个人
            },
        }
    },
    // 操作记录
    ACTION: {
        // 操作者类型
        OPERATOR_TYPE_MAP: {
            '0': { value: 0, text: '系统' },
            '1': { value: 0, text: '管理员' },
            '2': { value: 0, text: '运营商' },
            '3': { value: 0, text: '工人' },
            '4': { value: 0, text: '用户' },
        },
        // 操作对象类型
        TARGET_TYPE_MAP: {
            '1': { value: 1, text: '充电站' },
            '2': { value: 2, text: '订单' },
            '3': { value: 3, text: '用户' },
            '4': { value: 4, text: '片区' },
            '5': { value: 5, text: '设备' },
            '6': { value: 6, text: '分账账号' },
            '7': { value: 7, text: '结算模版' },
            '9': { value: 9, text: '虚拟卡' },
            '101': { value: 101, text: '管理员' },
            '102': { value: 102, text: '运营商' },
        },
        // 操作内容
        TYPE_MAP: {
            1: '管理员申请充电站直接通过',
            2: '管理员审核',
            3: '工人申请',
            4: '管理员删除充电站',
            5: '修改结算账户',
            6: '删除结算账户',
            7: '修改结算模版',
            8: '删除结算模版',
            9: '删除片区',
            10: '删除设备',
            11: '打款失败,修改打款账户',
            12: '删除用户',
            101: '修改管理员密码',
            102: '管理员修改其他人密码',
            103: '管理员修改运营商用户名',
            1001: '控制IOT平台的设备',
            6000: '卡充值',
            9000: '卡片切换片区',
            10000: '卡片减少余额',
        }
    },
    // 权益包订单
    BENEFIT_PACKAGE_ORDER: {
        NOTICE_ORDER: {
            STATUS: {
                PENDING: 0,   // 待支付
                PAID: 200,    // 已支付
                INVALID: 400, // 已失效
            },
            STATUS_MAP: {
                '0': { value: 0, text: '待支付', color: 'orange' },
                '200': { value: 200, text: '有效', color: 'green' },
                '400': { value: 400, text: '失效', color: 'red' },
            }
        },
    },

    // 广告配置
    ADVERTISING: {
        // 广告位置
        RESOURCE_MAP: {
            'plug_open_success': { value: 'plug_open_success', text: '两轮充充电成功页' },
            'car_open_success':  { value: 'car_open_success', text: '汽车充充电成功页' },
            'loading': { value: 'loading', text: '入口页' },
            'device_plug': { value: 'device_plug', text: '两轮充充电选择页' },
            'device_plug_port':   { value: 'device_plug_port',   text: '两轮充充电设备端口' },
            'device_plug_banner': { value: 'device_plug_banner', text: '两轮充充电设备BANNER' },
            'h5_pay_back': { value: 'h5_pay_back', text: 'H5支付后回调页面' },
        },
        // 广告渠道
        CANNEL_MAP: {
            '1': { value: 1, text: '微信小程序' },
            '2': { value: 2, text: '支付宝小程序' },
            '3': { value: 3, text: '微信H5' },
            '4': { value: 4, text: '支付宝H5' },
        },
        // 广告场景
        SCENE_LIST: [
            { value: 1,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '充电订单支付后-微信小程序' },
            { value: 2,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '充电订单支付后-支付宝小程序' },
            { value: 3,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '充电订单支付后-微信H5' },
            { value: 4,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '充电订单支付后-支付宝H5' },
            { value: 5,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: 'Banner广告-微信小程序' },
            { value: 6,  active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: 'Banner广告-支付宝小程序' },
            { value: 7,  active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: 'Banner广告-微信H5' },
            { value: 8,  active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: 'Banner广告-支付宝H5' },
            { value: 49, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: 'Banner广告-微信小程序-红包直塞' },
            { value: 32, active: true, rule:{ban_list:ADVERTISING_BAN.GT_INSUR},text:'自燃险-客户端' },   // 国泰自燃险-客户端
            { value: 33, active: false,rule:{ban_list:ADVERTISING_BAN.GT_INSUR},text:'国泰自燃险-客户端-支付宝小程序' },
            { value: 34, active: false,rule:{ban_list:ADVERTISING_BAN.GT_INSUR},text:'国泰自燃险-客户端-微信H5' },
            { value: 35, active: false,rule:{ban_list:ADVERTISING_BAN.GT_INSUR},text:'国泰自燃险-客户端-支付宝H5' },
            { value: 25, active: true ,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充电选择页-骑行险滚动引流条' }, // 临时隐藏
            { value: 28, active: true ,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充电选择页-骑行险引流按钮' }, // 临时隐藏
            { value: 26, active: true ,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充电选择页-骑行险10元优惠券' }, // 临时隐藏
            { value: 27, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充电选择页-支付宝1元优惠券' }, // 临时隐藏
            { value: 39, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充电选择页-支付宝贴片广告' }, // 临时隐藏
            { value: 36, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '国泰场地险-PC端' },
            { value: 37, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '国泰场地险-管家端-登录后' },
            { value: 38, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '国泰场地险-管家端-个人中心' },
            { value: 44, active: false,rule:{ban_list:ADVERTISING_BAN.LOADING},text: '扫码处理页-微信小程序' },
            { value: 45, active: false,rule:{ban_list:ADVERTISING_BAN.LOADING},text: '扫码处理页-支付宝小程序' },
            { value: 46, active: false,rule:{ban_list:ADVERTISING_BAN.LOADING},text: '扫码处理页-微信H5' },
            { value: 47, active: false,rule:{ban_list:ADVERTISING_BAN.LOADING},text: '扫码处理页-支付宝H5' },
            { value: 21, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '扫码处理页-口令广告-微信小程序' },
            { value: 22, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '扫码处理页-口令广告-支付宝小程序' },
            { value: 23, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '扫码处理页-口令广告-微信H5' },
            { value: 24, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '扫码处理页-口令广告-支付宝H5' },
            { value: 31, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '扫码处理页-支付宝首屏广告' },
            { value: 40, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '结束充电成功-微信小程序' },
            { value: 41, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '结束充电成功-支付宝小程序' },
            { value: 42, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '结束充电成功-微信H5' },
            { value: 43, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '结束充电成功-支付宝H5' },
            { value: 50, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备端口-微信小程序' },
            { value: 51, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备端口-支付宝小程序' },
            { value: 52, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备端口-微信H5' },
            { value: 53, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备端口-支付宝H5' },

            { value: 54, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备Banner-微信小程序' },
            { value: 55, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备Banner-支付宝小程序' },
            { value: 56, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备Banner-微信H5' },
            { value: 57, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '两轮充设备Banner-支付宝H5' },

            { value: 60, active: true, rule:{ban_list:ADVERTISING_BAN.FLOAT_REWARD}, text: '激励广告/浮窗-微信小程序' },
            { value: 61, active: true, rule:{ban_list:ADVERTISING_BAN.FLOAT_REWARD}, text: '激励广告/浮窗-支付宝小程序' },
            { value: 62, active: false,rule:{ban_list:ADVERTISING_BAN.FLOAT_REWARD}, text: '激励广告/浮窗-微信H5' },
            { value: 63, active: false,rule:{ban_list:ADVERTISING_BAN.FLOAT_REWARD}, text: '激励广告/浮窗-支付宝H5' },

            { value: 64, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '激励广告/按钮-微信小程序' },
            { value: 65, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '激励广告/按钮-支付宝小程序' },
            { value: 66, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '激励广告/按钮-微信H5' },
            { value: 67, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '激励广告/按钮-支付宝H5' },

            { value: 70, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '插屏广告-微信小程序' },
            { value: 71, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '插屏广告-支付宝小程序' },
            { value: 72, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '插屏广告-微信H5' },
            { value: 73, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '插屏广告-支付宝H5' },

            { value: 74, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '开屏广告-微信小程序' },
            { value: 75, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '开屏广告-支付宝小程序' },
            { value: 76, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '开屏广告-微信H5' },
            { value: 77, active: false,rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '开屏广告-支付宝H5' },

            { value: 80, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '引导广告-微信H5' },
            { value: 81, active: true, rule:{ban_list:ADVERTISING_BAN.COMMON}, text: '引导广告-支付宝H5' },
        ],
        // 广告行为
        TYPE_MAP: {
            '2': { key: 'show', value: 2, text: '呈现' },
            '1': { key: 'click', value: 1, text: '点击' },
            '3': { key: 'clipboard', value: 3, text: '调用剪切板' },

            '10': { key: 'mphs', value: 10, text: '半屏出现' },
            '11': { key: 'alipays', value: 11, text: '支付宝直链跳转' },

            // '12': { key: 'mphsm_hs', value: 12, text: '半屏出现-先半后竖' },
            // '13': { key: 'mphsm_in', value: 13, text: '竖屏出现-先半后竖' },

            '14': { key: 'open_app', value: 14, text: '打开其他小程序' },
            '15': { key: 'pay_insure', value: 15, text: '支付保险' },

            '16': { key: 'direct_card_success', value: 16, text: '支付宝红包直塞 - 成功发奖' },
            '17': { key: 'direct_card_show', value: 17, text: '支付宝红包直塞 - 发奖后展示' },
            '18': { key: 'direct_card_fail', value: 18, text: '支付宝红包直塞 - 发奖失败' },

            '20': { key: 'reward_show_succ', value: 20, text: '激励广告成功展示' },
            '21': { key: 'reward_show_fail', value: 21, text: '激励广告展示失败' },
            '22': { key: 'reward_click', value: 22, text: '激励广告点击"展示"' },
            '23': { key: 'reward_click_close', value: 23, text: '激励广告点击"关闭"' },
            '24': { key: 'reward_succ', value: 24, text: '激励广告成功发奖' },
            '25': { key: 'reward_fail', value: 25, text: '激励广告发奖失败' },
        },

        // 广告配置 - 预发/正式服创建后收到搬运过来
        AD_ID_MAP: {
            '3':  { value: 3,  order: 1, text: '充电订单支付后-微信小程序-冠宸·饿了么' },
            // '63': { value: 63, order: 1, text: '充电订单支付后-微信小程序-万聚源·美团' },
            '78': { value: 78, order: 1, text: '充电订单支付后-微信小程序-美团千载·外卖红包' },
            '79': { value: 79, order: 1, text: '充电订单支付后-微信小程序-美团千载·冰啤酒' },
            '80': { value: 80, order: 1, text: '充电订单支付后-微信小程序-饿了么联盟·消费日专享' },
            '81': { value: 81, order: 1, text: '充电订单支付后-微信小程序-饿了么联盟·天天领红包' },
            // '64': { value: 64, order: 1, text: '充电订单支付后-微信小程序-万聚源·美团·链接2' },
            // '44': { value: 44, order: 1, text: '充电订单支付后-微信小程序-首展-组件' },
            // '46': { value: 46, order: 1, text: '充电订单支付后-微信小程序-首展-先竖后半' },
            '35': { value: 35, order: 2, text: '充电订单支付后-支付宝小程序-灯火' },
            // '53': { value: 53, order: 2, text: '充电订单支付后-支付宝小程序-冠宸' },
            '84': { value: 84, order: 2, text: '充电订单支付后-支付宝小程序-饿了么' },
            '85': { value: 85, order: 2, text: '充电订单支付后-支付宝小程序-冠宸' },
            '86': { value: 86, order: 2, text: '充电订单支付后-支付宝小程序-飞猪' },
            '101': { value: 101, order: 2, text: '充电订单支付后-微信原生-插屏广告' },
            '105': { value: 105, order: 2, text: '充电订单支付后-微信原生-自定义“插屏”' },
            '104': { value: 104, order: 2, text: '充电订单支付后-支付宝小程序-冠辰·飞猪-有遮罩' },
            '106': { value: 106, order: 2, text: '充电订单支付后-支付宝小程序-冠辰·飞猪-无遮罩' },

            '47': { value: 47, order: 3, text: '充电订单支付后-微信H5-重构·阿飞证照' },
            '48': { value: 48, order: 3, text: '充电订单支付后-微信H5-渐染·奋力充电中' },
            '49': { value: 49, order: 3, text: '充电订单支付后-微信H5-渐染·工作辛苦啦' },
            '69': { value: 69, order: 3, text: '充电订单支付后-微信H5-无穷·公众号' },
            '82': { value: 82, order: 3, text: '充电订单支付后-微信H5-千惠街·公众号文章' },
            '103': { value: 103, order: 3, text: '充电订单支付后-微信H5-步点·公众号文章' },

            '36': { value: 36, order: 0, text: 'Banner广告-微信小程序' },
            '83': { value: 83, order: 0, text: 'Banner广告-微信小程序-红包直塞' },

            '28': { value: 28, order: 4, text: '两轮充电选择页-骑行险微信引流滚动条' },
            '29': { value: 29, order: 4, text: '两轮充电选择页-支付宝10元优惠券' },
            '30': { value: 30, order: 4, text: '两轮充电选择页-支付宝1元优惠券' },
            '31': { value: 31, order: 4, text: '两轮充电选择页-骑行险微信引流按钮' },


            '50': { value: 50, order: 6, text: '国泰场地险-PC端' },
            '51': { value: 51, order: 6, text: '国泰场地险-管家端-个人中心' },
            '52': { value: 52, order: 6, text: '国泰场地险-管家端-登录后' },

            '54': { value: 54, order: 8, text: '国泰自燃险-客户端-绿色主题' },
            // '56': { value: 56, order: 8, text: '国泰自燃险-客户端-支宝小程序-绿色主题' },
            // '59': { value: 59, order: 8, text: '国泰自燃险-客户端-支宝H5-绿色主题' },
            // '61': { value: 61, order: 8, text: '国泰自燃险-客户端-微信H5-绿色主题' },
            '71': { value: 71, order: 8, text: '国泰自燃险-客户端-绿色主题·计费弹窗' },
            // '72': { value: 72, order: 8, text: '国泰自燃险-客户端-新交互·范围内100%' },
            '74': { value: 74, order: 8, text: '国泰自燃险-客户端-新交互·中部弹出支付前确认' },
            '88': { value: 88, order: 8, text: '国泰自燃险-客户端-新交互·底部弹出支付前确认' },

            '96': { value: 96, order: 9, text: '两轮充设备端口-微信小程序-照梦·移动积分'} ,
            '97': { value: 97, order: 9, text: '两轮充设备端口-微信小程序-中智·移动积分'} ,

            '98': { value: 98, order: 9, text: '两轮充设备BANNER-微信小程序-中智·移动积分'} ,
            '99': { value: 99, order: 9, text: '两轮充设备BANNER-微信小程序-照梦·移动积分'} ,
        },

        // 广告配置 - 测试服创建后收到搬运过来
        AD_ID_MAP_DEV: {
        },


        // 规则目标 · 前端限制
        RULE_TYPE: {
            OPERATOR: 110,
            ORG: 120,
            STATION: 130,
            DEVICE: 140,
            USER: 210,
        },
        RULE_TYPE_LIST: [
            { value: 110, key: 'operator', value_key: 'operator_id', name_key: 'operator_name', text: '运营商' },
            { value: 120, key: 'org',      value_key: 'org_id',      name_key: 'org_name',      text: '片区' },
            { value: 130, key: 'station',  value_key: 'station_id',  name_key: 'station_name',  text: '站点' },
            { value: 140, key: 'device',   value_key: 'device_id',   name_key: 'device_suid',   text: '设备' },
            { value: 210, key: 'user',     value_key: 'user_id',     name_key: 'user_phone',    text: '用户' },
        ],
        RULE_OPTION_TREE: [
            {
            title: '屏蔽所有广告',
            key: 'flag_ban.all',
            children: [{
                title: "屏蔽充电订单支付后广告",
                key: 'flag_ban.open_success',
                children: [
                    { key: 'flag_ban.open_success.wx_app',  title: "屏蔽微信小程序" },
                    { key: 'flag_ban.open_success.ali_app', title: "屏蔽支付宝小程序" },
                    { key: 'flag_ban.open_success.wx_h5',   title: "屏蔽微信H5" },
                    { key: 'flag_ban.open_success.ali_h5',  title: "屏蔽支付宝" },
                ]
            },{
                // TODO
                title: "屏蔽所有Banner广告",
                key: 'flag_ban.banner',
                children: [
                    { key: 'flag_ban.banner.device', title: "屏蔽充电选择页Banner" },
                    { key: 'flag_ban.banner.order',  title: "屏蔽订单详情页Banner" },
                    { key: 'flag_ban.banner.home',   title: "屏蔽首页Banner" },
                    { key: 'flag_ban.banner.mine',   title: "屏蔽个人中心页Banner" },
                    { key: 'flag_ban.banner.other',  title: "屏蔽其他页面Banner" },
                ]
            },{
                title: "屏蔽两轮充充电选择页广告",
                key: 'flag_ban.plug',
                children: [
                    { key: 'flag_ban.plug.ali', title: "屏蔽支付宝系列广告", children: [
                        { key: 'flag_ban.plug.ali.guide_notice', title: "屏蔽骑行险微信引流滚动条" },
                        { key: 'flag_ban.plug.ali.guide_btn',    title: "屏蔽骑行险微信引流按钮" },
                        { key: 'flag_ban.plug.ali.qxx_ad', 	     title: "屏蔽支付宝骑行险广告" },
                        { key: 'flag_ban.plug.ali.pay_btn_ad',   title: "屏蔽支付宝1元优惠券广告" },
                    ]},
                    { key: 'flag_ban.plug.insur_gt', title: "屏蔽国泰自燃险系列广告", children: [
                        { key: 'flag_ban.plug.insur_gt.popup', title: "屏蔽自燃险每日弹窗" },
                        { key: 'flag_ban.plug.insur_gt.banner', title: "屏蔽自燃险Banner" },
                        { key: 'flag_ban.plug.insur_gt.confirm_before_pay', title: "屏蔽自燃险支付前询问" },
                    ]},
                ]
            }],
        }],
    },
    ADVERTISING_BAN,
    // 广告营销账户
    MARKETING_ACCOUNT: {
        ORDER_STATUS: {
            INIT: 100, // 待使用
            USED: 200, // 已使用
            REFUNDING: 350, // 退款中
            REFUNDED: 400, // 退款成功
            REFUNDED_AFTER_CLEARING: 500, // 结算后退款成功
            EXPIRE: -300, // 过期
        },
        ORDER_STATUS_MAP: {
            '100': { value: 100,  color: 'blue',   text: '待使用' },
            '200': { value: 200,  color: 'green',  text: '已使用' },
            '350': { value: 350,  color: 'orange', text: '退款中' },
            '400': { value: 400,  color: 'red',    text: '退款成功' },
            '500': { value: 500,  color: 'red',    text: '结算后退款成功' },
            '-300':{ value: -300, color: 'grey',   text: '已过期' },
        },
        SUBJECT: {
            ACCOUNT_RECHARGE: 300, // 支付宝广告账户充值
            ACCOUNT_DEDUCT: 310, // 支付宝广告账户扣减
            ORDER_REFUND: 320, // 支付宝广告订单退款
            ORDER_POWER: 330, // 支付宝广告订单充电使用
            ORDER_RESIDUE: 340, // 支付宝广告订单剩余未使用的
            ORDER_EXPIRE_REFUND: 350, // 支付宝广告订单过期退款
            ORDER_REFUND_AFTER_CLEARING: 360, // 支付宝广告订单结算后退款
        },
        SUBJECT_MAP: {
            '300': { value: 300, text: '后台充值' },
            '310': { value: 310, text: '后台扣减' },
            '320': { value: 320, text: '订单退款' },
            '330': { value: 330, text: '广告奖励发放' },
            '340': { value: 340, text: '订单剩余退款' },
            '350': { value: 350, text: '订单过期退款' },
            '360': { value: 360, text: '订单结算后退款' },
        }
    },
    // 保险订单 - 自燃险 - C端购买
    INSURANCE: {
        STATUS: {
            INIT: 0,                 // 未支付
            PAY_SUCCESS: 100,        // 支付成功
            PRE_ORDER_SUCCESS: 200,  // 预订单成功
            SUCCESS: 400,            // 出单成功
            POSTPAY_PENDING: 410,    // 待扣款
            POSTPAY_SUCCESS: 420,    // 扣款成功
            WAITING_REFUND: 450,     // 退款中
            REFUND_SUCCESS: 500,     // 退款成功
            REFUND_FAIL: -500,       // 退款失败
            FAIL: -200,              // 出单失败
            CANCEL: -100,            // 关闭预定单成功
            CANCEL_FAIL: -300,       // 关闭预定单失败
            PRE_ORDER_FAIL: -400,    // 预订单失败
            POSTPAY_FAIL: -420,    // 扣款失败

            SYNC_REFUND_SUCCESS: 501, // 出单成功后退款
            SYNC_WAITING_PORTION_REFUND: 451, // 出单后退款中
        },
        STATUS_MAP: {
            '400':  { sort: 10,  value: 400,  color: 'green',  text: '出单成功' },
            '410':  { sort: 10,  value: 410,  color: 'orange', text: '待扣款' },
            '420':  { sort: 10,  value: 420,  color: 'orange', text: '扣款成功' },
            '200':  { sort: 20,  value: 200,  color: 'blue',   text: '预订单成功' },
            '500':  { sort: 30,  value: 500,  color: 'gray',   text: '退款成功', hidden: true },
            '501':  { sort: 30,  value: 501,  color: 'gray',   text: '出单后退款成功', hidden: true },
            '-400': { sort: 40,  value: -400, color: 'red',    text: '预订单失败' },
            '-420': { sort: 40,  value: -420, color: 'orange', text: '扣款失败' },
            '-200': { sort: 50,  value: -200, color: 'red',    text: '出单失败' },
            '-500': { sort: 60,  value: -500, color: 'red',    text: '退款失败', hidden: true },
            '450':  { sort: 70,  value: 450,  color: 'orange', text: '退款中', hidden: true },
            '451':  { sort: 70,  value: 451,  color: 'orange', text: '出单后退款中', hidden: true },
            '-100': { sort: 80,  value: -100, color: 'red',    text: '关闭预定单成功' },
            '-300': { sort: 90,  value: -300, color: 'red',    text: '关闭预定单失败' },
            '100':  { sort: 100, value: 100,  color: 'orange', text: '支付成功' },
            '0':    { sort: 110, value: 0,    color: 'gray',   text: '未支付' },
        },
        STATUS_MARK: {
            CAN_REFUND: [-500, 450, 100], // 可否调用退款接口

            PRE: [100, 200], // 预备
            PRE_SUCCESS: [200], // 预备
            SUCCESS: [400],  // 出单成功
            CHARGE_FIRST_SUCCESS: [420], // 先充后付成功-扣款成功
            FAIL: [450, 500, -500, -100, -200, -300, -400, 501, 451], // 失败
            CHARGE_FIRST_REFUND: [501, 451], // 先充后付成功-退款

            PAY_SUCCESS: [100], // 支付成功

            // 退款中
            REFUNDING: [-400, -200, 450, 451, -100, -300],
            // 退款成功
            REFUND_SUCCESS: [500, 501],
            // 退款失败
            REFUND_FAILURE: [-500],
        },
        PAY_METHOD: {
            WECHART: 1,
            ALIPAY: 2,
            CHARGE_FIRST: 17,
        },
        PAY_METHOD_MAP: {
            '1': { value: 1, icon: 'i-WeChat', text: '微信' },
            '2': { value: 2, icon: 'i-Alipay', text: '支付宝' },
            '17': { value: 17, icon: 'i-charge_first', text: '先充后付' },
        },
        REFUND_STATUS: {
            PENDING_PRE_ISSUE: 100,  // 退保中（出单前）
            PENDING_POST_ISSUE: 110, // 退保中（出单后）
            SUCCESS_PRE_ISSUE: 200,  // 退保成功（出单前）
            SUCCESS_POST_ISSUE: 210, // 退保成功（出单后）
            FAILED_PRE_ISSUE: -200,  // 退保失败（出单前）
            FAILED_POST_ISSUE: -210, // 退保失败（出单后）
        },
        REFUND_STATUS_MAP: {
            '100': { value: 100, text: '退款中', order: 1 },
            '200':  { value: 200,  text: '退款成功', order: 1 },
            '-200': { value: -200, text: '退款失败', order: 1 },
            '110':  { value: 110,  text: '出单后退款中', order: -1 },
            '210':  { value: 210,  text: '出单后退款成功', order: -1 },
            '-210': { value: -210, text: '出单后退款失败', order: -1 },
        },
        REFUND_STATUS_MARK: {
            // 退款中
            REFUNDING: [100, 110],
            // 退款成功
            REFUND_SUCCESS: [200, 210],
            // 退款失败
            REFUND_FAILURE: [-200, -210],
        },

        // 出单源
        VERSION: {
            GUOTAI: 1,   // 国泰保单
            MAYI: 2,     // 蚂蚁保单
        },
        VERSION_MAP: {
            '': { value: '', text: '全部', order: 0 },
            '1': { value: 1, text: '国泰', order: 1 },  // 国泰保单
            '2': { value: 2, text: '蚂蚁', order: 1 },  // 蚂蚁保单
        },

        TYPE: {
            GUOTAI: 1,   // c端保险(国泰)
            VENUE: 2,     // b端保险 场地险
            MAYI: 3,     // c端保险(蚂蚁)增加类型 用于区分老版 国泰保单 和新版蚂蚁保单
        },
        TYPE_MAP: {
            '': { value: '', text: '全部', order: 0 },
            '1': { value: 1, text: '国泰', order: 1 },  // 国泰保单
            // '2': { value: 2, text: '场地险', order: 1 },  // 场地险
            '3': { value: 3, text: '蚂蚁', order: 1 },  // 蚂蚁保单
        },
    },
    // 保险订单 - 场地险 - B端购买
    VENUE_INSURANCE: {
        STATUS_MAP: {
            '200': { value: 200, color: 'blue',  text: '待生效' },
            '400': { value: 400, color: 'green', text: '已生效' },
            '-600':{ value:-600, color: 'red',   text: '已到期' },
            '500': { value: 500, color: 'gray',  text: '已退保' },
        },
    },

    // 错误日志
    ERROR_LOG: {
        TYPE: {
            // 注：以后定义新类型时，和后端确认下，防止定义重复
            // 前端定义
            GET_DEVICE_INFO_FAILED: 1,      // 获取设备信息失败
            ORDER_REFUND_ERROR: 2,          // 订单退款错误
            WECHAT_PUSH_FAILED: 3,          // 微信消息推送失败
            CUEB_CARD_ERROR: 4,             // 财经大学一卡通错误
            PYUN_PARKING_ERROR: 5,          // p云+停车对接错误
            APPID_GET_FAILED: 6,            // Appid获取失败
            CREATE_ORDER_FAILED: 7,         // 创建订单失败
            ORDER_PAY_FAILED: 8,            // 订单支付失败
            GET_PORT_INFO_FAILED: 9,  // 获取端口信息失败

            // 后端定义
            DEVICE_SERVICE_FEE_ERROR: 100,  // 设备服务费结算异常
        },
        TYPE_MAP: {
            '1': { value: 1, text: '获取设备信息失败', order: 1 },
            '2': { value: 2, text: '订单退款错误', order: 2 },
            '3': { value: 3, text: '微信消息推送失败', order: 2 },
            '4': { value: 4, text: '财经大学一卡通错误', order: 2 },
            '5': { value: 5, text: 'p云+停车对接错误', order: 2 },
            '6': { value: 6, text: 'Appid获取失败', order: 2 },
            '7': { value: 7, text: '创建订单失败', order: 2 },
            '8': { value: 8, text: '订单支付失败', order: 2 },
            '9': { value: 9, text: '获取端口信息失败', order: 1 },
            
            // 后端定义
            '100': { value: 100, text: '设备服务费结算异常', order: 2 },
        }
    }
};

export default Const;
